import Vue from 'vue';
import router from '@/router';
import VueResource from 'vue-resource';
import {productSalesProducts} from "./getters";
import {store} from "../../index";

Vue.use(VueResource);

export const fncPopulateDashboard = ({ commit, dispatch, state, rootState }, payload) => {
  if(payload.hasOwnProperty('tabs')) {
    commit('setTotalPending', true)
  }
  var ignoreFilters = false;
  var page_start = 0;
  if( payload.page_start ) { page_start = payload.page_start; }
  var page_end = 49;
  if( payload.page_end ) { page_end = payload.page_end; }

  if( payload.ignoreFilters != undefined && payload.ignoreFilters != null ) { ignoreFilters = payload.ignoreFilters; }

  var objAuth = JSON.parse(rootState.objAuthorize);

  var viewAllDepartments = false;
  if( objAuth.privileges.indexOf('DEPARTMENT_VIEW_ALL_QUOTES') != -1 ) { viewAllDepartments = true; }

  // if (state.quoteList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
  var currency_data = [];
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);

    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(pricelists => {

      if (payload != undefined && (payload.refresh != undefined || payload.reload != undefined)) {
        if (payload.date_from != 'null' && payload.date_from != null) {
          var startDate = new Date(payload.date_from + ' GMT').toISOString().slice(0, 10);
          var objStartDate = startDate.split("-");
          startDate = objStartDate[0] + '-' + objStartDate[1] + '-' + objStartDate[2];
        } else {
          startDate = 'null';
        }
        if (payload.date_to != 'null' && payload.date_to != null) {
          let da = new Date(payload.date_to)
          var endDate = new Date(da + ' GMT').toISOString().slice(0, 10);
          var objEndDate = endDate.split("-");
          endDate = objEndDate[0] + '-' + objEndDate[1] + '-' + objEndDate[2];
        } else {
          endDate = 'null';
        }

        var quote_age = '';
        if( payload.start_date ) {
          quote_age = payload.start_date;
          if( quote_age.length > 10 || quote_age.length == undefined ) {
            var startDate = new Date(quote_age);
            startDate.setDate(startDate.getDate() + 1);
            quote_age = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);
          }
          if (! payload.hasOwnProperty('call'))
            localStorage.setItem('quote_start_date', quote_age);
        } else {
          localStorage.setItem('quote_start_date', '1900-01-01');
        }
        var quote_age_end = '';
        if( payload.end_date ) {
          quote_age_end = payload.end_date;
          if( quote_age_end.length > 10 || quote_age_end.length == undefined ) {
            var endDate = new Date(quote_age_end);
            endDate.setDate(endDate.getDate() + 1);
            quote_age_end = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);
          }
          if (! payload.hasOwnProperty('call'))
              localStorage.setItem('quote_end_date', quote_age_end);
        }

        // added for dashboard speed
        if( payload.start_date && payload.start_date != '' && payload.end_date && payload.end_date != '' ) {
          var newPush = [];

          // localStorage.removeItem('reportSearch');
          localStorage.removeItem('reportDates');

          newPush.push('date');
          localStorage.setItem('searchOrder', JSON.stringify(newPush));
        }

        var reportDates = []
        reportDates.push(quote_age);
        reportDates.push(quote_age_end);

        localStorage.setItem('reportDates', reportDates.toString());

        if( ( payload.filter_only != null || payload.filter_only != undefined ) && !payload.hasOwnProperty('tabs')) {
          var quote_details = {
            a: 'getAllFilters',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end
            }
          };
        }
        else if(payload.hasOwnProperty('tabs')){
          var quote_details = {
            a: 'get_quote_status_count',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end,
              tabs: payload.tabs
            }
          };
        }
        else {
          var quote_details = {
            a: 'getAllNew',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end
            }
          };
        }

        if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
          quote_details.filter_params.originator = payload.originator;
        }
        if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
          quote_details.filter_params.filterStatus = payload.status;
        }
        if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
          quote_details.filter_params.customer = payload.customer;
        }
        if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
          quote_details.filter_params.vendor = payload.vendor;
        }
        if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
          quote_details.filter_params.store = payload.store;
        }
        if( ( payload.department != null || payload.department != undefined ) && payload.department[0] != 'all' ) {
          quote_details.filter_params.department = payload.department;
        }
        if( ( payload.filter_only != null || payload.filter_only != undefined ) ) {
          quote_details.filter_params.filter_only = true;
        }
        if( ( payload.search != null || payload.search != undefined ) ) {
          quote_details.filter_params.keywords = payload.search;
        }
        if( ( payload.quoteRegion != null || payload.quoteRegion != undefined ) && payload.quoteRegion[0] != 'all' ) {
          quote_details.filter_params.quoteRegion = payload.quoteRegion;
        }
        if( ( payload.quoteRep != null || payload.quoteRep != undefined ) && payload.quoteRep[0] != 'all' ) {
          quote_details.filter_params.quoteRep = payload.quoteRep;
        }
        if( viewAllDepartments == true ) {
          quote_details.filter_params.viewAllDepartments = true;
        }
        if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
          quote_details.filter_params.commercial_kam = payload.commercial_kam;
        }
        if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
          quote_details.filter_params.commercial_originator = payload.commercial_originator;
        }
        if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
          quote_details.filter_params.quote_type = payload.quote_type;
        }
        if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
          quote_details.filter_params.service_type = payload.service_type;
        }
        if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
          quote_details.filter_params.projects = payload.projects;
        }
        if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
          quote_details.filter_params.company = payload.company;
        }
      } else {
        var quote_age = '';
        if( payload.start_date ) {
          quote_age = payload.start_date;
          if (!payload.hasOwnProperty('call'))
            localStorage.setItem('quote_start_date', payload.start_date);
        }
        var quote_age_end = '';
        if( payload.end_date ) {
          quote_age_end = payload.end_date;
          if (!payload.hasOwnProperty('call'))
            localStorage.setItem('quote_end_date', payload.end_date);
        }
        if( ( payload.filter_only != null || payload.filter_only != undefined ) ) {
          var quote_details = {
            a: 'getAllFilters',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end
            }
          };
        }
        else {
          var quote_details = {
            a: 'getAllNew',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end
            }
          };
        }

        if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
          quote_details.filter_params.originator = payload.originator;
        }
        if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
          quote_details.filter_params.filterStatus = payload.status;
        }
        if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
          quote_details.filter_params.customer = payload.customer;
        }
        if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
          quote_details.filter_params.vendor = payload.vendor;
        }
        if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
          quote_details.filter_params.store = payload.store;
        }
        if( ( payload.filter_only != null || payload.filter_only != undefined ) ) {
          quote_details.filter_params.filter_only = true;
        }
        if( ( payload.search != null || payload.search != undefined ) ) {
          quote_details.filter_params.keywords = payload.search;
        }
        if( viewAllDepartments == true ) {
          quote_details.filter_params.viewAllDepartments = true;
        }
        if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
          quote_details.filter_params.commercial_kam = payload.commercial_kam;
        }
        if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
          quote_details.filter_params.commercial_originator = payload.commercial_originator;
        }
        if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
          quote_details.filter_params.quote_type = payload.quote_type;
        }
        if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
          quote_details.filter_params.service_type = payload.service_type;
        }
        if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
          quote_details.filter_params.projects = payload.projects;
        }
        if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
          quote_details.filter_params.company = payload.company;
        }
      }
      if(payload.hasOwnProperty('tabs')){
        delete quote_details.filter_params.keywords;
      }

      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(data => {

          if (payload.hasOwnProperty('tabs')){
            let arr = []
            for (const [key, value] of Object.entries(payload.tabs)) {
              if (payload.tabs[key].length === 0){
                let test = { [key]: {
                  total: 0.00,total_count: 0}}
                arr.push(test)
              }
            }
            commit('setTopTabsCount', data)
            commit('setTotalPending', false)
          }
          else{
            commit('fncSetQuoteReportLoaded', true);

            for (var d in data) {
              data[d].staticStatus = data[d].status;
            }
            commit({
              type: 'setDashboardData',
              dashData: data
            });

            setTimeout(function(){
              commit('fncFilterNeedsReload', false);
            }, 1)
          }

      });

    });
  });
  // }
};

export const fncGetStatusCounts = ({ commit, dispatch, state, rootState }, payload) => {
  var quote_details = {
    currency_data: currency_data,
    filter_params: {
      manufacturer: objAuth.manufacturer,
      user: objAuth.id,
      date_from: quote_age,
      date_to: quote_age_end
    }
  };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    commit('fncSetQuoteReportLoaded', true);

    for (var d in data) {
      data[d].staticStatus = data[d].status;
    }
    commit({
      type: 'setDashboardData',
      dashData: data
    });

    setTimeout(function(){
      commit('fncFilterNeedsReload', false);
    }, 1)

  });
}

function getTabKey() {
  let key
  if (localStorage.getItem('topTab') !== null) {
    let topTab = parseInt(localStorage.getItem('topTab'))
    switch (topTab) {
      case 0 :
        key = 'is_initial_engagement_quote'
        break
      case 1 :
        key = 'is_negotiating_customer_approval'
        break
      case 2 :
        key = 'is_manufacturer_fulfilment'
        break
      case 3 :
        key = 'is_cancelled_expired_rejected'
        break
      default:
        key = 'is_initial_engagement_quote'
    }
  }
  else {
    key = 'is_initial_engagement_quote'
  }
  return key
}

export const fncRetrieveFilters = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  if (payload.date_from != 'null' && payload.date_from != null) {
      var startDate = new Date(payload.date_from + ' GMT').toISOString().slice(0, 10);
      var objStartDate = startDate.split("-");
      startDate = objStartDate[0] + '-' + objStartDate[1] + '-' + objStartDate[2];
    } else {
      startDate = 'null';
    }
    if (payload.date_to != 'null' && payload.date_to != null) {
      let da = new Date(payload.date_to)
      var endDate = new Date(da + ' GMT').toISOString().slice(0, 10);
      var objEndDate = endDate.split("-");
      endDate = objEndDate[0] + '-' + objEndDate[1] + '-' + objEndDate[2];
    } else {
      endDate = 'null';
    }
    var quote_age = '';
    if( payload.start_date ) {
      quote_age = payload.start_date;
      if( quote_age.length > 10 || quote_age.length == undefined ) {
        var startDate = new Date(quote_age);
        startDate.setDate(startDate.getDate() + 1);
        quote_age = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);
      }
      if (! payload.hasOwnProperty('call'))
        localStorage.setItem('quote_start_date', quote_age);
    } else {
      localStorage.setItem('quote_start_date', '1900-01-01');
    }
    var quote_age_end = '';
    if( payload.end_date ) {
      quote_age_end = payload.end_date;
      if( quote_age_end.length > 10 || quote_age_end.length == undefined ) {
        var endDate = new Date(quote_age_end);
        endDate.setDate(endDate.getDate() + 1);
        quote_age_end = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);
      }
      if (! payload.hasOwnProperty('call'))
        localStorage.setItem('quote_end_date', quote_age_end);
    }

    // added for dashboard speed
    if( payload.start_date && payload.start_date != '' && payload.end_date && payload.end_date != '' ) {
      var newPush = [];

      // localStorage.removeItem('reportSearch');
      localStorage.removeItem('reportDates');

      newPush.push('date');
      localStorage.setItem('searchOrder', JSON.stringify(newPush));
    }

    var reportDates = []
    reportDates.push(quote_age);
    reportDates.push(quote_age_end);

    localStorage.setItem('reportDates', reportDates.toString());


      var quote_details = {
        a: 'getAllFilters',
        currency_data: [],
        filter_params: {
          manufacturer: objAuth.manufacturer,
          user: objAuth.id,
          date_from: quote_age,
          date_to: quote_age_end
        }
      };

    if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
      quote_details.filter_params.originator = payload.originator;
    }
    if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
      quote_details.filter_params.filterStatus = payload.status;
    }
    if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
      quote_details.filter_params.customer = payload.customer;
    }
    if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
      quote_details.filter_params.vendor = payload.vendor;
    }
    if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
      quote_details.filter_params.store = payload.store;
    }
    if( ( payload.department != null || payload.department != undefined ) && payload.department[0] != 'all' ) {
      quote_details.filter_params.department = payload.department;
    }
    if( ( payload.filter_only != null || payload.filter_only != undefined ) ) {
      quote_details.filter_params.filter_only = true;
    }
    if( ( payload.search != null || payload.search != undefined ) ) {
      quote_details.filter_params.keywords = payload.search;
    }
    if( ( payload.quoteRegion != null || payload.quoteRegion != undefined ) && payload.quoteRegion[0] != 'all' ) {
      quote_details.filter_params.quoteRegion = payload.quoteRegion;
    }
    if( ( payload.quoteRep != null || payload.quoteRep != undefined ) && payload.quoteRep[0] != 'all' ) {
      quote_details.filter_params.quoteRep = payload.quoteRep;
    }
    /*if( viewAllDepartments == true ) {
      quote_details.filter_params.viewAllDepartments = true;
    }*/
    if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
      quote_details.filter_params.commercial_kam = payload.commercial_kam;
    }
    if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
      quote_details.filter_params.commercial_originator = payload.commercial_originator;
    }
    if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
      quote_details.filter_params.quote_type = payload.quote_type;
    }
    if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
      quote_details.filter_params.service_type = payload.service_type;
    }
    if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
      quote_details.filter_params.projects = payload.projects;
    }
    if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
      quote_details.filter_params.company = payload.company;
    }


  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    commit('fncSetQuoteReportLoaded', true);

    for (var d in data) {
      data[d].staticStatus = data[d].status;
    }
    commit({
      type: 'setDashboardData',
      dashData: data
    });

    setTimeout(function(){
      commit('fncFilterNeedsReload', false);
    }, 1)

  });

};

export const fncPopulateDashboardCopy = ({ commit, dispatch, state, rootState }, payload) => {

  var ignoreFilters = false;
  var page_start = 0;
  if( payload.page_start ) { page_start = payload.page_start; }
  var page_end = 49;
  if( payload.page_end ) { page_end = payload.page_end; }

  if( payload.ignoreFilters != undefined && payload.ignoreFilters != null ) { ignoreFilters = payload.ignoreFilters; }

  var objAuth = JSON.parse(rootState.objAuthorize);

  var viewAllDepartments = false;
  if( objAuth.privileges.indexOf('DEPARTMENT_VIEW_ALL_QUOTES') != -1 ) { viewAllDepartments = true; }

  // if (state.quoteList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
  var currency_data = [];
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);

    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(pricelists => {

      if (payload != undefined && (payload.refresh != undefined || payload.reload != undefined)) {
        if (!payload.hasOwnProperty('report_type')){
          if (payload.date_from != 'null' && payload.date_from != null) {
            var startDate = new Date(payload.date_from + ' GMT').toISOString().slice(0, 10);
            var objStartDate = startDate.split("-");
            startDate = objStartDate[0] + '-' + objStartDate[1] + '-' + objStartDate[2];
          } else {
            startDate = 'null';
          }
          if (payload.date_to != 'null' && payload.date_to != null) {
            let da = new Date(payload.date_to)
            var endDate = new Date(da + ' GMT').toISOString().slice(0, 10);
            var objEndDate = endDate.split("-");
            endDate = objEndDate[0] + '-' + objEndDate[1] + '-' + objEndDate[2];
          } else {
            endDate = 'null';
          }

          var quote_age = '';
          if( payload.start_date ) {
            quote_age = payload.start_date;
            if( quote_age.length > 10 || quote_age.length == undefined ) {
              var startDate = new Date(quote_age);
              startDate.setDate(startDate.getDate() );
              quote_age = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);
            }
            if (! payload.hasOwnProperty('call'))
              localStorage.setItem('quote_start_date', quote_age);
          } else {
            localStorage.setItem('quote_start_date', '1900-01-01');
          }
          var quote_age_end = '';
          if( payload.end_date ) {
            quote_age_end = payload.end_date;
            if( quote_age_end.length > 10 || quote_age_end.length == undefined ) {
              var endDate = new Date(quote_age_end);
              endDate.setDate(endDate.getDate() );
              quote_age_end = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);
            }
            if (! payload.hasOwnProperty('call'))
                localStorage.setItem('quote_end_date', quote_age_end);
          }
        }
        else{
          var quote_age = payload.start_date;
          var quote_age_end = payload.end_date;

          var endDate = payload.start_date;
          var startDate = payload.end_date
        }

        // added for dashboard speed
        if( payload.start_date && payload.start_date != '' && payload.end_date && payload.end_date != '' ) {
          var newPush = [];

          // localStorage.removeItem('reportSearch');
          localStorage.removeItem('reportDates');

          newPush.push('date');
          localStorage.setItem('searchOrder', JSON.stringify(newPush));
        }

        var reportDates = []
        reportDates.push(quote_age);
        reportDates.push(quote_age_end);

        localStorage.setItem('reportDates', reportDates.toString());

     if( ( payload.filter_only != null || payload.filter_only != undefined ) ) {
          var quote_details = {
            a: 'getAllFiltersCopy',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end,
              report_type: payload.report_type ? 'conversion' : 'origination',
            }
          };
        } else {
          var quote_details = {
            a: 'getAllNew',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end
            }
          };
        }

        if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
          quote_details.filter_params.originator = payload.originator;
        }
        if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
          quote_details.filter_params.filterStatus = payload.status;
        }
        if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
          quote_details.filter_params.customer = payload.customer;
        }
        if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
          quote_details.filter_params.vendor = payload.vendor;
        }
        if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
          quote_details.filter_params.store = payload.store;
        }
        if( ( payload.department != null || payload.department != undefined ) && payload.department[0] != 'all' ) {
          quote_details.filter_params.department = payload.department;
        }
        if( ( payload.filter_only != null || payload.filter_only != undefined ) ) {
          quote_details.filter_params.filter_only = true;
        }
        if( ( payload.search != null || payload.search != undefined ) ) {
          quote_details.filter_params.keywords = payload.search;
        }
        if( ( payload.quoteRegion != null || payload.quoteRegion != undefined ) && payload.quoteRegion[0] != 'all' ) {
          quote_details.filter_params.quoteRegion = payload.quoteRegion;
        }
        if( ( payload.quoteRep != null || payload.quoteRep != undefined ) && payload.quoteRep[0] != 'all' ) {
          quote_details.filter_params.quoteRep = payload.quoteRep;
        }
        if( viewAllDepartments == true ) {
          quote_details.filter_params.viewAllDepartments = true;
        }
        if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
          quote_details.filter_params.commercial_kam = payload.commercial_kam;
        }
        if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
          quote_details.filter_params.commercial_originator = payload.commercial_originator;
        }
        if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
          quote_details.filter_params.quote_type = payload.quote_type;
        }
        if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
          quote_details.filter_params.service_type = payload.service_type;
        }
        if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
          quote_details.filter_params.projects = payload.projects;
        }
        if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
          quote_details.filter_params.company = payload.company;
        }
        if( ( payload.role != null || payload.role != undefined ) && payload.role[0] != 'all' ) {
          quote_details.filter_params.role = payload.role;
        }
      } else {
        var quote_age = '';
        if( payload.start_date ) {
          quote_age = payload.start_date;
          if (!payload.hasOwnProperty('call'))
            localStorage.setItem('quote_start_date', payload.start_date);
        }
        var quote_age_end = '';
        if( payload.end_date ) {
          quote_age_end = payload.end_date;
          if (!payload.hasOwnProperty('call'))
            localStorage.setItem('quote_end_date', payload.end_date);
        }
        if( ( payload.filter_only != null || payload.filter_only != undefined ) ) {
          var quote_details = {
            a: 'getAllFiltersCopy',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end,
            }
          };
        } else {
          var quote_details = {
            a: 'getAllNew',
            currency_data: currency_data,
            filter_params: {
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              date_from: quote_age,
              date_to: quote_age_end
            }
          };
        }

        if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
          quote_details.filter_params.originator = payload.originator;
        }
        if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
          quote_details.filter_params.filterStatus = payload.status;
        }
        if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
          quote_details.filter_params.customer = payload.customer;
        }
        if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
          quote_details.filter_params.vendor = payload.vendor;
        }
        if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
          quote_details.filter_params.store = payload.store;
        }
        if( ( payload.filter_only != null || payload.filter_only != undefined ) ) {
          quote_details.filter_params.filter_only = true;
        }
        if( ( payload.search != null || payload.search != undefined ) ) {
          quote_details.filter_params.keywords = payload.search;
        }
        if( viewAllDepartments == true ) {
          quote_details.filter_params.viewAllDepartments = true;
        }
        if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
          quote_details.filter_params.commercial_kam = payload.commercial_kam;
        }
        if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
          quote_details.filter_params.commercial_originator = payload.commercial_originator;
        }
        if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
          quote_details.filter_params.quote_type = payload.quote_type;
        }
        if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
          quote_details.filter_params.service_type = payload.service_type;
        }
        if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
          quote_details.filter_params.projects = payload.projects;
        }
        if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
          quote_details.filter_params.company = payload.company;
        }
        if( ( payload.role != null || payload.role != undefined ) && payload.role[0] != 'all' ) {
          quote_details.filter_params.role = payload.role;
        }
      }
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(data => {


        for (var d in data) {
          data[d].staticStatus = data[d].status;
        }

        commit({
          type: 'setDashboardData',
          dashData: data
        });
        commit('fncSummaryFilterLoad', false);
        // setTimeout(() => {
        //   commit('fncSummaryFilterLoad', false);
        // }, 1000)

      });

    });
  });
  // }
};

export const fncPopulateQuoteListCopy = ({ commit, dispatch, state, rootState }, payload) => {

  var ignoreFilters = false;
  var page_start = 0;
  if( payload.page_start ) { page_start = payload.page_start; }
  var page_end = 49;
  if( payload.page_end ) { page_end = payload.page_end; }

  if( payload.ignoreFilters != undefined && payload.ignoreFilters != null ) { ignoreFilters = payload.ignoreFilters; }

  var objAuth = JSON.parse(rootState.objAuthorize);

  var viewAllDepartments = false;
  if( objAuth.privileges.indexOf('DEPARTMENT_VIEW_ALL_QUOTES') != -1 ) { viewAllDepartments = true; }

  if (state.quoteList != undefined && state.quoteList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
    //state.quotesLoaded = false;
    var currency_data = [];
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);

      }).then(data => {
      var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer };
      Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured', display: true };
          commit('setSnack', snackDetails);
          console.log(error);
        }).then(pricelists => {

        for (var p in pricelists) {
          var cur_data = { id: pricelists[p].pl_id, default: pricelists[p].pl_is_default, currency_sym: pricelists[p].pl_currency_sym, tax_label: pricelists[p].pl_tax_label, tax_percentage: pricelists[p].pl_tax_percentage, currency_code: pricelists[p].pl_currency_code };
          currency_data.push(cur_data);
        }

        var objAuth = JSON.parse(rootState.objAuthorize);
        var columnDetails = { id: objAuth.id };
        Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Report.php?a=get_report_settings', { params: columnDetails }, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            var snackDetails = { color: 'error', message: 'An error has occured retrieving the Quote list', display: true };
            commit('setSnack', snackDetails);
            console.log(error);
          }).then(data => {
          var objSettings = JSON.parse(data.report_settings);
          //commit('setObjQuoteSettings', objSettings);
          // commit({
          //   type: 'setObjQuoteSettings',
          //   columns: objSettings,
          //   manu: objAuth.manufacturer
          // });
          if (payload != undefined && (payload.refresh != undefined || payload.reload != undefined)) {
            if (payload.date_from != 'null' && payload.date_from != null) {
              let da = new Date(payload.date_from)
              var startDate = new Date(da + ' GMT').toISOString().slice(0, 10);
              var objStartDate = startDate.split("-");
              startDate = objStartDate[0] + '-' + objStartDate[1] + '-' + objStartDate[2];
            } else {
              startDate = 'null';
            }
            if (payload.date_to != 'null' && payload.date_to != null) {
              let da = new Date(payload.date_to)
              var endDate = new Date(da + ' GMT').toISOString().slice(0, 10);
              var objEndDate = endDate.split("-");
              endDate = objEndDate[0] + '-' + objEndDate[1] + '-' + objEndDate[2];
            } else {
              endDate = 'null';
            }

            var quote_age = '';
            if( payload.start_date ) {
              quote_age = payload.start_date;
              // localStorage.setItem('quote_start_date', payload.start_date);
            } else {
              quote_age = '1900-01-01';
              // localStorage.setItem('quote_start_date', '1900-01-01');
            }

            var quote_age_end = '';
            if( payload.end_date ) {
              quote_age_end = payload.end_date;
              // localStorage.setItem('quote_end_date', payload.end_date);
            } else {
              var today = new Date();
              var dd = String(today.getDate()).padStart(2, '0');
              var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
              var yyyy = today.getFullYear();

              var end_date = yyyy + '-' + mm + '-' + dd;
              quote_age_end = end_date;
              // localStorage.setItem('quote_end_date', payload.end_date);
            }

            // added for dashboard speed
            if( payload.start_date && payload.start_date != '' && payload.end_date && payload.end_date != '' ) {
              var newPush = [];

              localStorage.removeItem('reportSearch');
              localStorage.removeItem('reportDates');

              newPush.push('date');
              // localStorage.setItem('searchOrder', JSON.stringify(newPush));

              /*localStorage.removeItem('reportOriginators');
              localStorage.removeItem('reportProject');
              localStorage.removeItem('reportUsers');
              localStorage.removeItem('reportCompanies');
              localStorage.removeItem('reportSpecifiers');*/

            }

            /*if( start_date = '' ) {
              start_date = '1900-01-01';
            }
            if( end_date = '' ) {
              var today = new Date();
              var dd = String(today.getDate()).padStart(2, '0');
              var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
              var yyyy = today.getFullYear();

              end_date = yyyy + '-' + mm + '-' + dd;
            }*/

            var reportDates = []
            reportDates.push(quote_age);
            reportDates.push(quote_age_end);

            localStorage.setItem('reportDates', reportDates.toString());
            if( payload.hasOwnProperty('call_type') ) {
              var quote_details = {
                a: 'generateSummaryReport',
                currency_data: currency_data,
                filter_params: {
                  manufacturer: objAuth.manufacturer,
                  user: objAuth.id,
                  date_from: quote_age,
                  date_to: quote_age_end,
                  call: payload.call_type,
                  report_type: payload.report_type,
                  category: payload.category,
                  report_measurement: payload.report_measurement,
                  report_increment: payload.report_increment,
                  show_zero: payload.show_zero,
                }
              };
              if( payload.call_type === 'originator' ) {
                quote_details.filter_params.originator_copy = JSON.stringify(payload.originator_copy);
              }
              if( payload.call_type === 'role' ) {
                quote_details.filter_params.rep_copy = JSON.stringify(payload.rep_copy);
              }
              if( payload.call_type === 'role' ) {
                quote_details.filter_params.role_copy = payload.role_copy;
                quote_details.filter_params.department_copy = payload.department_copy;
              }
              if( payload.call_type === 'store' ) {
                quote_details.filter_params.store_copy = payload.store_copy;
                quote_details.filter_params.quoteRegion_copy = payload.quoteRegionCopy;
                quote_details.filter_params.department_copy = payload.department_copy;
              }
              if( payload.call_type === 'vendor' ) {
                quote_details.filter_params.vendor_copy = payload.vendor_copy;
              }
              if( payload.call_type === 'department' ) {
                quote_details.filter_params.department_copy = payload.department_copy;
              }

            }
            else {
              var quote_details = {
                a: 'getAll',
                currency_data: currency_data,
                filter_params: {
                  manufacturer: objAuth.manufacturer,
                  user: objAuth.id,
                  date_from: quote_age,
                  date_to: quote_age_end,
                  page_start: page_start,
                  page_end: page_end
                  //originator: payload.originator != null || payload.originator != undefined ? payload.originator : '*'
                  /*filterStatus: payload.status,
                  customer: payload.customer,
                  vendor: payload.vendor,
                  store: payload.store*/
                }
              };
            }

            if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
              quote_details.filter_params.originator = payload.originator;
            }
            if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
              quote_details.filter_params.filterStatus = payload.status;
            }
            if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
              quote_details.filter_params.customer = payload.customer;
            }
            if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
              quote_details.filter_params.vendor = payload.vendor;
            }
            if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
              quote_details.filter_params.store = payload.store;
            }
            if( ( payload.search != null || payload.search != undefined )  ) {
              quote_details.filter_params.keywords = payload.search;
            }
            if( ( payload.department != null || payload.department != undefined ) && payload.department[0] != 'all' ) {
              quote_details.filter_params.department = payload.department;
            }
            if( ( payload.quoteRegion != null || payload.quoteRegion != undefined ) && payload.quoteRegion[0] != 'all' ) {
              quote_details.filter_params.quoteRegion = payload.quoteRegion;
            }
            if( viewAllDepartments == true ) {
              quote_details.filter_params.viewAllDepartments = true;
            }
            if( ( payload.quoteRep != null || payload.quoteRep != undefined ) && payload.quoteRep[0] != 'all' ) {
              quote_details.filter_params.quoteRep = payload.quoteRep;
            }
            if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
              quote_details.filter_params.commercial_kam = payload.commercial_kam;
            }
            if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
              quote_details.filter_params.commercial_originator = payload.commercial_originator;
            }
            if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
              quote_details.filter_params.quote_type = payload.quote_type;
            }
            if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
              quote_details.filter_params.service_type = payload.service_type;
            }
            if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
              quote_details.filter_params.projects = payload.projects;
            }
            if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
              quote_details.filter_params.company = payload.company;
            }
            if( payload.linked != null && payload.linked != undefined && payload.linked != '' ) {
              quote_details.filter_params.linked = payload.linked;
            }
            if( payload.role != null && payload.role != undefined && payload.role != 'all' ) {
              quote_details.filter_params.role = payload.role;
            }
            if( payload.rep != null && payload.rep != undefined && payload.rep != 'all' ) {
              quote_details.filter_params.rep = payload.rep;
            }
            if( payload.call_type === 'role' ) {
              quote_details.filter_params.rep_copy = JSON.stringify(payload.rep_copy);
            }

          } else {
            var quote_age = '';
            if( payload.start_date ) {
              quote_age = payload.start_date;
              // localStorage.setItem('quote_start_date', payload.start_date);
            }
            var quote_age_end = '';
            if( payload.end_date ) {
              quote_age_end = payload.end_date;
              // localStorage.setItem('quote_end_date', payload.end_date);
            }
            if( payload.hasOwnProperty('call_type') ) {
              var quote_details = {
                a: 'generateSummaryReport',
                currency_data: currency_data,
                filter_params: {
                  manufacturer: objAuth.manufacturer,
                  user: objAuth.id,
                  date_from: quote_age,
                  date_to: quote_age_end,
                  call: payload.call_type,
                  role: payload.role,
                  report_type: payload.report_type,
                  category: payload.category,
                  report_measurement: payload.report_measurement,
                  report_increment: payload.report_increment,
                  show_zero: payload.show_zero,
                }
              };
              if( payload.call_type === 'originator'  ) {
                quote_details.filter_params.originator_copy = JSON.stringify(payload.originator_copy) ;
              }
              if( payload.call_type === 'role' ) {
                quote_details.filter_params.role_copy = payload.role_copy;
              }
              if( payload.call_type === 'store' ) {
                quote_details.filter_params.store_copy = payload.store_copy;
                quote_details.filter_params.quoteRegion_copy = payload.quoteRegionCopy;
              }
              if( payload.call_type === 'vendor' ) {
                quote_details.filter_params.vendor_copy = payload.vendor_copy;
              }
              if( payload.call_type === 'department' ) {
                quote_details.filter_params.department_copy = payload.department_copy;
              }
            }
            else {
              var quote_details = {
                a: 'getAll',
                currency_data: currency_data,
                filter_params: {
                  manufacturer: objAuth.manufacturer,
                  user: objAuth.id,
                  date_from: quote_age,
                  date_to: quote_age_end,
                  page_start: page_start,
                  page_end: page_end,
                  //originator: ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ? payload.originator : '*'
                  /*filterStatus: payload.status,
                  customer: payload.customer,
                  vendor: payload.vendor,
                  store: payload.store*/
                }
              };
            }

            if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
              quote_details.filter_params.originator = payload.originator;
            }
            if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
              quote_details.filter_params.filterStatus = payload.status;
            }
            if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
              quote_details.filter_params.customer = payload.customer;
            }
            if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
              quote_details.filter_params.vendor = payload.vendor;
            }
            if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
              quote_details.filter_params.store = payload.store;
            }
            if( ( payload.department != null || payload.department != undefined ) && payload.department[0] != 'all' ) {
              quote_details.filter_params.department = payload.department;
            }
            if( ( payload.search != null || payload.search != undefined )  ) {
              quote_details.filter_params.keywords = payload.search;
            }
            if( viewAllDepartments == true ) {
              quote_details.filter_params.viewAllDepartments = true;
            }
            if( ( payload.quoteRegion != null || payload.quoteRegion != undefined ) && payload.quoteRegion[0] != 'all' ) {
              quote_details.filter_params.quoteRegion = payload.quoteRegion;
            }
            if( ( payload.quoteRep != null || payload.quoteRep != undefined ) && payload.quoteRep[0] != 'all' ) {
              quote_details.filter_params.quoteRep = payload.quoteRep;
            }
            if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
              quote_details.filter_params.commercial_kam = payload.commercial_kam;
            }
            if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
              quote_details.filter_params.commercial_originator = payload.commercial_originator;
            }
            if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
              quote_details.filter_params.quote_type = payload.quote_type;
            }
            if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
              quote_details.filter_params.service_type = payload.service_type;
            }
            if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
              quote_details.filter_params.projects = payload.projects;
            }
            if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
              quote_details.filter_params.company = payload.company;
            }
            if( payload.linked != null && payload.linked != undefined && payload.linked != '' ) {
              quote_details.filter_params.linked = payload.linked;
            }
            if( payload.role != null && payload.role != undefined && payload.role != 'all' ) {
              quote_details.filter_params.role = payload.role;
            }
            if( payload.rep != null && payload.rep != undefined && payload.rep != 'all' ) {
              quote_details.filter_params.rep = payload.rep;
            }
          }

          Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              console.log(error);
            }).then(data => {
            var filters = {
              filters: {
                region: '*',
                originator: '*',
                status: '*',
                companies: '*',
                customers: '*',
                projects: '*',
                specifiers: '*'
              },
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              viewall: true

            }
            commit('fncSummaryFilterLoad', false);
            //commit('fncSetQuoteReportLoaded', true);
            if( payload.hasOwnProperty('call_type') ) {
              if( data.success == true ) {
                let da
                if (payload.report_type === 'conversion'){
                  switch (payload.call_type) {
                    case 'department':
                      da = 'Quote_Conv_Date_By_Dept.xlsx'
                      break;
                    case 'store':
                      da = 'Quote_Conv_Date_Region_Store.xlsx'
                      break
                    case 'role':
                      da = 'Quote_Conv_Date_BY_Roles.xlsx'
                      break
                    case 'originator':
                      da = 'Quote_Conv_Date_Originator.xlsx'
                      break
                    case 'vendor':
                      da = 'Quote_Conv_Date_Vendor.xlsx'
                      break
                  }
                }
                else{
                  switch (payload.call_type) {
                    case 'department':
                      da = 'Quote_Orig_Date_By-Dept.xlsx'
                      break;
                    case 'store':
                      da = 'Quote_Orig_Date_Region-Store.xlsx'
                      break
                    case 'role':
                      da = 'Quote_Orig_Date_BY-Roles.xlsx'
                      break
                    case 'originator':
                      da = 'Quote_Orig_Date_Originator.xlsx'
                      break
                    case 'vendor':
                      da = 'Quote_Orig_Date_Vendor.xlsx'
                      break
                  }
                }
                var reportDownload = document.createElement('a');
                reportDownload.setAttribute('href', data.file);
                reportDownload.setAttribute('download', da);
                reportDownload.click();
                ///commit('setSummaryLoading', false);
              }
              else {

                var snackDetails = { color: 'error', message: data.reason, display: true };
                commit('setSnack', snackDetails);
              }
            }
          });
        });
      });
    });
  }
};
export const fncPopulateQuoteList = ({ commit, dispatch, state, rootState }, payload) => {
  let key = getTabKey()
  let singleStatus

  if (localStorage.getItem('secondTab') !== null && (payload.selectedTab === undefined || payload.selectedTab == null ) ) {
    let secondTab = localStorage.getItem('secondTab')
    let tabs = JSON.parse(localStorage.getItem('tabs'));
    let count = 0
    let keyNotFound = false

    for (let p in tabs[key]) {
      if (count === Number(secondTab) ){
        singleStatus = tabs[key][p].description
        keyNotFound = true
        break
      }
      count++
    }

    if (keyNotFound){
      payload.selectedTab = singleStatus
    }
  }

  var ignoreFilters = false;
  var page_start = 0;
  if( payload.page_start ) { page_start = payload.page_start; }
  var page_end = 49;
  if( payload.page_end ) { page_end = payload.page_end; }

  if( payload.ignoreFilters != undefined && payload.ignoreFilters != null ) { ignoreFilters = payload.ignoreFilters; }

  var objAuth = JSON.parse(rootState.objAuthorize);

  var viewAllDepartments = false;
  if( objAuth.privileges.indexOf('DEPARTMENT_VIEW_ALL_QUOTES') != -1 ) { viewAllDepartments = true; }

  if (state.quoteList != undefined && state.quoteList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
    state.quotesLoaded = false;
    var currency_data = [];
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);

      }).then(data => {
      var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer };
      Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured', display: true };
          commit('setSnack', snackDetails);
          console.log(error);
        }).then(pricelists => {

        for (var p in pricelists) {
          var cur_data = { id: pricelists[p].pl_id, default: pricelists[p].pl_is_default, currency_sym: pricelists[p].pl_currency_sym, tax_label: pricelists[p].pl_tax_label, tax_percentage: pricelists[p].pl_tax_percentage, currency_code: pricelists[p].pl_currency_code };
          currency_data.push(cur_data);
        }

        var objAuth = JSON.parse(rootState.objAuthorize);
        var columnDetails = { id: objAuth.id };
        Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Report.php?a=get_report_settings', { params: columnDetails }, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            var snackDetails = { color: 'error', message: 'An error has occured retrieving the Quote list', display: true };
            commit('setSnack', snackDetails);
            console.log(error);
          }).then(data => {
          var objSettings = JSON.parse(data.report_settings);
          //commit('setObjQuoteSettings', objSettings);
          commit({
            type: 'setObjQuoteSettings',
            columns: objSettings,
            manu: objAuth.manufacturer
          });
          if (payload != undefined && (payload.refresh != undefined || payload.reload != undefined)) {
            if (payload.date_from != 'null' && payload.date_from != null) {
              let da = new Date(payload.date_from)
              var startDate = new Date(da + ' GMT').toISOString().slice(0, 10);
              var objStartDate = startDate.split("-");
              startDate = objStartDate[0] + '-' + objStartDate[1] + '-' + objStartDate[2];
            } else {
              startDate = 'null';
            }
            if (payload.date_to != 'null' && payload.date_to != null) {
              let da = new Date(payload.date_to)
              var endDate = new Date(da + ' GMT').toISOString().slice(0, 10);
              var objEndDate = endDate.split("-");
              endDate = objEndDate[0] + '-' + objEndDate[1] + '-' + objEndDate[2];
            } else {
              endDate = 'null';
            }

            var quote_age = '';
            if( payload.start_date ) {
              quote_age = payload.start_date;
              localStorage.setItem('quote_start_date', payload.start_date);
            } else {
              quote_age = '1900-01-01';
              localStorage.setItem('quote_start_date', '1900-01-01');
            }

            var quote_age_end = '';
            if( payload.end_date ) {
              quote_age_end = payload.end_date;
              localStorage.setItem('quote_end_date', payload.end_date);
            } else {
              var today = new Date();
              var dd = String(today.getDate()).padStart(2, '0');
              var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
              var yyyy = today.getFullYear();

              var end_date = yyyy + '-' + mm + '-' + dd;
              quote_age_end = end_date;
              localStorage.setItem('quote_end_date', payload.end_date);
            }

            // added for dashboard speed
            if( payload.start_date && payload.start_date != '' && payload.end_date && payload.end_date != '' ) {
              var newPush = [];

              localStorage.removeItem('reportSearch');
              localStorage.removeItem('reportDates');

              newPush.push('date');
              localStorage.setItem('searchOrder', JSON.stringify(newPush));

              /*localStorage.removeItem('reportOriginators');
              localStorage.removeItem('reportProject');
              localStorage.removeItem('reportUsers');
              localStorage.removeItem('reportCompanies');
              localStorage.removeItem('reportSpecifiers');*/

            }

            /*if( start_date = '' ) {
              start_date = '1900-01-01';
            }
            if( end_date = '' ) {
              var today = new Date();
              var dd = String(today.getDate()).padStart(2, '0');
              var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
              var yyyy = today.getFullYear();

              end_date = yyyy + '-' + mm + '-' + dd;
            }*/

            var reportDates = []
            reportDates.push(quote_age);
            reportDates.push(quote_age_end);

            localStorage.setItem('reportDates', reportDates.toString());
            if( payload.hasOwnProperty('call_type') ) {
              var quote_details = {
                a: 'generateSummaryReport',
                currency_data: currency_data,
                filter_params: {
                  manufacturer: objAuth.manufacturer,
                  user: objAuth.id,
                  date_from: quote_age,
                  date_to: quote_age_end,
                  call: payload.call_type,
                  role: payload.role,
                  category: payload.category,
                  report_measurement: payload.report_measurement,
                  report_increment: payload.report_increment,
                  originator_copy: payload.originator_copy,
                  department_copy: payload.department_copy,
                  store_copy: payload.store_copy,
                  vendor_copy: payload.vendor_copy,
                }
              };
            }
            else {
              if( objAuth.privileges.indexOf('VIEW_OLD_QUOTE_REPORT') == -1 ) {
                var quote_details = {
                  a: 'getAll',
                  currency_data: currency_data,
                  filter_params: {
                    manufacturer: objAuth.manufacturer,
                    user: objAuth.id,
                    date_from: quote_age,
                    date_to: quote_age_end,
                    page_start: page_start,
                    page_end: page_end,
                    key: key,
                    //originator: payload.originator != null || payload.originator != undefined ? payload.originator : '*'
                    /*filterStatus: payload.status,
                    customer: payload.customer,
                    vendor: payload.vendor,
                    store: payload.store*/
                  }
                };
              } else {
                var quote_details = {
                  a: 'getAll',
                  currency_data: currency_data,
                  filter_params: {
                    manufacturer: objAuth.manufacturer,
                    user: objAuth.id,
                    date_from: quote_age,
                    date_to: quote_age_end,
                    page_start: page_start,
                    page_end: page_end,
                    //originator: payload.originator != null || payload.originator != undefined ? payload.originator : '*'
                    /*filterStatus: payload.status,
                    customer: payload.customer,
                    vendor: payload.vendor,
                    store: payload.store*/
                  }
                };
              }

            }

            if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
              quote_details.filter_params.originator = payload.originator;
            }
            if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
              quote_details.filter_params.filterStatus = payload.status;
            }
            if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
              quote_details.filter_params.customer = payload.customer;
            }
            if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
              quote_details.filter_params.vendor = payload.vendor;
            }
            if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
              quote_details.filter_params.store = payload.store;
            }
            if( ( payload.search != null || payload.search != undefined )  ) {
              quote_details.filter_params.keywords = payload.search;
            }
            if( ( payload.department != null || payload.department != undefined ) && payload.department[0] != 'all' ) {
              quote_details.filter_params.department = payload.department;
            }
            if( ( payload.quoteRegion != null || payload.quoteRegion != undefined ) && payload.quoteRegion[0] != 'all' ) {
              quote_details.filter_params.quoteRegion = payload.quoteRegion;
            }
            if( viewAllDepartments == true ) {
              quote_details.filter_params.viewAllDepartments = true;
            }
            if( ( payload.quoteRep != null || payload.quoteRep != undefined ) && payload.quoteRep[0] != 'all' ) {
              quote_details.filter_params.quoteRep = payload.quoteRep;
            }
            if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
              quote_details.filter_params.commercial_kam = payload.commercial_kam;
            }
            if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
              quote_details.filter_params.commercial_originator = payload.commercial_originator;
            }
            if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
              quote_details.filter_params.quote_type = payload.quote_type;
            }
            if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
              quote_details.filter_params.service_type = payload.service_type;
            }
            if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
              quote_details.filter_params.projects = payload.projects;
            }
            if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
              quote_details.filter_params.company = payload.company;
            }
            if( payload.linked != null && payload.linked != undefined && payload.linked != '' ) {
              quote_details.filter_params.linked = payload.linked;
            }
            if( payload.quote_report_search != null && payload.quote_report_search != undefined && payload.quote_report_search != '' ) {
              quote_details.filter_params.quote_report_search = payload.quote_report_search;
            }
            if( objAuth.privileges.indexOf('VIEW_OLD_QUOTE_REPORT') != -1 && payload.selectedTab !== undefined && payload.selectedTab != null ) {
              quote_details.filter_params.selectedTab = payload.selectedTab;
            }

          } else {
            var quote_age = '';
            if( payload.start_date ) {
              quote_age = payload.start_date;
              localStorage.setItem('quote_start_date', payload.start_date);
            }
            var quote_age_end = '';
            if( payload.end_date ) {
              quote_age_end = payload.end_date;
              localStorage.setItem('quote_end_date', payload.end_date);
            }
            if( payload.hasOwnProperty('call_type') ) {
              var quote_details = {
                a: 'generateSummaryReport',
                currency_data: currency_data,
                filter_params: {
                  manufacturer: objAuth.manufacturer,
                  user: objAuth.id,
                  date_from: quote_age,
                  date_to: quote_age_end,
                  call: payload.call_type,
                  role: payload.role,
                  category: payload.category,
                  report_measurement: payload.report_measurement,
                  report_increment: payload.report_increment,
                  originator_copy: payload.originator_copy,
                  department_copy: payload.department_copy,
                  store_copy: payload.store_copy,
                  vendor_copy: payload.vendor_copy,
                }
              };
            }
            else {
              if( objAuth.privileges.indexOf('VIEW_OLD_QUOTE_REPORT') == -1 ) {
                var quote_details = {
                  a: 'getAll',
                  currency_data: currency_data,
                  filter_params: {
                    manufacturer: objAuth.manufacturer,
                    user: objAuth.id,
                    date_from: quote_age,
                    date_to: quote_age_end,
                    page_start: page_start,
                    page_end: page_end,
                    key: key,
                    //originator: ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ? payload.originator : '*'
                    /*filterStatus: payload.status,
                    customer: payload.customer,
                    vendor: payload.vendor,
                    store: payload.store*/
                  }
                };
              } else {
                var quote_details = {
                  a: 'getAll',
                  currency_data: currency_data,
                  filter_params: {
                    manufacturer: objAuth.manufacturer,
                    user: objAuth.id,
                    date_from: quote_age,
                    date_to: quote_age_end,
                    page_start: page_start,
                    page_end: page_end,
                    //originator: ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ? payload.originator : '*'
                    /*filterStatus: payload.status,
                    customer: payload.customer,
                    vendor: payload.vendor,
                    store: payload.store*/
                  }
                };
              }

            }

            if( ( payload.originator != null || payload.originator != undefined ) && payload.originator[0] != 'all' ) {
              quote_details.filter_params.originator = payload.originator;
            }
            if( ( payload.status != null || payload.status != undefined ) && payload.status[0] != 'all' ) {
              quote_details.filter_params.filterStatus = payload.status;
            }
            if( ( payload.customer != null || payload.customer != undefined ) && payload.customer[0] != 'all' ) {
              quote_details.filter_params.customer = payload.customer;
            }
            if( ( payload.vendor != null || payload.vendor != undefined ) && payload.vendor[0] != 'all' ) {
              quote_details.filter_params.vendor = payload.vendor;
            }
            if( ( payload.store != null || payload.store != undefined ) && payload.store[0] != 'all' ) {
              quote_details.filter_params.store = payload.store;
            }
            if( ( payload.department != null || payload.department != undefined ) && payload.department[0] != 'all' ) {
              quote_details.filter_params.department = payload.department;
            }
            if( ( payload.search != null || payload.search != undefined )  ) {
              quote_details.filter_params.keywords = payload.search;
            }
            if( viewAllDepartments == true ) {
              quote_details.filter_params.viewAllDepartments = true;
            }
            if( ( payload.quoteRegion != null || payload.quoteRegion != undefined ) && payload.quoteRegion[0] != 'all' ) {
              quote_details.filter_params.quoteRegion = payload.quoteRegion;
            }
            if( ( payload.quoteRep != null || payload.quoteRep != undefined ) && payload.quoteRep[0] != 'all' ) {
              quote_details.filter_params.quoteRep = payload.quoteRep;
            }
            if( ( payload.commercial_kam != null || payload.commercial_kam != undefined ) && payload.commercial_kam[0] != 'all' ) {
              quote_details.filter_params.commercial_kam = payload.commercial_kam;
            }
            if( ( payload.commercial_originator != null || payload.commercial_originator != undefined ) && payload.commercial_originator[0] != 'all' ) {
              quote_details.filter_params.commercial_originator = payload.commercial_originator;
            }
            if( ( payload.quote_type != null || payload.quote_type != undefined ) && payload.quote_type[0] != 'all' ) {
              quote_details.filter_params.quote_type = payload.quote_type;
            }
            if( ( payload.service_type != null || payload.service_type != undefined ) && payload.service_type[0] != 'all' ) {
              quote_details.filter_params.service_type = payload.service_type;
            }
            if( ( payload.projects != null || payload.projects != undefined ) && payload.projects[0] != 'all' ) {
              quote_details.filter_params.projects = payload.projects;
            }
            if( ( payload.company != null || payload.company != undefined ) && payload.company[0] != 'all' ) {
              quote_details.filter_params.company = payload.company;
            }
            if( payload.linked != null && payload.linked != undefined && payload.linked != '' ) {
              quote_details.filter_params.linked = payload.linked;
            }
            if( payload.quote_report_search != null && payload.quote_report_search != undefined && payload.quote_report_search != '' ) {
              quote_details.filter_params.quote_report_search = payload.quote_report_search;
            }
            if( objAuth.privileges.indexOf('VIEW_OLD_QUOTE_REPORT') === -1 && payload.selectedTab !== undefined && payload.selectedTab != null ) {
              quote_details.filter_params.selectedTab = payload.selectedTab;
            }
          }

          Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              console.log(error);
            }).then(data => {
            var filters = {
              filters: {
                region: '*',
                originator: '*',
                status: '*',
                companies: '*',
                customers: '*',
                projects: '*',
                specifiers: '*'
              },
              manufacturer: objAuth.manufacturer,
              user: objAuth.id,
              viewall: true
            }
            Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=salesOrder', salesDetails, rootState.headerDetails)
              .then(response => {
                return response.json();
              }, error => {
                //console.log(error);
              }).then(so => {

              commit('fncSetQuoteReportLoaded', false);

              for (var d in data.quotes) {
                data.quotes[d].staticStatus = data.quotes[d].status;
              }
              if (data.tabs){
                commit('fncTabs', data.tabs);
              }

              if (data.selected_tab_with_quotes){
                commit('fncSelectedTabWithQuotes', data.selected_tab_with_quotes);
              }

              if (data.selected_status){
                commit('selectTabs', data.selected_status);
              }

              commit({
                type: 'setQuoteList',
                quotes: data.quotes,
                departments: rootState.Departments.departmentList,
                branches: rootState.Branches.branchList,
                loggedUser: objAuth,
                ignoreFilters: ignoreFilters,
                page_start: page_start
                //filters: d,
              });
              commit({
                type: 'setSalesOrderStatusStatus',
                salesOrders: so
              });

                if (payload != undefined && payload.reload == true) {
                  var snackDetails = { color: 'success', message: 'Quote Report reload successfull', display: true };
                  commit('setSnack', snackDetails);
                }



            });
          });
        });
      });
    });
  } else if (objAuth.vendorActive == '1') {

    commit({
      type: 'setQuoteList',
      quotes: state.quoteList,
      departments: rootState.Departments.departmentList,
      branches: rootState.Branches.branchList,
      loggedUser: objAuth,
      ignoreFilters: ignoreFilters,
      page_start: page_start
    });

    var salesDetails = { manufacturer: objAuth.manufacturer };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=salesOrder', salesDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(so => {
      commit({
        type: 'setSalesOrderStatusStatus',
        salesOrders: so
      });
    });
  } else {
    commit( 'fncSetQuoteReportLoaded', true );
  }
};

export const fncPopulateTenderList = ({commit, dispatch, state, rootState}, payload)  => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var tenderDetails = {manufacturer: objAuth.manufacturer, filter: state.objTenderFilters };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=get_tender_data', {params: tenderDetails}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit({
      type: 'setTenderList',
      tenders: data
    });
  });
};

export const fncPopulateRfcList = ({ commit, dispatch, state, rootState }, payload) => {
  if (state.rfcList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true ))) {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var rfcDetails = {
      client_id: objAuth.manufacturer,
      current_user: objAuth.id,
      max_per_page: 9999
    };
    Vue.http.get(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/rfc', { params: rfcDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured retrieving the RFC list', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      commit('hideModal');
      commit({
        type: 'setRfcList',
        rfcList: data
      });
      if (payload != undefined && payload.reload == true) {
        var snackDetails = { color: 'success', message: 'RFC reload successfull', display: true };
        commit('setSnack', snackDetails);
      }
    });
  }
};

/*export const fncGetpricelistrange = ({commit, dispatch, state, rootState}, payload) => {
	var productRange = 'Unknown Range';
	for( var k in payload.productData ) {
		if( payload.productData[k].pli_code == payload.productCode ) {
			productRange = payload.productData[k].pli_range;
		}
	}
	return productRange;
}*/

export const fncPopulateProductSalesList = ({ commit, dispatch, state, rootState }, payload) => {
  if (state.productSalesList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true || payload.objFilters.startDate != undefined))) {
    if (payload != undefined && payload.reload == undefined) {
      localStorage.setItem('psStartDate', payload.objFilters.startDate);
      localStorage.setItem('psEndDate', payload.objFilters.endDate);
      localStorage.setItem('psQuoteStatus', payload.objFilters.quoteStatus);
      localStorage.setItem('psQuoteTenderStatus', payload.objFilters.quoteTenderStatus);
      localStorage.setItem('psProductTenderStatus', payload.objFilters.productTenderStatus);
      localStorage.setItem('psOriginator', payload.objFilters.originator);
      localStorage.setItem('psCustomer', payload.objFilters.customer);
    }
    var objAuth = JSON.parse(rootState.objAuthorize);
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(data => {
      var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, 'default': 1 };
      Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured', display: true };
          commit('setSnack', snackDetails);
        }).then(dt => {
        var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, 'is_library_pricelist': 1 };
        Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            var snackDetails = { color: 'error', message: 'An error has occured', display: true };
            commit('setSnack', snackDetails);
          }).then(dd => {
          var list_id = dd[0].pl_id;
          var tokenDetails = { token: data.token, list_id: list_id };
          Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', { params: tokenDetails }, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              var snackDetails = { color: 'error', message: 'An error has occured', display: true };
              commit('setSnack', snackDetails);
            }).then(d => {
            var plistItems = d;
            var salesDetails = {
              manufacturer: objAuth.manufacturer,
              filter: {
                date_from: state.objProductSalesFilters.dateFrom == undefined ? 'null' : state.objProductSalesFilters.dateFrom,
                date_to: state.objProductSalesFilters.dateTo == undefined ? 'null' : state.objProductSalesFilters.dateTo,
                originator: state.objProductSalesFilters.originator == '' ? '0' : state.objProductSalesFilters.originator,
                customer_user: state.objProductSalesFilters.customer == '' ? '0' : state.objProductSalesFilters.customer,
                quote_status: state.objProductSalesFilters.quoteStatus == '' ? 'None' : state.objProductSalesFilters.quoteStatus,
                tender_status: state.objProductSalesFilters.quoteTenderStatus == '' ? '*' : state.objProductSalesFilters.quoteTenderStatus,
                project_tender_status: state.objProductSalesFilters.projectTenderStatus == undefined ? '*' : state.objProductSalesFilters.projectTenderStatus
              }
            };
            Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=get_product_sales', { params: salesDetails }, rootState.headerDetails)
              .then(response => {
                return response.json();
              }, error => {
                console.log(error);
              }).then(sales => {
              dispatch('fncCreatePSFilters');
              commit({
                type: 'fncPopulateProductSalesList',
                plistItems: plistItems,
                sales: sales
              })
              if (payload != undefined && payload.reload == true) {
                var snackDetails = { color: 'success', message: 'Product sales report reload successfull', display: true };
                commit('setSnack', snackDetails);
              }
            });
          });
        });
      });
    });
  }
}

export const fncCreatePSFilters = ({ commit, dispatch, state, rootState }, payload) => {
  commit('fncSetPSFilterQuoteTenderStatus');
  commit('fncSetPSFilterProductTenderStatus');
  var objAuth = JSON.parse(rootState.objAuthorize);
  var statusDetails = { user: objAuth.id, manufacturer: objAuth.manufacturer }
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=get_quote_status', { params: statusDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the Status list', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit({
      type: 'fncSetPSFilterStatus',
      statusses: data
    })
    var originatorDetails = { current_user_id: objAuth.id, current_user_manufacturer: objAuth.manufacturer }
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Report.php?a=get_originators', { params: originatorDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured retrieving the Originator list', display: true };
        commit('setSnack', snackDetails);
      }).then(dd => {
      commit({
        type: 'fncSetPSFilterOriginators',
        originators: dd
      })

      var customerDetails = { current_user_id: objAuth.id, current_user_manufacturer: objAuth.manufacturer, company: 0 }
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Report.php?a=get_customers', { params: customerDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured retrieving the Customer list', display: true };
          commit('setSnack', snackDetails);
        }).then(d => {
        commit({
          type: 'fncSetPSFilterCustomers',
          customers: d
        })
      });
    });
  });
}


export const fncSalesProducts = ({ commit, dispatch, state, rootState }, payload) => {
  var objProducts = [];
  for( var k in state.productSalesProducts ) {
    if( state.productSalesProducts[k].range == payload.range ) {
      if( objProducts[state.productSalesProducts[k].product_name] == undefined ) {
        objProducts[state.productSalesProducts[k].product_name] = [];
        objProducts[state.productSalesProducts[k].product_name]['name'] = state.productSalesProducts[k].product_name;
        objProducts[state.productSalesProducts[k].product_name]['products'] = [];
        objProducts[state.productSalesProducts[k].product_name]['uom'] = state.productSalesProducts[k].uom;
        objProducts[state.productSalesProducts[k].product_name]['quantity'] = 0;
        objProducts[state.productSalesProducts[k].product_name]['gross'] = 0;
        objProducts[state.productSalesProducts[k].product_name]['discount'] = 0;
        objProducts[state.productSalesProducts[k].product_name]['nett'] = 0;
      }
      objProducts[state.productSalesProducts[k].product_name]['products'].push(state.productSalesProducts[k]);
      objProducts[state.productSalesProducts[k].product_name]['quantity'] += parseFloat( state.productSalesProducts[k].quantity );
    }
  }
  for (var k in state.productSalesSubList) {
    var prodCode = state.productSalesSubList[k].code;
    var prodName = state.productSalesSubList[k].name;
    if (objProducts.hasOwnProperty(prodCode + ' - ' + prodName)) {
      objProducts[prodCode + ' - ' + prodName]['gross'] = state.productSalesSubList[k].gross_total;
      objProducts[prodCode + ' - ' + prodName]['discount'] = state.productSalesSubList[k].discount_total;
      objProducts[prodCode + ' - ' + prodName]['nett'] = state.productSalesSubList[k].nett_total;
    }
  }
  commit({
    type: 'fncSetProductSalesSelectProducts',
    products: objProducts,
    range: payload.range
  })
}

export const fncPopulateRolesStatusList = ({ commit, dispatch, state, rootState }, payload) => {
  // if (state.statusList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true ))) {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var statusDetails = {
    a: 'get_quote_status_roles',
    manufacturer: objAuth.manufacturer,
    department: payload.department
  };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', { params: statusDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log('err')
    }).then(data => {

    commit({
      type: 'setSummaryStatusList',
      status: data.status
    });
    commit({
      type: 'setSummaryRoleList',
      status: data.roles
    });

  });
  // }
};

export const fncPopulateStatusList = ({ commit, dispatch, state, rootState }, payload) => {
  // if (state.statusList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true ))) {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var statusDetails = {
    a: 'get_quote_status',
    manufacturer: objAuth.manufacturer,
    user: objAuth.id
  };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', { params: statusDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the Status list', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    for (var n = 0; n < data.length; n++) {
      data[n].text = data.description;
      data[n].order = parseInt(n) + 1;
    }
    commit({
      type: 'setStatusList',
      status: data
    });
    if (payload != undefined && payload.reload == true) {
      var snackDetails = { color: 'success', message: 'Quote Status reload successfull', display: true };
      commit('setSnack', snackDetails);
    }
  });
  // }
};

export const fncPopulateRfcStatusList = ({ commit, dispatch, state, rootState }, payload) => {
  if (state.rfcStatusList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var statusDetails = {
      client_id: objAuth.manufacturer
    };
    Vue.http.get(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/rfcstatus', { params: statusDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured retrieving the Status list', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      for (var n = 0; n < data.length; n++) {
        data[n].order = parseInt(n) + 1;
      }
      commit('hideModal');
      commit({
        type: 'setRfcStatusList',
        rfcStatus: data
      });
      if (payload != undefined && payload.reload == true) {
        var snackDetails = { color: 'success', message: 'RFC Status reload successfull', display: true };
        commit('setSnack', snackDetails);
      }
    });
  }
};

export const fncUpdateStatus = ({ commit, dispatch, state, rootState }, payload) => {

  if (payload.reload != undefined) {
    payload.settings.colour_flag = payload.settings.colour_flag == 'Yes' ? true : false;
    payload.settings.create_invoice = payload.settings.create_invoice == 'Yes' ? true : false;
    payload.settings.is_accepted = payload.settings.is_accepted == 'Yes' ? true : false;
    payload.settings.is_new_lead = payload.settings.is_new_lead == 'Yes' ? true : false;
    payload.settings.is_gathering_customer_reqs = payload.settings.is_gathering_customer_reqs == 'Yes' ? true : false;
    payload.settings.is_quote_sent = payload.settings.is_quote_sent == 'Yes' ? true : false;
    payload.settings.is_requote_requested = payload.settings.is_requote_requested == 'Yes' ? true : false;
    payload.settings.is_rejected = payload.settings.is_rejected == 'Yes' ? true : false;
    payload.settings.is_awaiting = payload.settings.is_awaiting == 'Yes' ? true : false;
    payload.settings.is_cancel = payload.settings.is_cancel == 'Yes' ? true : false;
    payload.settings.is_converted = payload.settings.is_converted == 'Yes' ? true : false;
    payload.settings.is_checked = payload.settings.is_checked == 'Yes' ? true : false;
    payload.settings.is_expired = payload.settings.is_expired == 'Yes' ? true : false;
    payload.settings.is_lock = payload.settings.is_lock == 'Yes' ? true : false;
    payload.settings.is_order_status = payload.settings.is_order_status == 'Yes' ? true : false;
    payload.settings.is_tender_winning = payload.settings.is_tender_winning == 'Yes' ? true : false;
    payload.settings.is_vendor = payload.settings.is_vendor == 'Yes' ? true : false;
    payload.settings.is_picked = payload.settings.is_picked == 'Yes' ? true : false;
    payload.settings.is_dispatched = payload.settings.is_dispatched == 'Yes' ? true : false;
    payload.settings.is_installation_wip = payload.settings.is_installation_wip == 'Yes' ? true : false;
    payload.settings.is_installation_work_complete = payload.settings.is_installation_work_complete == 'Yes' ? true : false;
    payload.settings.is_reorder = payload.settings.is_reorder == 'Yes' ? true : false;
    payload.settings.tender_status = payload.settings.tender_status == 'Yes' ? true : false;
    payload.settings.triggers_notification = payload.settings.triggers_notification == 'Yes' ? true : false;
    payload.settings.is_customer_accept_final = payload.settings.is_customer_accept_final == 'Yes' ? true : false;
    payload.settings.is_customer_accept = payload.settings.is_customer_accept == 'Yes' ? true : false;
    payload.settings.is_customer_reject = payload.settings.is_customer_reject == 'Yes' ? true : false;
    payload.settings.is_ecommerce_cancelled = payload.settings.is_ecommerce_cancelled == 'Yes' ? true : false;
    payload.settings.is_ecommerce_pending = payload.settings.is_ecommerce_pending == 'Yes' ? true : false;
    payload.settings.is_ecommerce_success = payload.settings.is_ecommerce_success == 'Yes' ? true : false;
    payload.settings.is_ecommerce_failed = payload.settings.is_ecommerce_failed == 'Yes' ? true : false;
    payload.settings.is_process_order = payload.settings.is_process_order == 'Yes' ? true : false;
    payload.settings.is_print = payload.settings.is_print == 'Yes' ? true : false;
    payload.settings.is_hybris = payload.settings.is_hybris == 'Yes' ? true : false;
    payload.settings.is_hybris_trolley = payload.settings.is_hybris_trolley == 'Yes' ? true : false;
    payload.settings.can_back_after_payment = payload.settings.can_back_after_payment == 'Yes' ? true : false;
    payload.settings.can_forward_before_payment = payload.settings.can_forward_before_payment == 'Yes' ? true : false;
    payload.settings.is_manufactured = payload.settings.is_manufactured == 'Yes' ? true : false;
    payload.settings.is_delivered_to_store = payload.settings.is_delivered_to_store == 'Yes' ? true : false;

    payload.settings.fs_job_complete = payload.settings.fs_job_complete == 'Yes' ? true : false;
    payload.settings.fs_job_cancelled = payload.settings.fs_job_cancelled == 'Yes' ? true : false;
    payload.settings.fs_awaiting_stock = payload.settings.fs_awaiting_stock == 'Yes' ? true : false;
    payload.settings.fs_on_site = payload.settings.fs_on_site == 'Yes' ? true : false;
    payload.settings.fs_work_paused = payload.settings.fs_work_paused == 'Yes' ? true : false;
    payload.settings.fs_no_appointment_contact_customer = payload.settings.fs_no_appointment_contact_customer == 'Yes' ? true : false;
    payload.settings.fs_delivery_ready = payload.settings.fs_delivery_ready == 'Yes' ? true : false;

    payload.settings.fs_installer_allocated = payload.settings.fs_installer_allocated == 'Yes' ? true : false;
    payload.settings.fs_installer_on_route_stock_collect = payload.settings.fs_installer_on_route_stock_collect == 'Yes' ? true : false;
    payload.settings.fs_installer_at_dispatch = payload.settings.fs_installer_at_dispatch == 'Yes' ? true : false;
    payload.settings.fs_collection_cancelled = payload.settings.fs_collection_cancelled == 'Yes' ? true : false;
    payload.settings.fs_installer_on_route_customer = payload.settings.fs_installer_on_route_customer == 'Yes' ? true : false;

    payload.settings.is_new_lead = payload.settings.is_new_lead == 'Yes' ? true : false;
    payload.settings.is_initial_engagement_quote = payload.settings.is_initial_engagement_quote == 'Yes' ? true : false;
    payload.settings.is_negotiating_customer_approval = payload.settings.is_negotiating_customer_approval == 'Yes' ? true : false;
    payload.settings.is_manufacturer_fulfilment = payload.settings.is_manufacturer_fulfilment == 'Yes' ? true : false;
    payload.settings.is_cancelled_expired_rejected = payload.settings.is_cancelled_expired_rejected == 'Yes' ? true : false;

    payload.settings.department = payload.department;
    payload.settings.roles = payload.roles;
    payload.settings.editStatus = payload.settings;
    payload.settings.reasons = payload.reasons;
    payload.settings.is_delivered = payload.is_delivered;
    payload.settings.is_waiting_tender = payload.is_waiting_tender;
    payload.settings.is_pod_uploaded = payload.is_pod_uploaded;
    payload.settings.is_ignore = payload.is_ignore;
    payload.settings.is_po_received = payload.is_po_received;
    payload.settings.is_customer_send = payload.is_customer_send;
    payload.settings.is_reqs_sent_to_design_team = payload.is_reqs_sent_to_design_team;
    payload.settings.is_quote_completed_by_design_team = payload.is_quote_completed_by_design_team;
    payload.settings.is_status_repeat = payload.is_status_repeat;
  }
  var objAuth = JSON.parse(rootState.objAuthorize);

  if( payload.settings.editStatus.department != null && payload.settings.editStatus.department != 'null' ) {
    var statusDep = payload.settings.editStatus.department.join();
  } else {
    var statusDep = null;
  }

  var editStatusDetails = {
    id: payload.settings.editStatus.id,
    description: payload.settings.editStatus.description,
    is_new_lead: payload.settings.editStatus.is_new_lead,
    is_gathering_customer_reqs: payload.settings.editStatus.is_gathering_customer_reqs,
    is_quote_sent: payload.settings.editStatus.is_quote_sent,
    is_requote_requested: payload.settings.editStatus.is_requote_requested,
    is_rejected: payload.settings.editStatus.is_rejected,
    is_order: payload.settings.editStatus.is_order_status,
    is_awaiting: payload.settings.editStatus.is_awaiting,
    is_lock: payload.settings.editStatus.is_lock,
    is_accepted: payload.settings.editStatus.is_accepted,
    is_tender_winning: payload.settings.editStatus.is_tender_winning,
    create_invoice: payload.settings.editStatus.create_invoice,
    is_cancel: payload.settings.editStatus.is_cancel,
    is_picked: payload.settings.editStatus.is_picked,
    is_dispatched: payload.settings.editStatus.is_dispatched,
    is_installation_wip: payload.settings.editStatus.is_installation_wip,
    is_installation_work_complete: payload.settings.editStatus.is_installation_work_complete,
    triggers_notification: payload.settings.editStatus.triggers_notification,
    tender_status: payload.settings.editStatus.tender_status,
    order: payload.settings.editStatus.order,
    is_checked: payload.settings.editStatus.is_checked,
    is_converted: payload.settings.editStatus.is_converted,
    is_vendor: payload.settings.editStatus.is_vendor,
    is_reorder: payload.settings.editStatus.is_reorder,
    colour: payload.settings.editStatus.style_colour,
    colour_check: payload.settings.editStatus.colour_flag,
    is_expired: payload.settings.editStatus.is_expired,
    is_customer_accept_final: payload.settings.editStatus.is_customer_accept_final,
    is_customer_accept: payload.settings.editStatus.is_customer_accept,
    is_customer_reject: payload.settings.editStatus.is_customer_reject,
    is_ecommerce_cancelled: payload.settings.editStatus.is_ecommerce_cancelled,
    is_ecommerce_pending: payload.settings.editStatus.is_ecommerce_pending,
    is_ecommerce_success: payload.settings.editStatus.is_ecommerce_success,
    is_ecommerce_failed: payload.settings.editStatus.is_ecommerce_failed,
    is_process_order: payload.settings.editStatus.is_process_order,
    is_print: payload.settings.editStatus.is_print,
    is_hybris: payload.settings.editStatus.is_hybris,
    is_hybris_trolley: payload.settings.editStatus.is_hybris_trolley,
    can_back_after_payment: payload.settings.editStatus.can_back_after_payment,
    can_forward_before_payment: payload.settings.editStatus.can_forward_before_payment,
    is_manufactured: payload.settings.editStatus.is_manufactured,
    is_delivered_to_store: payload.settings.editStatus.is_delivered_to_store,
    fs_job_complete: payload.settings.editStatus.fs_job_complete,
    fs_job_cancelled: payload.settings.editStatus.fs_job_cancelled,
    fs_awaiting_stock: payload.settings.editStatus.fs_awaiting_stock,
    fs_on_site: payload.settings.editStatus.fs_on_site,
    fs_work_paused: payload.settings.editStatus.fs_work_paused,
    fs_no_appointment_contact_customer: payload.settings.editStatus.fs_no_appointment_contact_customer,
    fs_delivery_ready: payload.settings.editStatus.fs_delivery_ready,
    fs_installer_allocated: payload.settings.editStatus.fs_installer_allocated,
    fs_installer_on_route_stock_collect: payload.settings.editStatus.fs_installer_on_route_stock_collect,
    fs_installer_at_dispatch: payload.settings.editStatus.fs_installer_at_dispatch,
    fs_collection_cancelled: payload.settings.editStatus.fs_collection_cancelled,
    fs_installer_on_route_customer: payload.settings.editStatus.fs_installer_on_route_customer,
    reasons: payload.settings.editStatus.reasons,
    is_delivered: payload.settings.editStatus.is_delivered,
    is_waiting_tender: payload.settings.editStatus.is_waiting_tender,
    is_pod_uploaded: payload.settings.editStatus.is_pod_uploaded,
    is_ignore: payload.settings.editStatus.is_ignore,
    is_customer_send: payload.settings.editStatus.is_customer_send,
    is_reqs_sent_to_design_team: payload.settings.editStatus.is_reqs_sent_to_design_team,
    is_quote_completed_by_design_team: payload.settings.editStatus.is_quote_completed_by_design_team,
    // department: payload.settings.editStatus.department,
    // department: payload.settings.editStatus.department.join(),
    department: statusDep,
    roles: payload.settings.editStatus.roles,
    current_user_id: objAuth.id,

    //is_new_lead: payload.settings.editStatus.is_new_lead,
    is_initial_engagement_quote: payload.settings.editStatus.is_initial_engagement_quote,
    is_negotiating_customer_approval: payload.settings.editStatus.is_negotiating_customer_approval,
    is_manufacturer_fulfilment: payload.settings.editStatus.is_manufacturer_fulfilment,
    is_cancelled_expired_rejected: payload.settings.editStatus.is_cancelled_expired_rejected,
    is_po_received: payload.settings.editStatus.is_po_received,
    is_status_repeat: payload.settings.editStatus.is_status_repeat,
  }
  var statusString = JSON.stringify(editStatusDetails);
  statusString = statusString.replace(new RegExp('false', 'g'), '0');
  statusString = statusString.replace(new RegExp('true', 'g'), '1');
  editStatusDetails = JSON.parse(statusString);
  var params = { params: editStatusDetails }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=edit_quote_status', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      state.runEdit = false;
      var snackDetails = {color: 'error', message: 'An error has occured while trying to update the status', display: true};
      commit('setSnack', snackDetails);
      commit('setStatusEdit', false);
    }).then(data => {
    if (payload.reload == undefined) {
      state.runEdit = false;
      commit('setStatusEdit', false);
      var snackDetails = { color: 'success', message: 'The status was updated successfully', display: true };
      commit('setSnack', snackDetails);
      /*dispatch({
        type: 'fncPopulateStatusList',
        refresh: true
      });
      commit('hideModal');*/
      setTimeout(function(){
        window.location.reload();
      }, 1250)
    }
  });
}

export const fncAddStatus = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var addStatusDetails = {
    description: payload.settings.statusDescription,
    is_awaiting: payload.settings.awaitingAcceptance,
    is_order: payload.settings.createOrder,
    is_lock: payload.settings.locksQuote,
    is_accepted: payload.settings.acceptedStatus,
    is_tender_winning: payload.settings.tenderWinningStatus,
    is_checked: payload.settings.checkedStatus,
    is_converted: payload.settings.convertedStatus,
    is_vendor: payload.settings.vendorStatus,
    create_invoice: payload.settings.createInvoice,
    is_cancel: payload.settings.cancelStatus,
    triggers_notification: payload.settings.triggersNotifications,
    tender_status: payload.settings.initialTenderStatus,
    order: 99,
    department: payload.settings.statusDepartment,
    roles: payload.settings.statusRoles,
    colour: payload.settings.styleColor,
    colour_check: payload.settings.flagQuoteReport,
    is_expired: payload.settings.expiredStatus,
    is_po_received: payload.settings.poStatus,
    is_reorder: payload.settings.reorderQuote,
    is_customer_accept_final: payload.settings.customerAcceptFinal,
    is_customer_accept: payload.settings.customerAccept,
    is_customer_reject: payload.settings.customerReject,
    is_picked: payload.settings.pickedStatus,
    is_dispatched: payload.settings.dispatchedStatus,
    is_installation_wip: payload.settings.installationWipStatus,
    is_installation_work_complete: payload.settings.installationCompleteStatus,
    is_print: payload.settings.printStatus,
    is_hybris: payload.settings.hybrisStatus,
    is_hybris_trolley: payload.settings.hybrisTrolleyStatus,
    current_user_id: objAuth.id,
    current_user_manufacturer: objAuth.manufacturer,
    is_ecommerce_cancelled: payload.settings.isEcommerceCancelled,
    is_ecommerce_pending: payload.settings.isEcommercePending,
    is_ecommerce_success: payload.settings.isEcommerceSuccess,
    is_ecommerce_failed: payload.settings.isEcommerceFailed,
    fs_job_complete: payload.settings.fsJobCompleted,
    fs_job_cancelled: payload.settings.fsJobCancelled,
    fs_awaiting_stock: payload.settings.fsAwaitingStock,
    fs_on_site: payload.settings.fsTlOnSite,
    fs_work_paused: payload.settings.fsWordPaused,
    fs_no_appointment_contact_customer: payload.settings.fsNoAppointment,
    fs_ready_for_delivery: payload.settings.fsReadyForDelivery,
    fs_installer_allocated: payload.settings.fsInstallerAllocated,
    fs_installer_on_route_stock_collect: payload.settings.fsInstallerOnRouteStockCollect,
    fs_installer_at_dispatch: payload.settings.fsInstallerAtDispatch,
    fs_collection_cancelled: payload.settings.fsCollectionCancelled,
    fs_installer_on_route_customer: payload.settings.fsInstallerOnRouteCustomer,
    can_back_after_payment: payload.settings.backStatus,
    can_forward_before_payment: payload.settings.forwardStatus,
    is_manufactured: payload.settings.manufacturedStatus,
    is_delivered_to_store: payload.settings.deliveredToStoreStatus,
    is_process_order: payload.settings.isProcessOrder,
    reasons: payload.settings.reasons,
    is_delivered: payload.settings.isDelivered,
    is_waiting_tender: payload.settings.isWaitingTender,
    is_pod_uploaded: payload.settings.isPodUploaded,
    is_customer_send: payload.settings.isCustomerSend,
    is_new_lead: payload.settings.isNewLead,
    is_gathering_customer_reqs: payload.settings.isGatheringCustomerReqs,
    is_quote_sent: payload.settings.isQuoteSent,
    is_requote_requested: payload.settings.isRequoteRequested,
    is_rejected: payload.settings.isRejected,
    is_reqs_sent_to_design_team: payload.settings.isReqsSentToDesignTeam,
    is_quote_completed_by_design_team: payload.settings.isQuoteCompletedByDesignTeam,
    is_ignore: payload.settings.isIgnore,
    is_initial_engagement_quote: payload.settings.initial_engagement_quoting,
    is_negotiating_customer_approval: payload.settings.negotiating_customer_approval,
    is_manufacturer_fulfilment:payload.settings.manufacturer_fulfilment,
    is_cancelled_expired_rejected:payload.settings.cancelled_expired_rejected,
  }

  /*
  isNewLead: this.is_new_lead,
            isGatheringCustomerReqs: this.is_gathering_customer_reqs,
            isQuoteSent: this.is_quote_sent,
            isRequoteRequested: this.is_requote_requested,
            isRejected: this.is_rejected,
            isConverted: this.is_converted
   */

  var statusString = JSON.stringify(addStatusDetails);
  statusString = statusString.replace(new RegExp('false', 'g'), '0');
  statusString = statusString.replace(new RegExp('true', 'g'), '1');
  addStatusDetails = JSON.parse(statusString);
  var params = { params: addStatusDetails };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=create_quote_status', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured while trying to add the status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    state.runAdd = false;
    var snackDetails = {color: 'success', message: 'The status was added successfully', display: true};
    commit('setSnack', snackDetails);
    //commit('hideModal');
    setTimeout(function(){
      window.location.reload();
    }, 1250)
    /*dispatch({
      type: 'fncPopulateStatusList',
      refresh: true
    });*/
  });
}

export const fncAddRfcStatus = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var statusDetails = {
    description: payload.settings.statusDescription,
    order: 99,
    creates_notification: payload.settings.triggersNotification,
    is_data_captured: payload.settings.dataCaptured,
    is_get_approval: payload.settings.getApproval,
    is_accepted: payload.settings.approved,
    is_cancel: payload.settings.cancel,
    is_reviewed: payload.settings.reviewed,
    is_sr_collection_note: payload.settings.srCollection,
    is_more_info: payload.settings.moreInfo,
    is_received_ddc: payload.settings.receivedDdc,
    is_sr_raised: payload.settings.raised,
    is_cancel_sr: payload.settings.cancel,
    is_sr_cancelled: payload.settings.cancelled,
    is_sr_receipted: payload.settings.receipted,
    manufacturer_id: objAuth.manufacturer
  };
  Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/rfcstatus', statusDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured creating the RFC status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('hideModal');
    var snackDetails = {color: 'success', message: 'The status was successfully created', display: true};
    commit('setSnack', snackDetails);
    dispatch({
      type: 'fncPopulateRfcStatusList',
      refresh: true
    })
  });
}

export const fncEditRfcStatus = ({ commit, dispatch, state, rootState }, payload) => {
  state.runAdd = false;
  var statusDetails = {
    id: payload.settings.id,
    method: 'PUT',
    description: payload.settings.description,
    order: payload.settings.order,
    creates_notification: payload.settings.triggers_notification == true ? 1 : 0,
    is_data_captured: payload.settings.is_data_captured == true ? 1 : 0,
    is_get_approval: payload.settings.is_get_approval == true ? 1 : 0,
    is_accepted: payload.settings.is_accepted == true ? 1 : 0,
    is_cancel: payload.settings.is_cancel == true ? 1 : 0,
    is_reviewed: payload.settings.is_reviewed == true ? 1 : 0,
    is_sr_collection_note: payload.settings.is_sr_collection_note == true ? 1 : 0,
    is_more_info: payload.settings.is_more_info == true ? 1 : 0,
    is_received_ddc: payload.settings.is_received_ddc == true ? 1 : 0,
    is_sr_raised: payload.settings.is_sr_raised == true ? 1 : 0,
    /*is_cancel_sr: payload.settings.is_cancel,*/
    is_sr_cancelled: payload.settings.is_sr_cancelled == true ? 1 : 0,
    is_sr_receipted: payload.settings.is_sr_receipted == true ? 1 : 0
  };
  Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/rfcstatus', statusDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured updating the RFC status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    if (payload.reload == undefined) {
      commit('hideModal');
      state.runEdit = false;
      var snackDetails = { color: 'success', message: 'The status was successfully updated', display: true };
      commit('setSnack', snackDetails);
      dispatch({
        type: 'fncPopulateRfcStatusList',
        refresh: true
      })
    }
  });
}

export const fncDeleteStatus = ({commit, dispatch, state, rootState}, payload) => {
  var deleteDetails = { id: payload.statusId };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=delete_quote_status', deleteDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured while trying to delete the status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    var snackDetails = {color: 'success', message: 'The status was removed successfully', display: true};
    commit('setSnack', snackDetails);
    dispatch({
      type: 'fncPopulateStatusList',
      refresh: true
    });
  });
}

export const fncDeleteRfcStatus = ({commit, dispatch, state, rootState}, payload) => {
  Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/rfcstatus', {id:payload.statusId, method: 'DELETE'}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured retrieving the RFC history', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    var snackDetails = {color: 'success', message: 'The status was removed successfully', display: true};
    commit('setSnack', snackDetails);
    dispatch({
      type: 'fncPopulateRfcStatusList',
      refresh: true
    })
  });
}

export const fncGetUserInfo = ({commit, dispatch, state, rootState}, payload) => {

  var params = { a: 'get_user_data', id: payload, ctx: process.env.CTX };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'users_tree_data_handler.php', {params: params}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured while trying to retrieve the user information', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    var origData = data;
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {
      var objAuthorize = JSON.parse( rootState.objAuthorize );
      var pricelistDetails = {token: data.token, manufacturer_id: objAuthorize.manufacturer};
      Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: pricelistDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = {color: 'error', message: 'An error has occured retrieving the user pricelists', display: true};
          commit('setSnack', snackDetails);
        }).then(data => {
        var toReturn = [];
        if( data.length !== 0 ) {
          for (var n = 0; n < data.length; n++) {
            if (origData.pricelist_links.indexOf(data[n].pl_id) != '-1') {
              toReturn.push(data[n].pl_name);
            }
          }
        }
        origData.pricelist_names = toReturn;
        var regionDetails = {
          id: payload
        }
        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=get_user_regions', regionDetails, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            var snackDetails = { color: 'error', message: 'An error has occured retrieving the user pricelists', display: true };
            commit('setSnack', snackDetails);
          }).then(regions => {
          origData.allRegions = regions
          commit('setObjUserInfo', origData);
        });
      });
    });
  });
}

export const fncGetQuoteHistory = ({commit, dispatch, state, rootState}, payload) => {
  var params = { a: 'get_statushistory', id: payload, ctx: process.env.CTX };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', {params: params}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured while trying to retrieve the quote history', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('setObjQuoteHistory', data);
  });
}

export const fncGetDateHistory = ({commit, dispatch, state, rootState}, payload) => {console.log(payload)
  var params = { a: 'get_date_history', id: payload.id, history_type: payload.history_type };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', {params: params}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured while trying to retrieve the quote history', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('setobjDateHistory', data);
  });
}

export const fncSetProductSalesReportsFilters = ({commit, dispatch, state, rootState}, payload) => {
  var finalFilterObj = {
    'quote_status': [],
    'quote_tender_status': [],
    'originator': [],
    'originator_type': [],
    'customer_company': [],
    'customer_user': []
  };
  var objAuth = JSON.parse(rootState.objAuthorize);
  var filterDetails = { a: 'get_quote_status', manufacturer: objAuth.manufacturer };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', { params: filterDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    finalFilterObj.quote_status.push(data);
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Report.php', { params: {a: 'get_originators', current_user_id: objAuth.id, current_user_manufacturer: objAuth.manufacturer} }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {
      finalFilterObj.originator.push(data);
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Report.php?a=get_customers', { params: { company: '', current_user_id: objAuth.id, current_user_manufacturer: objAuth.manufacturer }}, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(data => {
        finalFilterObj.customer_user.push(data);
        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Report.php?a=get_customer_companies', { params: {current_user_manufacturer: objAuth.manufacturer }}, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(data => {
          finalFilterObj.customer_company.push(data);
          commit('fncSetProductSalesReportsFilters', finalFilterObj);
        });
      });
    });
  });
}

export const fncImportStatus = ({commit, dispatch, state, rootState}, payload) => {
  commit('setRunAdd', true);
  var objAuth = JSON.parse(rootState.objAuthorize);
  var rowDetails = {rows: payload, current_manufacturer: objAuth.manufacturer, current_id: objAuth.id};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=import_qs', {params: rowDetails}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to import the status list', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('hideModal');
    var snackDetails = {color: 'success', message: 'The status list was imported successfully', display: true};
    commit('setSnack', snackDetails);
    dispatch('fncPopulateStatusList');
    commit('setRunAdd', false);
  });
}

export const fncGenerateQuoteReport = ({commit, dispatch, state, rootState}, payload) => {

}

export const fncPopulateRfcHistory = ({commit, dispatch, state, rootState}, payload) => {
  Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/rfc/history', {id:payload.rfcId}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured retrieving the RFC history', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    commit({
      type: 'setRfcHistory',
      rfcHistory: data
    });
  });
}

export const fncFilterRfc = ({ commit, dispatch, state, rootState }, payload) => {
  localStorage.setItem('rfcStartDate', payload.objFilters.startDate);
  localStorage.setItem('rfcEndDate', payload.objFilters.endDate);
  localStorage.setItem('rfcOriginator', payload.objFilters.originator);
  localStorage.setItem('rfcCustomer', payload.objFilters.customer);
  localStorage.setItem('rfcStatus', payload.objFilters.status);
  localStorage.setItem('rfcSrNumber', payload.objFilters.srNumber);
  localStorage.setItem('rfcCnNumber', payload.objFilters.cnNumber);
  localStorage.setItem('rfcRfcNumber', payload.objFilters.rfcNumber);
  dispatch({
    type: 'fncPopulateRfcList',
    refresh: true
  })
  /*var objFilter = state.rfcSearchList;
  for( var i = 0; i < state.rfcList.length; i++ ) {
      if( typeof state.rfcList[i] === 'object' ) {
          if (payload.originator != '' && state.rfcList[i].originator.fullname != payload.originator) {
              objFilter[i] = '';
          }
      }
      if( typeof state.rfcList[i] === 'object' ) {
          if( payload.customer != '' && state.rfcList[i].customer.fullname != payload.customer ) {
              objFilter[i] = '';
          }
      }
      if( typeof state.rfcList[i] === 'object' ) {
          if( payload.status != '' && state.rfcList[i].statusDescription != payload.status ) {
              objFilter[i] = '';
          }
      }
      if( typeof state.rfcList[i] === 'object' && state.rfcList[i].salesReturnNumber != undefined ) {
          if( state.rfcList[i].salesReturnNumber.indexOf(payload.srNumber) == -1 ) {
              console.log( 'somehow getting in here' );
              objFilter[i] = '';
          }
      } else if( payload.srNumber != '' ){
          objFilter[i] = '';
      }
      if( typeof state.rfcList[i] === 'object' && state.rfcList[i].creditNoteNumber != undefined ) {
          if( state.rfcList[i].creditNoteNumber.indexOf(payload.cnNumber) == -1 ) {
              objFilter[i] = '';
          }
      } else if( payload.cnNumber != '' ){
          objFilter[i] = '';
      }
      if( typeof state.rfcList[i] === 'object' && state.rfcList[i].number != undefined ) {
          if( payload.rfcNumber != '' && state.rfcList[i].number.indexOf(payload.rfcNumber) == -1 ) {
              objFilter[i] = '';
          }
      }
  }
 var tmpList = [];
  for( var n = 0; n < objFilter.length; n++ ) {
      if( typeof objFilter[n] === 'object' ) {
          tmpList.push( objFilter[n] );
      }
  }
  commit('fncFilterRfc', tmpList);*/
}

export const fncViewQuote = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/user/token', {id:objAuth.id}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured retrieving the user token', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    var urlData = {
      id: payload.id,
      customer_id: payload.customerId,
      customer_name: payload.customerName,
      delivery_address_id: payload.deliveryId,
      number: payload.number
    };
    var rfcUrl = window.location.protocol + process.env.DEV_RFC + "?route=open_rfc&token=" + data.token + "&data=" + JSON.stringify(urlData);
    var appWindow = window.open();
    if( appWindow == null ) {
      alert('HOW TO DISABLE THE POPUP BLOCKER IN CHROME\n\n1) Select OK\n2) Go to the far right of the address field of your browser and you will notice an icon that has a small red cross. Click on it and the message will read “Pop-ups blocked”\n3) Select the first option “Always allow pop-ups from http://myorder.ndtec.co.za then select Done');
    } else {
      appWindow.location.href = rfcUrl;
    }
  });
}

export const fncGetUserPricelists = ({commit, dispatch, state, rootState}, payload) => {
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    var objAuthorize = JSON.parse( rootState.objAuthorize );
    var pricelistDetails = {token: data.token, manufacturer_id: objAuthorize.manufacturer};
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: pricelistDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = {color: 'error', message: 'An error has occured retrieving the user pricelists', display: true};
        commit('setSnack', snackDetails);
      }).then(data => {
      var toReturn = [];
      if( data.length !== 0 ) {
        for (var n = 0; n < data.length; n++) {
          if (payload.pricelists.indexOf(data[n].pl_id) != '-1') {
            toReturn.push(data[n].pl_name);
          }
        }
      }
      return toReturn;
    });
  });
}

export const fncUpdateQuoteStatus = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var statusDetails = { type: 'quote_status_change', prev_value: payload.prevStatus, new_value: payload.status, user: objAuth.id, target: payload.quoteId, data: payload.additionalComments, manufacturer: objAuth.manufacturer, save: 'true' };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add', statusDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('hideModal');

    if( data.error != null ) {
      var snackDetails = {color: 'error', message: data.error, display: true};
    } else {
      var snackDetails = {color: 'success', message: 'The quote status was updated successfully', display: true};
    }

    commit('setSnack', snackDetails);
    commit('setRunAdd', false);

    if( data.error == null ) {
      if( window.location.hash.indexOf('quote-single-content?quote=') != -1 ) {
        setTimeout(function() {
          window.location.reload();
        },500)
      } else {
        setTimeout(function() {
          // location.reload();
          commit('fncUpdateStatusText', payload);
          commit('hideModal');
        },500)
      }
    }

  });
}

/*export const fncPopulateDiscountList = ({ commit, dispatch, state, rootState }, payload) => {
  if (state.quoteList.length == 0 || (payload != undefined && ( payload.refresh == true || payload.reload == true ))) {
    if (isNaN(payload.objFilters.authorizer) === true) {
      payload.objFilters.authorizer = '';
    }
    if (isNaN(payload.objFilters.requestor) === true) {
      payload.objFilters.requestor = '';
    }
    localStorage.setItem('discountStartDate', payload.objFilters.startDate);
    localStorage.setItem('discountEndDate', payload.objFilters.endDate);
    if (payload.objFilters.requestor !== undefined) {
      localStorage.setItem('discountRequestor', parseInt(payload.objFilters.requestor));
    }
    if (payload.objFilters.authorizer !== undefined) {
      localStorage.setItem('discountAuthoriser', parseInt(payload.objFilters.authorizer));
    }
    var objAuth = JSON.parse(rootState.objAuthorize);
    var discountDetails = { client_id: objAuth.manufacturer, start_date: payload.startDate, end_date: payload.endDate, requestor_id: payload.requestor, receiver_id: payload.authoriser };
    Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/audit/discountreport', { client_id: objAuth.manufacturer }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured retrieving the discount report', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      commit('fncSetColumns', finalSettings);
    });
  } else {
    var snackDetails = { color: 'success', message: 'The report columns have been updated successfully', display: true };
    commit('setSnack', snackDetails);
    commit('hideModal');
    setTimeout(function(){
      location.reload();
    }, 250)
      commit('fncPopulateDiscountList', data);
      commit('hideModal');
      if (payload != undefined && payload.reload == true) {
        var snackDetails = { color: 'success', message: 'Discount report reload successfull', display: true };
        commit('setSnack', snackDetails);
      }
    });
  }
}*/

export const fncSetQuoteDetails = ({ commit, dispatch, state, rootState }, payload) => {
  var quoteItem = payload.quote;

  var statusDetails = { id: payload.quoteId, hide_details: false, ordered: true };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getContent', statusDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to retrieve the quote details', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {

    var quoteDetails = data;
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getAttachments', statusDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = {color: 'error', message: 'An error occured while trying to retrieve the quote attachments', display: true};
        commit('setSnack', snackDetails);
      }).then(d => {
      var quoteAttachments = d;

      commit({
        type: 'fncSetSingleQuoteData',
        quoteDetails: quoteDetails,
        quoteAttachments: quoteAttachments,
        quote: quoteItem
      });

      if( payload.showPopup == null ) {
        if( payload.so == undefined || payload.so == null ) {
          var modalDetails = { title: 'Quote Details - ' + quoteItem.quote_no, component: 'modal-quote-details', mstate: true, params: { quoteDetails: quoteDetails, quoteAttachments: quoteAttachments, quote: quoteItem } };
          commit({
            type: 'setModal',
            details: modalDetails
          });
        } else {

          var objAuth = JSON.parse(rootState.objAuthorize);
          Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              var snackDetails = { color: 'error', message: 'An error has occured', display: true };
              commit('setSnack', snackDetails);
              console.log(error);
            }).then(sdata => {
            var tokenDetails = { token: sdata.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.order.pricelist };
            Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
              .then(response => {
                return response.json();
              }, error => {
                var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                commit('setSnack', snackDetails);
                console.log(error);
              }).then(sdt => {
              if ( sdt[0] ) {
                var vat = sdt[0].pl_tax_percentage / 100;
              } else {
                var vat = 0.15;
              }
              if( payload.doPrintInvoice == true ) {
                dispatch('fncPrintInvoice', payload.order );
              } else if( payload.doPrint == true ) {
                dispatch('fncPrintReportPdf', payload.order );
              } else {
                var modalDetails = { title: 'Purchase Order Report - ' + payload.order.quoteNo, component: 'modal-sales-order-report-details', mstate: true, params: { details: payload.order, vat: vat, quoteDetails: quoteDetails, quoteAttachments: quoteAttachments, quote: quoteItem } };
                commit({
                  type: 'setModal',
                  details: modalDetails
                });
              }

            });
          });

        }
      }



    });
  });
}

export const fncReorderStatus = ({ commit, dispatch, state, rootState }, payload) => {
  commit({
    type: 'fncResetStatus',
    newIndex: payload.end,
    oldIndex: payload.start
  });
  for (var k in state.statusList) {
    dispatch({
      type: 'fncUpdateStatus',
      settings: state.statusList[k],
      reload: false
    });
  }
  commit('fncSetStatus', state.statusList);
  dispatch('fncPopulateStatusList');
  var snackDetails = { color: 'success', message: 'The status order was updated successfully', display: true };
  commit('setSnack', snackDetails);
}

export const fncReorderRfcStatus = ({ commit, dispatch, state, rootState }, payload) => {
  commit({
    type: 'fncResetRfcStatus',
    newIndex: payload.end,
    oldIndex: payload.start
  });
  for (var k in state.rfcStatusList) {
    dispatch({
      type: 'fncEditRfcStatus',
      settings: state.rfcStatusList[k],
      reload: false
    });
  }
  commit('fncSetRfcStatus', state.statusList);
  dispatch({
    type: 'fncPopulateRfcStatusList',
    refresh: true
  })
  var snackDetails = { color: 'success', message: 'The rfc status order was updated successfully', display: true };
  commit('setSnack', snackDetails);
}

export const fncGenerateColumns = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var savedColumns = [];
  for ( var k in state.objQuoteSettings ) {
    savedColumns.push({ "id": state.objQuoteSettings[k].id, "label": state.objQuoteSettings[k].label, "checked": state.objQuoteSettings[k].checked, "width": state.objQuoteSettings[k].width });
  }
  var columnsDetails = { a: 'save_report_settings', id: objAuth.id, settings: JSON.stringify(savedColumns) };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Report.php', columnsDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote columns', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('hideModal');
    dispatch({
      type: 'fncPopulateQuoteList',
      refresh: true
    });
    var snackDetails = { color: 'success', message: 'The Quote Columns were updated successfully', display: true };
    commit('setSnack', snackDetails);
  });
}

export const fncQuoteSettings = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var quoteDetails = { id: payload.quoteId }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuote', quoteDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the quote details', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    var attDetails = { params: { quote: payload.quoteId } }
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getAttachments', attDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the quote attachments', display: true };
        commit('setSnack', snackDetails);
      }).then(d => {
      var attDetails = { params: { quote: payload.quoteId } }
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getSoAttachments', attDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the purchase order attachments', display: true };
          commit('setSnack', snackDetails);
        }).then(dd => {

        commit({
          type: 'fncSetQuoteSettings',
          quoteDetails: data,
          quoteAttachments: d,
          soAttachments: dd
        });

        if (payload.hasOwnProperty('vendorId')){
          var modalDetails = { title: 'Quote Attachments - ' + payload.quoteNo, component: 'modal-quote-settings', mstate: true, params: { quoteId: payload.quoteId, vendor: payload.vendorId  } };
        }
        else {
          var modalDetails = { title: 'Quote Attachments - ' + payload.quoteNo, component: 'modal-quote-settings', mstate: true, params: { quoteId: payload.quoteId, vendor: payload.data.vendorId, metaData: payload.data.metaData } };
        }
        commit({
          type: 'setModal',
          details: modalDetails
        });

      });
    });
  });
}

export const fncUpdateQuoteSettings = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var canExpire = state.quoteSettings.details.can_expire == true ? 1 : 0;
  var followUpDate = new Date(state.quoteSettings.details.follow_up_date + ' GMT').toISOString().slice(0, 10);
  var deliveryDate = new Date(state.quoteSettings.details.delivery_date + ' GMT').toISOString().slice(0, 10);
  var quoteDetails = {
    id: state.quoteSettings.details.id,
    status: state.quoteSettings.details.status,
    order_no: state.quoteSettings.details.order_no,
    plist: state.quoteSettings.details.pricelist,
    project: state.quoteSettings.details.project,
    delivery_address: state.quoteSettings.details.delivery_address,
    locked: state.quoteSettings.details.locked,
    changed: 0,
    follow_up_date: followUpDate,
    delivery_date: deliveryDate,
    sales_chance: state.quoteSettings.details.sales_chance,
    can_expire: canExpire
  }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=edit', quoteDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote details', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    if (data == 'success') {
      var snackDetails = { color: 'success', message: 'The Quote Settings were updated successfully', display: true };
      commit('setSnack', snackDetails);
      var auditDetails = {
        type: 'quote_save',
        user: objAuth.id,
        target: state.quoteSettings.details.id
      }
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add', auditDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the quote attachments', display: true };
          commit('setSnack', snackDetails);
        }).then(d => {
        commit('hideModal');
      });
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote details', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncUploadQuoteImage = ({ commit, dispatch, state, rootState }, payload) => {
  var uploadData = new FormData();
  var objAuth = JSON.parse(rootState.objAuthorize);
  var randInt = Math.floor((Math.random() * 9999) + 1000);
  uploadData.append('fileInput', payload.files, payload.files.name);

  uploadData.append('manufacturerID', objAuth.manufacturer);
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'QuoteAttachment.php', uploadData, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data.error != undefined ) {
      var snackDetails = { color: 'error', message: data.error, display: true };
      commit('setSnack', snackDetails);
    } else {
      var uploadImg = {
        params: {
          user: objAuth.id,
          path: window.location.protocol + process.env.API_ATTACHMENTS + data.file_name,
          original_filename: data.original_filename,
          quote: payload.quoteId,
          attachment_category: payload.attachmentCategory
        }
      }
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=addAttachment', uploadImg, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
          commit('setSnack', snackDetails);
        }).then(d => {
        var snackDetails = { color: 'success', message: 'The quote image was uploaded successfully', display: true };
        commit('setSnack', snackDetails);
        dispatch('fncGetQuoteFiles', payload.quoteId);
      });
    }
  });
}

export const fncUploadSurveyImage = ({ commit, dispatch, state, rootState }, payload) => {
  var uploadData = new FormData();

  var randInt = Math.floor((Math.random() * 9999) + 1000);
  uploadData.append('fileInput', payload.files, payload.files.name);

  if( window.location.href.indexOf('manufacturer=') != -1 ) {
    var arrUrl = window.location.href.split('manufacturer=');
    var arrManu = arrUrl[1].split('&');
    uploadData.append('manufacturerID', arrManu[0]);
  } else {
    var objAuth = JSON.parse(rootState.objAuthorize);
    uploadData.append('manufacturerID', objAuth.manufacturer);
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'QuoteAttachment.php', uploadData, rootState.headerDetails)
    .then(response => {
      console.log('Return JSON');
      console.log( response.json() );
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data.error != undefined ) {
      var snackDetails = { color: 'error', message: data.error, display: true };
      commit('setSnack', snackDetails);
    } else {
      commit('fncSetSurveyFiles', data);
      var snackDetails = { color: 'success', message: 'The survey image was uploaded successfully', display: true };
      commit('setSnack', snackDetails);
    }
  });
}



        /*.then(response => {
          return response.json();
        }, error => {
          commit('setSnack', snackDetails);
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
      });*/


// }

export const  fncPopulateSalesOrdersStatusList = ({ commit, dispatch, state, rootState }, payload) => {
  commit({
    type: 'fncPopulateSalesOrdersStatusList',
    status: state.statusList,
    passedRoot: rootState,
    rootState: rootState
  });
}

export const  fncPopulateSalesOrders = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var page = router.history.current.query.p;
  if( payload && payload.page && payload.page != null ) { page = payload.page; }
  state.soLoaded = false;
  var objAuth = JSON.parse(rootState.objAuthorize);
  var userDetails = { a: 'userVendor', id: objAuth.id };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: userDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(d => {

    var isFactory = false;
    if( objAuth.privileges.indexOf('VENDOR_FACTORY') != -1 ) { isFactory = false }

    if( objAuth.type == '6' && d[0].vendor != undefined ){
      var salesDetails = { manufacturer: objAuth.manufacturer, vendor: d[0].vendor, page: page, vendors: payload.vendors, status: payload.status, stores: payload.stores, soDates: payload.soDates, factory: isFactory, search: payload.search };
    } else {
      var salesDetails = { manufacturer: objAuth.manufacturer, page: page, vendors: payload.vendors, status: payload.status, stores: payload.stores, soDates: payload.soDates, factory: isFactory, search: payload.search };
    }
    state.salesOrderListFilter = [];
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=salesOrder', salesDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {

      var vendorDetails = { a: 'getAll', manu: objAuth.manufacturer };
      Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: vendorDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(dd => {
        var userDetails = { a: 'userVendor', id: objAuth.id };
        Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: userDetails }, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(d => {

          var quoteDetails = { a: 'getManufacturerAudits', manufacturer: objAuth.manufacturer };
          Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: quoteDetails }, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              console.log(error);
            }).then(qd => {

            commit('fncSetManufacturerAudits', qd);

            commit({
              type: 'fncSetSalesOrder',
              sales: data,
              user: objAuth,
              vendors: dd,
              userVendor: d,
              userType: objAuth.type,
              status: state.statusList,
              passedRoot: rootState,
              rootState: rootState
            });

            if ( payload == true ) {
              var snackDetails = { color: 'success', message: 'Purchase Order Report reload successfull', display: true };
              commit('setSnack', snackDetails);
            }
          });

        });
      });
      /* Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: vendorDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(dd => {
        commit({
          type: 'fncSetSalesOrder',
          sales: data,
          user: objAuth,
          vendors: dd,
          userVendor: d,
          userType: objAuth.type,
          status: state.statusList,
          rootState: rootState,
          passedRoot: rootState
        });
        if ( payload == true ) {
          var snackDetails = { color: 'success', message: 'Purchase Order Report reload successfull', display: true };
        }*/
      /*var userDetails = { a: 'userVendor', id: objAuth.id };
      Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: userDetails }, rootState.headerDetails)
        }).then(d => {
        commit({
          type: 'fncSetSalesOrder',
          sales: data,
          user: objAuth,
          vendors: dd,
          userVendor: d,
          userType: objAuth.type,
          status: state.statusList
        });
        if ( payload == true ) {
          var snackDetails = { color: 'success', message: 'Purchase Order Report reload successfull', display: true };
          commit('setSnack', snackDetails);
        }
      });*/
      // });
    });
  });
};

export const fncPopulateSalesOrdersFilters = ({ commit, dispatch, state, rootState }, payload) => {

  var page = -1;
  var objAuth = JSON.parse(rootState.objAuthorize);
  var userDetails = { a: 'userVendor', id: objAuth.id };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: userDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(d => {

    var isFactory = false;
    if( objAuth.privileges.indexOf('VENDOR_FACTORY') != -1 ) { isFactory = true }

    if( objAuth.type == '6' && d[0].vendor != undefined ){
      var salesDetails = { manufacturer: objAuth.manufacturer, vendor: d[0].vendor, page: page, vendors: payload.vendors, status: payload.status, stores: payload.stores, soDates: payload.soDates, factory: isFactory };
    } else {
      var salesDetails = { manufacturer: objAuth.manufacturer, page: page, vendors: payload.vendors, status: payload.status, stores: payload.stores, soDates: payload.soDates, factory: isFactory };
    }

    state.salesOrderListFilter = [];
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=salesOrder', salesDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {

      commit( 'setSoFilters', data );
      commit('fncFilterNeedsReloadSo', false);

    });
  });
};

export const fncRemoveSurveyAttachment = ({ commit, dispatch, state, rootState }, payload) => {
  commit('fncSpliceSurveyImage', payload.attachmentId);
  var snackDetails = { color: 'success', message: 'The survey image was removed successfully', display: true };
  commit('setSnack', snackDetails);
}

export const fncPopulateStock = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = { manufacturer: objAuth.manufacturer };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=get_stock', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to upload the stock file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('fncSetStockAvailability', data.stock_availability);
  });
}

export const fncRemoveStock = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = { manufacturer: objAuth.manufacturer };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=delete_stock', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to remove the stock file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    if( data == true ) {
      commit('fncEmptyStock');
      dispatch('fncPopulateStock');
      var snackDetails = { color: 'success', message: 'The stock file has been removed succesfully', display: true };
      commit('setSnack', snackDetails);
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to remove the stock file', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncUploadStockAvailibility = ({ commit, dispatch, state, rootState }, payload) => {
  var uploadData = new FormData();
  var objAuth = JSON.parse(rootState.objAuthorize);
  var randInt = Math.floor((Math.random() * 9999) + 1000);
  uploadData.append('fileInput', payload.files, payload.files.name);
  //uploadData.append('allowed_types', objAuth.allowed_file_types);
  uploadData.append('manufacturerID', objAuth.manufacturer);
  uploadData.append('max_upload_size', objAuth.max_upload_size);
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'QuoteAttachment.php', uploadData, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    var stockFile = window.location.protocol + process.env.API_ATTACHMENTS + data.file_name;
    var uploadFile = {
      params: {
        path: window.location.protocol + process.env.DEV_ENDPOINT + process.env.API_ATTACHMENTS + data.file_name,
        manufacturer: objAuth.manufacturer
      }
    };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=add_stock', uploadFile, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
        commit('setSnack', snackDetails);
      }).then(d => {
      commit('fncEmptyStock');
      var snackDetails = { color: 'success', message: 'The stock file was uploaded successfully', display: true };
      commit('setSnack', snackDetails);
      dispatch('fncPopulateStock');
    });
  });
}

export const fncAvailableReps = ({ commit, dispatch, state, rootState }, payload) => {
  var repDetails = {
    a: 'get_lu_user_list',
    params: {
      user: payload,
      uu_type: 1,
      lu_type: 1,
      link_dir: 2,
      deleted: 0
    }
  };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'User.php', { params: repDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the rep list', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('fncSetAvailableReps', data);
  });
}

export const fncQuoteLinkUser = ({ commit, dispatch, state, rootState }, payload) => {
  var userDetails = {
    params: {
      parent: payload.parent,
      child: payload.child,
      linkType: 'User'
    }
  }
  if (payload.link == true) {
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=link_user', userDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured updating the userlink', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      commit('fncEmptySetAvailableReps');
      dispatch('fncAvailableReps', payload.child);
      var snackDetails = { color: 'success', message: 'The user has been linked successfully', display: true };
      commit('setSnack', snackDetails);
    });
  } else {
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=unlink_user', userDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured updating the userlink', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      commit('fncEmptySetAvailableReps');
      dispatch('fncAvailableReps', payload.child);
      var snackDetails = { color: 'success', message: 'The user has been unlinked successfully', display: true };
      commit('setSnack', snackDetails);
    });
  }
}

export const fncQuoteLinkUserSingle = ({ commit, dispatch, state, rootState }, payload) => {
  var params = {
    link: payload.link,
    user: payload.user,
    quote: payload.quote
  };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=update_quote_user', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured updating the quote/user link', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    if( data == true ) {
      if( payload.link == true ) {
        var snackDetails = { color: 'success', message: 'The user has been linked to the quote successfully', display: true };
      } else {
        var snackDetails = { color: 'success', message: 'The user has been unlinked from the quote successfully', display: true };
      }
      commit('setSnack', snackDetails);
    } else {
      var snackDetails = { color: 'success', message: 'The user could not be linked to the quote', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncPopulateQuoteUsers = ({ commit, dispatch, state, rootState }, payload) => {
  var params = {
    quote: payload.quote
  };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=get_quote_users', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured updating the quote/user link', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit( 'fncSetQuoteUsers', data );
  });
}

export const fncResetColumns = ({ commit, dispatch, state, rootState }, payload) => {

  if( payload.noSort != null ) {

    var quoteSettings = state.objQuoteSettings;
    if( payload.newSettings.length > 0 ) {
      quoteSettings = payload.newSettings;
    }

    commit('fncSetColumnsSorted', true);

    var objAuth = JSON.parse(rootState.objAuthorize);
    var newSettings = [];
    var newOrder = 1;
    for( var s in quoteSettings ) {
      var p = quoteSettings[s];
      p.order = newOrder;
      newSettings.push(p);
      newOrder++;
    }

    var checkedColumns = [];
    var uncheckedColumns = [];

    for( var n in newSettings ) {
      if( newSettings[n].checked == 'false' || newSettings[n].checked == false ) {
        uncheckedColumns.push( newSettings[n] );
      } else {
        checkedColumns.push( newSettings[n] );
      }
    }

    var finalSettings = [];
    var newOrder = 1;
    for( var c in checkedColumns ) {
      checkedColumns[c].order = newOrder;
      finalSettings.push(checkedColumns[c]);
      newOrder++;
    }
    for( var c in uncheckedColumns ) {
      uncheckedColumns[c].order = newOrder;
      finalSettings.push(uncheckedColumns[c]);
      newOrder++;
    }

    commit('setQuoteSettings', finalSettings);

    // Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)

    var columnsDetails = { a: 'save_report_settings', id: objAuth.id, settings: JSON.stringify(newSettings) };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Report.php', columnsDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote columns', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      commit('fncSetColumns', finalSettings);
    });
  } else if( payload.splice == null ) {
    var objAuth = JSON.parse(rootState.objAuthorize);

    state.objQuoteSettings.splice(payload.end, 0, state.objQuoteSettings.splice(payload.start, 1)[0]);

    var newSettings = [];
    var newOrder = 1;
    for( var s in state.objQuoteSettings ) {
      var p = state.objQuoteSettings[s];
      p.order = newOrder;
      newSettings.push(p);
      newOrder++;
    }

    var checkedColumns = [];
    var uncheckedColumns = [];

    for( var n in newSettings ) {
      if( newSettings[n].checked == 'false' || newSettings[n].checked == false ) {
        uncheckedColumns.push( newSettings[n] );
      } else {
        checkedColumns.push( newSettings[n] );
      }
    }

    var finalSettings = [];
    var newOrder = 1;
    for( var c in checkedColumns ) {
      checkedColumns[c].order = newOrder;
      finalSettings.push(checkedColumns[c]);
      newOrder++;
    }
    for( var c in uncheckedColumns ) {
      uncheckedColumns[c].order = newOrder;
      finalSettings.push(uncheckedColumns[c]);
      newOrder++;
    }

    commit('setQuoteSettings', finalSettings);
    var columnsDetails = { a: 'save_report_settings', id: objAuth.id, settings: JSON.stringify(newSettings) };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Report.php', columnsDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote columns', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      commit('fncSetColumns', finalSettings);
    });
  } else {
    /*dispatch({
      type: 'fncPopulateQuoteList',
      refresh: true
    });*/
    var snackDetails = { color: 'success', message: 'The report columns have been updated successfully', display: true };
    commit('setSnack', snackDetails);
    commit('hideModal');
    setTimeout(function(){
      location.reload();
    }, 1000)
  }

}

export const fncQuoteColumns = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var columnDetails = { id: objAuth.id };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Report.php?a=get_report_settings', { params: columnDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the Quote list', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var objSettings = JSON.parse(data.report_settings);

    if( payload == false  ) {
      commit({
        type: 'setObjQuoteSettings',
        columns: objSettings,
        manu: objAuth.manufacturer
      });
    } else {
      commit('setObjQuoteSettings', objSettings);
      var snackDetails = { color: 'success', message: 'The report columns have been updated successfully', display: true };
      commit('setSnack', snackDetails);
    }
  });
};

export const fncRemoveQuoteAttachment = ({ commit, dispatch, state, rootState }, payload) => {
  var attDetails = { params: { attachment_id: payload.attachmentId } };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=deleteAttachment', attDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote columns', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    var snackDetails = { color: 'success', message: 'The quote image was removed successfully', display: true };
    commit('setSnack', snackDetails);
    dispatch('fncGetQuoteFiles', payload.quoteId);
  });
}

export const fncMarkPaid = ({ commit, dispatch, state, rootState }, payload) => {
  var attDetails = { params: { attachment_id: payload.attachmentId, is_paid: payload.is_paid } };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=mark-paid', attDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote columns', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    var snackDetails = { color: 'success', message: 'The quote image was marked as paid successfully', display: true };
    commit('setSnack', snackDetails);

    if (payload.hasOwnProperty('isQuoteReport')){
      dispatch('fncQuoteSettings', payload);
    }
    else{
      dispatch('fncSoSettings', payload.quoteId);
    }
  });
}

export const fncGetQuoteFiles = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var quoteDetails = { id: payload }
  var attDetails = { params: { quote: payload } }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getAttachments', attDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the quote attachments', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('fncSetQuoteAttachments', data);
    commit({
      type: 'fncSetAttachmentActive',
      count: data.length,
      quote: payload
    })
  });
}

export const fncCheckForex = ({ commit, dispatch, state, rootState }, payload) => {
  var currencyType = payload.currencyOverride;
  if (payload.currencyOverride == null) {
    currencyType = 'ZAR';
  }

  var forexDetails = {
    access_key: '41442dfe4505e6bd8d7217d927bf9a44',
    source: currencyType,
    currencies: payload.currency,
    amount: 1
  }
  Vue.http.get('http://apilayer.net/api/live', { params: forexDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the Forex currency data', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('fncSetForex', data);
  });
  /*var currencyType = payload.currencyOverride;
  if (payload.currencyOverride == null) {
    currencyType = 'USD';
  }
  var forexDetails = {
    access_key: '41442dfe4505e6bd8d7217d927bf9a44',
    source: currencyType,
    currencies: payload.currency,
        amount: 1
  }
  Vue.http.get('http://apilayer.net/api/live', { params: forexDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the Forex currency data', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
      commit('fncSetForex', data);
    });*/
};

export const fncUpdateForex = ({ commit, dispatch, state, rootState }, payload) => {
  var forexDetails = {
    params: {
      quote_id: payload.quoteId,
      override_currency_sym: payload.overrideCurrencySym,
      override_currency_code: payload.overrideCurrencyCode,
      override_exchange_rate: payload.overrideExchangeRate,
      override_tax_label: payload.overrideTaxLabel,
      override_tax_rate: payload.overrideTaxRate
    }
  }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=update_forex', forexDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote forex values', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit('hideModal');
    commit('fncEmptyQuoteList');
    var snackDetails = { color: 'success', message: 'The quote forex details was updated successfully', display: true };
    commit('setSnack', snackDetails);
    dispatch({
      type: 'fncPopulateQuoteList',
      refresh: true
    });
  });
}

export const fncViewAppQuote = ({ commit, dispatch, state, rootState }, payload) => {
  var statusName = payload.status;
  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = { manufacturer: objAuth.manufacturer };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=get_quote_status', { params: params }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the RFC list', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    var locked = false;
    for (var n in data) {
      if (data[n].description === statusName) {
        if (data[n].is_lock == 'Yes' ) {
          locked = true
        }
      }
    }
    if ( locked != true ) {
      Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/user/token', { id: objAuth.id }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured retrieving the user token', display: true };
          commit('setSnack', snackDetails);
        }).then(data => {
        var urlData = {
          id: payload.id,
          customer_id: payload.customer_id,
          customer_name: payload.customer_name,
          manufacturer: objAuth.manufacturer,
        };
        var appUrl = payload.app_url + "/reroute.php?token=" + data.token + "&route=open_quote&data=" + JSON.stringify(urlData);
        var appWindow = window.open();
        if (appWindow == null) {
          alert('HOW TO DISABLE THE POPUP BLOCKER IN CHROME\n\n1) Select OK\n2) Go to the far right of the address field of your browser and you will notice an icon that has a small red cross. Click on it and the message will read “Pop-ups blocked”\n3) Select the first option “Always allow pop-ups from http://myorder.ndtec.co.za then select Done');
        } else {
          appWindow.location.href = appUrl;
        }
      });
    }

  });
}

export const fncPopulateSpecList = ({ commit, dispatch, state, rootState }, payload) => {

}

export const fncPopulateSpecStatusList = ({ commit, dispatch, state, rootState }, payload) => {

}

export const fncDeleteSpecStatus = ({ commit, dispatch, state, rootState }, payload) => {

}

export const fncQuoteAction = ({ commit, dispatch, state, rootState }, payload) => {

}

/*export const fncPopulateSalesOrders = ({ commit, dispatch, state, rootState }, payload) => {
  state.soLoaded = false;
  var objAuth = JSON.parse(rootState.objAuthorize);
  var salesDetails = { manufacturer: objAuth.manufacturer };
  state.salesOrderListFilter = [];
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=salesOrder', salesDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    var vendorDetails = { a: 'getAll', manu: objAuth.manufacturer };
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: vendorDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(dd => {
      var userDetails = { a: 'userVendor', id: objAuth.id };
      Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: userDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(d => {

                      var objAuth = JSON.parse(rootState.objAuthorize);
                      Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
                        .then(response => {
                          return response.json();
                        }, error => {
                          var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                          commit('setSnack', snackDetails);
                          console.log(error);
                        }).then(sdata => {
                        var tokenDetails = { token: sdata.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.order.pricelist };
                        Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
                          .then(response => {
                            return response.json();
                          }, error => {
                            var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                            commit('setSnack', snackDetails);
                            console.log(error);
                          }).then(sdt => {
                          if ( sdt[0] ) {
                            var vat = sdt[0].pl_tax_percentage / 100;
                          } else {
                            var vat = 0.15;
                          }
                          if( payload.doPrintInvoice == true ) {
                            dispatch('fncPrintInvoice', payload.order );
                          } else if( payload.doPrint == true ) {
                            dispatch('fncPrintReportPdf', payload.order );
                          } else {
                            var modalDetails = { title: 'Purchase Order Report - ' + payload.order.quoteNo, component: 'modal-sales-order-report-details', mstate: true, params: { details: payload.order, vat: vat, quoteDetails: quoteDetails, quoteAttachments: quoteAttachments, quote: quoteItem } };
                            commit({
                              type: 'setModal',
                              details: modalDetails
                            });
                          }
        var quoteDetails = { a: 'getManufacturerAudits', manufacturer: objAuth.manufacturer };
        Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: quoteDetails }, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(d => {
          }).then(qd => {

          commit('fncSetManufacturerAudits', qd);

          commit({
            type: 'fncSetSalesOrder',
            sales: data,
            user: objAuth,
            vendors: dd,
            userVendor: d,
            userType: objAuth.type,
            status: state.statusList,
            passedRoot: rootState
          });

          if ( payload == true ) {
            var snackDetails = { color: 'success', message: 'Purchase Order Report reload successfull', display: true };
            commit('setSnack', snackDetails);
          }
        });

      });
    });
  });
}*/

export const fncUpdateReportStatus = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);

  console.log('RUNNING RUNNING RUNNING RUNNING');

  var quoteDetails = { id: payload.quoteId }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuote', quoteDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the quote details', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    var objAuth = JSON.parse(rootState.objAuthorize);
    var rankOrder = objAuth.quote_status_rank_order;

    var currentQuoteStatus = data.status;
    var currentQuoteStatusLevel = 0;
    var updatedReportStatus = '';
    var updatedReportStatusLevel = 0;
    var statusArray = [];

    for (var s in state.statusList) {
      statusArray[state.statusList[s].id] = state.statusList[s].order;
      if (state.statusList[s].description == currentQuoteStatus) {
        currentQuoteStatusLevel = state.statusList[s].order;
      }
      if (state.statusList[s].id == payload.statusId) {
        updatedReportStatus = state.statusList[s].description;
        updatedReportStatusLevel = state.statusList[s].order;
      }
    }

    var lowestStatus = 0;
    // var lowestStatus = currentQuoteStatusLevel;

    var count = 0;
    for (var q in state.salesOrderListAll) {
      if (state.salesOrderListAll[q].quoteId == payload.quoteId && state.salesOrderListAll[q].vendor != payload.vendorId) {
        if (lowestStatus < statusArray[state.salesOrderListAll[q].items[0].statusId]) {
          lowestStatus = statusArray[state.salesOrderListAll[q].items[0].statusId];
        }
        count++;
      }
    }

    if (count == 0) {
      for (var q in state.salesOrderListAll) {
        if (state.salesOrderListAll[q].quoteId == payload.quoteId) {
          if (lowestStatus < statusArray[state.salesOrderListAll[q].items[0].statusId]) {
            lowestStatus = statusArray[state.salesOrderListAll[q].items[0].statusId];
          }
          count++;
        }
      }
    }

    if (updatedReportStatusLevel < lowestStatus) {
      lowestStatus = updatedReportStatusLevel;
    }

    var objAuth = JSON.parse(rootState.objAuthorize);

    var comment = 'Changed from the Vendor Screen';

    if( payload && payload.comment && payload.comment != '' ) {
      comment = 'Vendor: ' + payload.comment;
    }

    if ( rankOrder = '1' && updatedReportStatusLevel > currentQuoteStatusLevel ) {

      var statusDetails = { type: 'quote_status_change', prev_value: currentQuoteStatus, new_value: updatedReportStatus, user: objAuth.id, target: payload.quoteId, data: comment, save: 'true' };

      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add', statusDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote status', display: true };
          commit('setSnack', snackDetails);
        }).then(data => {
        var repStatusDetails = { quoteId: payload.quoteId, comment: payload.comment, statusId: payload.statusId, vendorId: payload.vendorId, createdBy: objAuth.id };

        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=updateOrderStatus', repStatusDetails, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(data => {
          // dispatch('fncPopulateSalesOrders');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
          commit('hideModal');
          var snackDetails = { color: 'success', message: 'The status has been updated successfully', display: true };
          commit('setSnack', snackDetails);
          setTimeout(function(){
            window.location.reload();
          }, 500);
        });
      });

    } else if (lowestStatus != currentQuoteStatusLevel && lowestStatus != 0) {

      var newStatus = '';
      for (var s in state.statusList) {
        if (state.statusList[s].order == lowestStatus) {
          newStatus = state.statusList[s].description;
        }
      }
      var statusDetails = { type: 'quote_status_change', prev_value: currentQuoteStatus, new_value: newStatus, user: objAuth.id, target: payload.quoteId, data: comment, save: 'true' };

      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add', statusDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote status', display: true };
          commit('setSnack', snackDetails);
        }).then(data => {
        var repStatusDetails = { quoteId: payload.quoteId, comment: payload.comment, statusId: payload.statusId, vendorId: payload.vendorId, createdBy: objAuth.id };
        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=updateOrderStatus', repStatusDetails, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(data => {
          //dispatch('fncPopulateSalesOrders');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
          commit('hideModal');
          var snackDetails = { color: 'success', message: 'The status has been updated successfully', display: true };
          commit('setSnack', snackDetails);
          setTimeout(function(){
            window.location.reload();
          }, 500);
        });
      });
    } else {
      var repStatusDetails = { quoteId: payload.quoteId, comment: payload.comment, statusId: payload.statusId, vendorId: payload.vendorId, createdBy: objAuth.id };

      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=updateOrderStatus', repStatusDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(data => {
        // dispatch('fncPopulateSalesOrders');
        setTimeout(function(){
          window.location.reload();
        }, 1000);
        commit('hideModal');
        var snackDetails = { color: 'success', message: 'The status has been updated successfully', display: true };
        commit('setSnack', snackDetails);
        setTimeout(function(){
          window.location.reload();
        }, 500);
      });
    }

  });

}

export const fncGetSalesOrderHistory = ({ commit, dispatch, state, rootState }, payload) => {
  var statusDetails = { quote: payload.quote, vendor: payload.vendor };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getOrderStatusHistory', statusDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    var statusses = {};
    var previousStatus = 'N/A';

    if(state.statusList.length != 0 ) {
      state.statusList[0].description;
    }

    var statusHistory = [];

    for ( var s in state.statusList ) {
      statusses[state.statusList[s].id] = state.statusList[s].description;
    }

    for (var s in data) {
      var fullname = 'Automated';
      if ( data[s].name != null ) {
        fullname = data[s].name + ' ' + data[s].surname;
      }
      var historyDate = data[s].created.substr(0,10);
      var pushStatus = { statusFrom: previousStatus, statusTo: data[s].statusName, date: historyDate, comment: data[s].description, fullname: fullname }
      statusHistory.push( pushStatus );
      previousStatus = data[s].statusName;
    }

    var modalDetails = { title: 'Purchase Order Report Status History - ' + payload.quoteNo, component: 'modal-quote-history-order', mstate: true, params: { history: statusHistory } };
    commit({
      type: 'setModal',
      details: modalDetails
    });

  });
}

export const fncViewSalesOrder = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.order.pricelist };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {
      if ( dt[0] ) {
        var vat = dt[0].pl_tax_percentage / 100;
      } else {
        var vat = 0.15;
      }
      var modalDetails = { title: 'Purchase Order Report - ' + payload.order.quoteNo, component: 'modal-sales-order-report-details', mstate: true, params: { details: payload.order, vat: vat } };
      commit({
        type: 'setModal',
        details: modalDetails
      });

    });
  });
}

export const fncDownloadReportCsv = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.data.pricelist };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {

      if (dt.error) {
        var snackDetails = { color: 'error', message: 'Error: ' + dt.error, display: true };
        commit('setSnack', snackDetails);
      } else {

        if (dt[0]) {
          var vat = dt[0].pl_tax_percentage / 100;
        } else {
          var vat = 0.15;
        }

        var vendorName = 'N/A';
        for (var v in payload.vendorList) {
          if (payload.vendorList[v].id == payload.data.vendor) {
            vendorName = payload.vendorList[v].name;
          }
        }

        var toReturn = 'Vendor, ';
        toReturn += vendorName + "\n";

        if (objAuth.type != '6' && payload.privileges.indexOf('VENDOR_HIDE_DETAILS') == -1) {
          toReturn += 'Quote Date, ';
          toReturn += payload.data.date + "\n";
          toReturn += 'Customer, ';
          toReturn += payload.data.fullname + "\n";
          toReturn += 'Email, ';
          toReturn += payload.data.email + "\n";
          toReturn += 'Contact Number, ';
          toReturn += payload.data.contactnum + "\n";
          toReturn += 'Quote No, ';
          toReturn += payload.data.quoteNo + "\n\n";
        } else {
          toReturn += 'Quote Date, ';
          toReturn += payload.data.date + "\n";
          toReturn += 'Quote No, ';
          toReturn += payload.data.quoteNo + "\n\n";
        }

        if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
          toReturn += 'ITEM, QUANTITY, UOM, TOTAL' + "\n";
        } else {
          toReturn += 'ITEM, QUANTITY, UOM' + "\n";
        }

        for (var item in payload.data.items) {
          toReturn += payload.data.items[item].itemName + ',';
          toReturn += payload.data.items[item].quantity + ',';
          toReturn += payload.data.items[item].uom + ',';

          if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
            if (payload.privileges.indexOf('VENDOR_COST_PRICE') != -1) {
              var lineData = JSON.parse(payload.data.items[item].line_item_data);
              if (lineData.cost_price != null) {
                var total = parseFloat(lineData.cost_price) * payload.data.items[item].quantity
              } else {
                var total = payload.data.items[item].price * payload.data.items[item].quantity
              }

            } else if (payload.privileges.indexOf('VENDOR_FULL_PRICE') != -1) {
              var total = payload.data.items[item].price * payload.data.items[item].quantity
            }

            toReturn += parseFloat(total).toFixed(2) + ',';
          }


          /*var itemVat = total * vat;
          toReturn += parseFloat(itemVat).toFixed(2) + ',';

          var bigTotal = total + itemVat;
          toReturn += parseFloat(bigTotal).toFixed(2) + ',';*/

          toReturn += "\n";

        }

        for (var item in payload.data.items) {
          if (payload.data.items[item].linked_props != '' || payload.data.items.length == 1) {
            toReturn += "\n\n";

            var table = document.createElement('table');
            table.innerHTML = payload.data.items[item].spec;
            for (var i = 0, row; row = table.rows[i]; i++) {
              if ( i != 0 ) {
                toReturn += "\n";
              }
              for (var j = 0, col; col = row.cells[j]; j++) {
                var cellData = row.cells[j].innerHTML;
                cellData = cellData.replace(/<(?:.|\n)*?>/gm, '');
                toReturn += cellData + ','
              }
            }
          }
        }

        var rows = { rows: toReturn };

        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=create_excel_so', rows, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            var snackDetails = { color: 'error', message: 'An error occured while trying to create the excel file', display: true };
            commit('setSnack', snackDetails);
          }).then(data => {

          if( data.success == true ) {
            var reportDownload = document.createElement('a');
            reportDownload.setAttribute('href', data.file);
            reportDownload.setAttribute('download', 'so-report.xlsx');
            reportDownload.click();
          } else {
            var snackDetails = { color: 'error', message: 'An error occured while trying to create the excel file', display: true };
            commit('setSnack', snackDetails);
          }

        });

        /*var reportDownload = document.createElement('a');
        reportDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(toReturn));
        reportDownload.setAttribute('download', 'SO-'+payload.data.quoteNo+'.csv');
        reportDownload.click();*/

      }

    });
  });
}

export const fncDownloadReportPdf = ({ commit, dispatch, state, rootState }, payload) => {

  var html = "<html><head><style> .installation { border-collapse: collapse !important; width: 100% !important;} .installation th { font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .installation td { text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .glasscuttingSpecs { border-collapse: collapse !important; width: 70% !important; } .glasscuttingSpecs th { width: 50% !important;font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .glasscuttingSpecs td { width: 50% !important;text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .specialordertable { border-collapse: collapse !important; width: 50% !important; } .specialordertable td.celltitle { text-align: left !important; width: 50% !important; font-size: 12px !important; background: #92e273 !important; padding: 10px !important; } .specialordertable td { width: 50% !important; text-align: left !important; font-size: 12px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .blindOrderSpecs { max-width: 100px !important; min-width: 100px !important; font-size:8px !important; color: #7f7e7e !important } .so-total-row, .so-total-label, .so-total { font-size: 10px !important; } h2 { font-size: 20px; font-weight: normal; padding-bottom: 0px; margin-bottom: 0px; padding-top: 20px; } .so-header { font-size: 8px; } .so-description, .so-qty, .so-price, .so-uom { font-size: 8px !important; } table.blindOrder { font-size: 8px !important; color: #7f7e7e !important; border: 1px solid #eee!important; width: 100% !important; margin-top: 25px; } table.blindOrder tr { width: 100% !important; } table.blindOrder th { font-size: 8px !important; text-align: left!important; padding: 10px !important; width: 25% !important; } table.blindOrder .header { background: #f1f1f1!important; padding: 10px !important; font-size: 10px !important; font-weight: 900!important; } table.blindOrder th.mainheader { font-size: 10px !important; padding: 10px !important; } table.blindOrder td { padding: 0 10px 10px !important; vertical-align: top!important; text-align: left!important; width: 25 % !important; } table { width: 100px; max-width: 540px; min-width: 540px; margin: 0 auto; } body { font-family: helvetica, sans-serif; } table.so-lineitems {margin-top: 5px; } table.so-lineitems th {border-bottom: 1px solid #ddd; } table.so-lineitems td {padding: 10px 0; font-size: 12px; } td.so-qty {text-align: right; padding-right: 5px; } td.so-price {text-align: right; } td.so-total-label {font-weight: bold; font-size: 10px; } td.so-total {text-align: right; font-weight: bold; font-size: 10px; border-top: 1px solid #000; border-bottom: 4px double #000; } .so-qty-header, .so-price-header {text-align:right;  font-size: 10px; } .so-uom-header {font-size: 0; } .so-description-header {text-align: left; font-size: 10px; }</style></head><body>";

  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.pricelist };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {
      if (dt[0]) {
        var vat = dt[0].pl_tax_percentage / 100;
      } else {
        var vat = 0.15;
      }
      var salesOrderNumber = payload.items[0].sales_order_number;
      html += '<table class="so-header">';
      html += '<tr>';
      html += '<td width="50%"><img src="' + window.location.protocol + process.env.MYSPEC_ENDPOINT + 'profile.php?t=/' + objAuth.myspec_url + '&p=' + objAuth.header_logo_img +'" /></td>';
      if (objAuth.privileges.indexOf('VENDOR_HIDE_DETAILS')) {
        html += '<td width="50%" style="text-align: right;">';
        html += '<strong>Quote Date:</strong> ' + payload.date + '<br />';
        html += '<strong>Vendor:</strong> ' + payload.vendorName + '<br />';
        html += '<strong>Quote Number:</strong> ' + payload.quoteNo + '<br />';
        if( salesOrderNumber != undefined && salesOrderNumber != '' && salesOrderNumber != null && salesOrderNumber != 0 ) {
          html += '<strong>Sales Order Number:</strong> ' + salesOrderNumber + '<br />';
        }
        html += '</td > ';
      } else {
        html += '<td width="50%" style="text-align: right;">';
        html += '<strong>Quote Date:</strong> ' + payload.date + '<br />';
        html += '<strong>Vendor:</strong> ' + payload.vendorName + '<br />';
        html += '<strong>Quote Number:</strong> ' + payload.quoteNo + '<br />';
        html += '<strong>Customer Name:</strong> ' + payload.fullname + '<br />';
        html += '<strong>Customer Email:</strong> ' + payload.email + '<br />';
        html += '<strong>Customer Contact:</strong> ' + payload.contactnum + '<br />';
        if( salesOrderNumber != undefined && salesOrderNumber != '' && salesOrderNumber != null && salesOrderNumber != 0 ) {
          html += '<strong>Sales Order Number:</strong> ' + salesOrderNumber + '<br />';
        }
        html += '</td > ';
      }
      html += '</tr>';
      html += '<tr>';
      html += '<td colspan="2"><h2>Purchase Order</h2></td>';
      html += '</tr>';
      html += '</table>';

      if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
        html += '<table class="so-lineitems">';
        html += '<tr>';
        html += '<th class="so-description-header" width="60%">Description</th>';
        html += '<th class="so-qty-header" width="20%">Quantity</th>';
        html += '<th class="so-uom-header" width="20%">UOM</th>';
        html += '</tr>';
      } else {
        html += '<table class="so-lineitems">';
        html += '<tr>';
        html += '<th class="so-description-header" width="40%">Description</th>';
        html += '<th class="so-qty-header" width="20%">Quantity</th>';
        html += '<th class="so-uom-header" width="20%">UOM</th>';
        html += '<th class="so-price-header" width="20%">Price</th>';
        html += '</tr>';
      }

      var totalPrice = 0;

      for (var i in payload.items) {
        var lineData = JSON.parse(payload.items[i].line_item_data);
        var cost = 0;
        if (lineData.cost_price != null) {
          cost = lineData.cost_price
        } else {
          cost = payload.items[i].price;
        }
        totalPrice += parseFloat(parseInt(payload.items[i].quantity) * parseFloat(cost));

        if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
          html += '<tr>';
          html += '<td class="so-description" width="60%">' + payload.items[i].itemName + '</td>';
          html += '<td class="so-qty" width="20%">' + payload.items[i].quantity + '</td>';
          html += '<td class="so-uom" width="20%">' + payload.items[i].uom + '</td>';
          html += '</tr>';
        } else {

          cost = parseFloat( cost * payload.items[i].quantity ).toFixed(2);

          html += '<tr>';
          html += '<td class="so-description" width="40%">' + payload.items[i].itemName + '</td>';
          html += '<td class="so-qty" width="20%">' + payload.items[i].quantity + '</td>';
          html += '<td class="so-uom" width="20%">' + payload.items[i].uom + '</td>';
          html += '<td class="so-price" width="20%">R' + cost.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
          html += '</tr>';
        }
      }

      if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
        html += '<tr class="so-total-row">';
        html += '<td class="so-total-label" style="text-align: right;" colspan="3"width="80%">Total: </td>';
        html += '<td class="so-total" width="20%">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
        html += '</tr>';
        html += '</table>';
      } else {
        html += '</table>';
      }

      var checkFourSure = JSON.parse( payload.items[0].line_item_data );

      if( checkFourSure.installation_customer_first_name != null ) {

        var lineDataCount = Object.keys(checkFourSure).length;
        lineDataCount = lineDataCount - 25;
        var productCount = Math.floor( lineDataCount / 6 );

        html += '<div v-if="lineData.installation_customer_first_name != null" class="lineItemDetails">';
        html += '          <h2 style="font-size:14px; padding-left:20px !important;padding-bottom:10px !important;">Installation Details</h2>';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="4"><strong>Customer Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">First Name</th>';
        html += '              <th width="25%">Last Name</th>';
        html += '              <th width="25%">Email Address</th>';
        html += '              <th width="25%">Contact Number</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_first_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_last_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_email +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_contact_number +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br /><br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="4"><strong>Address Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="50%" colspan="2">Address Found</th>';
        html += '              <th width="50%" colspan="2">Address Searched</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="50%" colspan="2">'+checkFourSure.installation_address_found +'</td>';
        html += '              <td width="50%" colspan="2">'+checkFourSure.installation_address_searched +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Suburb</th>';
        html += '              <th width="25%">Province</th>';
        html += '              <th width="25%">Installation Lat</th>';
        html += '              <th width="25%">Installation Long</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_address_suburb +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_province +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_install_lat +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_install_long +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Store Lat</th>';
        html += '              <th width="25%">Store Long</th>';
        html += '              <th width="25%">Store Name</th>';
        html += '              <th width="25%">Store Code</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_lat +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_long +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.store_id +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br /><br /><br /><br /><br /><br /><br /><br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="5"><strong>Install Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Appointment Date Start</th>';
        html += '              <th width="25%">Appointment Date End</th>';
        html += '              <th width="25%">Appointment Contact Number</th>';
        html += '              <th width="25%">Appointment Contact Person</th>';
        html += '            </tr>';
        var objDates = checkFourSure.installation_appointment_date_start.split(',');
        var toReturn = '<p>'+objDates[objDates.length - 1]+'</p>';
        if( objDates.length > 1 ) {
          toReturn += '<small><strong>OLD DATES</strong></small><br />';
          for( var d in objDates ) {
            if( objDates[d] != objDates[objDates.length - 1] ) {
              toReturn += '<small>'+objDates[d]+'</small><br />';
            }
          }
        }
        html += '            <tr>';
        html += '              <td width="25%">'+toReturn +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_date_end +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_contact_number +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_contact_person +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="100%" colspan="4">Lookup Service Rep</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="100%" colspan="4">'+checkFourSure.installation_lookup_service_ref +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="80%" colspan="3">Appointment Installation Notes</th>';
        html += '              <th width="20%">Installation Sales Order Number</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="80%" colspan="3">'+checkFourSure.installation_notes+'</td>';
        html += '              <td width="20%">'+checkFourSure.installation_sales_order_number +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="6"><strong>Product Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="16.66%">Product Description</th>';
        html += '              <th width="16.66%">Product Make</th>';
        html += '              <th width="16.66%">Product Type</th>';
        html += '              <th width="16.66%">Product SKU</th>';
        html += '              <th width="16.66%">Product MO ID</th>';
        html += '              <th width="16.66%">Product QTY</th>';
        html += '            </tr>';
        if( productCount >= 1 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_1 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 2 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_2 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 3 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_3 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 4 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_4 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 5 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_5  +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_5 +'</td>';
          html += '            </tr>';
        }
        html += '          </table>';
        html += '          <br />';
        html += '        </div>';


      } else {
        if( payload.items.length == 1 ){
          html += payload.items[0].spec;
        } else {
          var hasLinked = false;
          for (var i in payload.items) {
            if( payload.items[i].linked_props != '' ) {
              hasLinked = true;
            }
          }
          if( hasLinked == false ) {
            html += '<br /><br />' + payload.items[0].spec;
          } else {
            for (var i in payload.items) {
              if (payload.items[i].linked_props != '' || payload.items.length == 1) {
                html += payload.items[i].spec;
              }
            }
          }
        }
      }

      html += '</body></html>';

      var htmlDetails = {
        html: html
      }

      Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
        .then(response => {
          return response.body;
        }, error => {
          console.log(error);
        }).then(data => {

        var reportDownload = document.createElement('a');
        reportDownload.setAttribute('href', 'data:application/octet-stream;base64,' + data);
        reportDownload.setAttribute('download', 'SO-' + payload.quoteNo+'.pdf');
        reportDownload.click();

      });

    });
  });

}

export const fncDownloadReportSoPdfNew = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  console.log( payload );

  payload.manufacturer = objAuth.manufacturer;
  var pdfDetails = { quote: payload };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Notification.php?a=generate_full_quote_table_sales_order', {params: pdfDetails}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      var htmlDetails = {
        html: data.html,
        documentFormat: data.documentFormat
      }

      Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
        .then(response => {
          return response.body;
        }, error => {
          console.log(error);
        }).then(d => {

        var reportDownload = document.createElement('a');
        reportDownload.setAttribute('href', 'data:application/octet-stream;base64,' + d);
        reportDownload.setAttribute('download', 'SO-' + payload.quote_no+'.pdf');
        reportDownload.click();

    });

      console.log('Data');
      console.log( data );

    /*commit({
      type: 'setTenderList',
      tenders: data
    });*/
  });

}

export const fncDownloadReportSoPdf = ({ commit, dispatch, state, rootState }, payload) => {

  // var html = "<html><head><style> .installation { border-collapse: collapse !important; width: 100% !important;} .installation th { font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .installation td { text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .glasscuttingSpecs { border-collapse: collapse !important; width: 70% !important; } .glasscuttingSpecs th { width: 50% !important;font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .glasscuttingSpecs td { width: 50% !important;text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .specialordertable { border-collapse: collapse !important; width: 50% !important; } .specialordertable td.celltitle { text-align: left !important; width: 50% !important; font-size: 12px !important; background: #92e273 !important; padding: 10px !important; } .specialordertable td { width: 50% !important; text-align: left !important; font-size: 12px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .blindOrderSpecs { max-width: 100px !important; min-width: 100px !important; font-size:8px !important; color: #7f7e7e !important } .so-total-row, .so-total-label, .so-total { font-size: 10px !important; } h2 { font-size: 20px; font-weight: normal; padding-bottom: 0px; margin-bottom: 0px; padding-top: 20px; } .so-header { font-size: 8px; } .so-description, .so-qty, .so-price, .so-uom { font-size: 8px !important; } table.blindOrder { font-size: 8px !important; color: #7f7e7e !important; border: 1px solid #eee!important; width: 100% !important; margin-top: 25px; } table.blindOrder tr { width: 100% !important; } table.blindOrder th { font-size: 8px !important; text-align: left!important; padding: 10px !important; width: 25% !important; } table.blindOrder .header { background: #f1f1f1!important; padding: 10px !important; font-size: 10px !important; font-weight: 900!important; } table.blindOrder th.mainheader { font-size: 10px !important; padding: 10px !important; } table.blindOrder td { padding: 0 10px 10px !important; vertical-align: top!important; text-align: left!important; width: 25 % !important; } table { width: 100px; max-width: 540px; min-width: 540px; margin: 0 auto; } body { font-family: helvetica, sans-serif; } table.so-lineitems {margin-top: 5px; } table.so-lineitems th {border-bottom: 1px solid #ddd; } table.so-lineitems td {padding: 10px 0; font-size: 12px; } td.so-qty {text-align: right; padding-right: 5px; } td.so-price {text-align: right; } td.so-total-label {font-weight: bold; font-size: 10px; } td.so-total {text-align: right; font-weight: bold; font-size: 10px; border-top: 1px solid #000; border-bottom: 4px double #000; } .so-qty-header, .so-price-header {text-align:right;  font-size: 10px; } .so-uom-header {font-size: 0; } .so-description-header {text-align: left; font-size: 10px; }</style></head><body>";

  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.pricelist };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {

      var statusDetails = { id: payload.id, hide_details: false };
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getContent', statusDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured', display: true };
          commit('setSnack', snackDetails);
          console.log(error);
        }).then(qd => {

          payload.items = qd;

        var customerId = payload.customer;
        if( payload.customer == '0' || payload.customer == '' ) {
          customerId = payload.createdBy;
        }

        var deliveryAddress = 0;
        if( payload.items.length > 0 && payload.items[0].delivery_address != '0'){
          deliveryAddress = payload.items[0].delivery_address;
        }

        var apiDetails = { quoteId: payload.id, customerId: customerId, deliveryAddress: deliveryAddress, manufacturer: objAuth.manufacturer, departmentId: payload.departmentId, vendorId: payload.vendorId };

        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=getSoDetails', apiDetails, rootState.headerDetails)
          .then(response => {
            return response.body;
          }, error => {
            console.log(error);
          }).then(cdd => {

          var html = '';

          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0');
          var yyyy = today.getFullYear();

          today = dd + '/' + mm + '/' + yyyy;

          var logo = window.location.protocol + process.env.MYSPEC_ENDPOINT + 'profile.php?t=/' + objAuth.myspec_url + '&p=' + objAuth.header_logo_img;

          //var soNo = 'SO' + payload.vendor + '/' + payload.quoteId;
          var soNo = String(payload.id) + String(payload.customer_id) + String(payload.vendorId);
          soNo = soNo.padEnd(12, '0');

          if( objAuth.manufacturer == '385889803' ) {
            if( qd[0].sales_order_number != '' ) {
              soNo = qd[0].sales_order_number;
            } else {
              soNo = 'N/A'
            }
          }

          var itemNumbering = [];

          for( var i in payload.items ) {
            var lineItemData = JSON.parse(payload.items[i].line_item_data);
            if( itemNumbering[lineItemData.group_item] == undefined ) {
              itemNumbering[lineItemData.group_item] = [];
            }
            itemNumbering[lineItemData.group_item].push( payload.items[i] );
          }

          html += '<html>';
          html += '<head>';
          html += '    <link rel="preconnect" href="https://fonts.googleapis.com">';
          html += '    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>';
          html += '    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap" rel="stylesheet">';
          //html += '    <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap" rel="stylesheet">';
          html += '    <style type="text/css">';
          html += '        body {';
          html += '            font-family: "Open Sans" !important;';
          html += '            font-size: 14px;';
          html += '            text-rendering: optimize-speed !important;';
          html += '        }';
          html += '        .line-items table th, .line-items table td {';
          html += '            padding: 4px 8px;';
          html += '            vertical-align: top;';
          html += '        }';
          html += '        .last-spec-item td {';
          html += '            border-bottom: 1px solid #f1f1f1;';
          html += '        }';
          html += '        table {';
          html += '            width: 100%;';
          html += '        }';
          html += '    </style>';
          html += '</head>';
          html += '<body>';
          html += '<div style=" style="position: relative;height: 100%; page-break-before: always !important;margin-left: auto; margin-right: auto; max-width: 720px;">';
          // html += '    <div class="client-details">';
          /*html += '        <span class="client-logo" style="vertical-align: top">';
          html += '            <img width="100" height="100" src="'+logo+'" style="position: absolute; z-index:9999;display: block;border: 1px solid red; max-width: 150px">';
          html += '        </span>';*/

          var address = 'N/A';
          if( objAuth.manufacturer_address != null ) {
            var addressObj = objAuth.manufacturer_address.split('\n');
            address = addressObj.join('<br />');
          }

          var termsConditions = '';
          if( payload.store_name != '' ) {
            for( var b in rootState.Branches.branchList ) {
              if( payload.store_name == rootState.Branches.branchList[b].code ) {

                if( rootState.Branches.branchList[b].switch == '1' ) {
                  termsConditions = rootState.Branches.branchList[b].terms_and_conditions;
                }

                var objAddress = [];

                if( rootState.Branches.branchList[b].address_one && rootState.Branches.branchList[b].address_one != '' ) { objAddress.push(rootState.Branches.branchList[b].address_one); }
                if( rootState.Branches.branchList[b].address_two && rootState.Branches.branchList[b].address_two != '' ) { objAddress.push(rootState.Branches.branchList[b].address_two); }
                if( rootState.Branches.branchList[b].postal_code && rootState.Branches.branchList[b].postal_code != '' ) { objAddress.push(rootState.Branches.branchList[b].postal_code); }
                if( rootState.Branches.branchList[b].contact_no && rootState.Branches.branchList[b].contact_no != '' ) { objAddress.push(rootState.Branches.branchList[b].contact_no); }

                if( objAddress.length > 0 ) {
                  address = objAddress.join('<br />');
                } else {
                  address = 'N/A';
                }

              }
            }
          }

          html += '    <div class="client-details" style="display: block; float: left; clear: both; width:100%;">';
          html += '        <span class="client-logo" style="vertical-align: top; display: block; float: left;width:50%">';
          html += '            <img src="'+logo+'" style="max-width: 150px">';
          html += '        </span>';
          html += '        <span class="client-logo" style="line-height:11px;text-align: right; font-size:9px;vertical-align: top; display: block; float: right;width:50%">';
          html += address;
          html += '        </span>';
          html += '    </div>';

          /*html += '        <span class="client-address" style="border: 1px solid black !important;z-index:9999 !important;position:relative; top: -20px; float:right; font-size: 10px; line-height:12px; color: black; vertical-align: top">';
          html += address;
          html += '        </span>';*/
          html += '    </div>';
          html += '    <div class="quote-header" style="background-color: #f1f1f1; padding: 15px 20px;float:left;clear:both; width:520px;margin-top:10px;">';
          html += '        <span class="customer-details" style="display: inline-block" style="width:50%">';

          if( cdd.customerDetails != '' ) {
            /*html += '            <div class="customer-company" style="font-size: 12px"><b>XYZ Trading</b></div>';*/
            html += '            <div class="customer" style="font-size:12px;line-height:12px">';
            html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;font-weight: 700 !important;"><b>Customer Details:</b></div>';
            html += '<span style="font-size: 9px;line-height:12px;">' + cdd.customerDetails + '</span>';
            html += '            </div>';
          }

          /*if(  ) {
            html += '            <div class="customer-delivery" style="padding-top: 15px">';
            html += '                <div class="label" style="font-size: 10px"><b>Delivery Address:</b></div>';
            html += '                <div class="address" style="font-size: 10px;line-height:12px;">';
            html += '                    18 Newbury Avenue, Constantia<br>';
            html += '                    Cape Town, 8976';
            html += '                </div>';
            html += '            </div>';
          }*/

          if( cdd.deliveryDetails != '' ) {
            html += '<span style="font-size: 9px !important;line-height:12px;">';
            if( objAuth.doc_show_delivery_details == false || objAuth.doc_show_delivery_details == 0 ) {
              if( cdd.vendorDetails != '' ) {
                html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;margin-top: 15px;"><b>Vendor Details:</b></div>';
                html += cdd.vendorDetails;
              }
            } else {
              if( cdd.deliveryDetails == '' || cdd.deliveryDetails == undefined ) {
                html += '            <div class="customer-delivery" style="padding-top: 15px">';
                html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;"><b>Delivery Address:</b></div>';
                html += '                <div class="address" style="font-size: 9px;line-height:12px;">';
                html += 'N/A';
                html += '                </div>';
                html += '            </div>';
              } else {
                html += '            <div class="customer-delivery" style="padding-top: 15px">';
                html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;"><b>Delivery Address:</b></div>';
                html += '                <div class="address" style="font-size: 9px;line-height:12px;">';
                html += cdd.deliveryDetails;
                html += '                </div>';
                html += '            </div>';
              }
            }
            html += '</span>';
          } else {
            html += '<span style="font-size: 10px !important;">';
            if( objAuth.doc_show_delivery_details == false || objAuth.doc_show_delivery_details == 0 ) {
              html += '            <div class="customer-delivery" style="padding-top: 15px">';
              html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;"><b>Delivery Address:</b></div>';
              html += '                <div class="address" style="font-size: 9px;line-height:12px;">';
              html += 'Collect';
              html += '                </div>';
              html += '            </div>';
            } else {
              html += '            <div class="customer-delivery" style="padding-top: 15px">';
              html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;"><b>Delivery Address:</b></div>';
              html += '                <div class="address" style="font-size: 9px;line-height:12px;">';
              html += cdd.vendorDetails;
              html += '                </div>';
              html += '            </div>';
            }
            html += '</span>';
          }

          html += '        </span>';
          html += '        <span class="document-details" style="display: inline-block; vertical-align: top; text-align: right; float:right;width:50%;">';
          html += '            <div class="document-type" style="font-size: 24px;margin-top: -4px;"><b>SALES ORDER</b></div>';
          html += '            <div class="document-type" style="font-size: 9px;margin-top: 2px;"><b>Sales Order NO:</b>&nbsp;'+soNo+'</div>';
          html += '            <div class="document-type" style="font-size: 9px;margin-top: 2px;"><b>Date:</b>&nbsp;'+today+'</div>';
          /*html += '            <div style="font-size:10px !important;"><span style="font-size:10px !important;" class="label"><b>Sales Order NO:</b></span> <span style="font-size:10px !important;">'+soNo+'</span></div>';
          html += '            <div style="font-size:10px !important;"><span style="font-size:10px !important;" class="label"><b>Date:</b></span> <span style="font-size:10px !important;">'+today+'</span></div>';*/

          if( objAuth.doc_show_so_quote_details == '1' ) {
            html += '            <div class="document-type" style="font-size: 9px;margin-top: 2px;padding-top: 15px; color: grey;"><b>Quote Ref:</b>&nbsp;'+payload.quote_no+'</div>';
            // html += '            <div class="document-ref" style="padding-top: 15px; color: grey;font-size:10px;"><span class="label"><b>Quote Ref:</b></span> <span>'+payload.quote_no+'</span></div>';
          }
          html += '        </span>';
          html += '    </div>';
          html += '                <div class="line-items" style="float: left; clear:both;width:100%;">';
          html += '                    <table style="margin-top: 20px;clear:both;border-collapse: collapse; font-size: 12px;width:100% !important;">';
          html += '                        <tbody>';

          if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
            html += '<tr style="border-bottom: 1px solid #ECECEC;">';
              html += '<td style="width:50%;font-size:11px;"><b>ITEM</b></td>';
              html += '<td style="width:50%;font-size:11px;"><b>QUANTITY</b></td>';
            html += '</tr>';
          } else {
            html += '<tr style="border-bottom: 1px solid #ECECEC;">';
              html += '<td style="width:50%;font-size:11px;"><b>ITEM</b></td>';
              html += '<td style="width:10%;font-size:11px;"><b>QUANTITY</b></td>';
              html += '<td style="width:20%;font-size:11px; white-space: nowrap;text-align:right;"><b>UNIT PRICE</b></td>';
              html += '<td style="width:20%;font-size:11px;white-space: nowrap;text-align:right;"><b>TOTAL PRICE</b></td>';
            html += '</tr>';
          }

          var totalQuotePrice = 0;
          if( payload.items.length > 0 ) {

            if (cdd.pdf_number_attachments == 1) {

              var itemNumbering = [];

              for (var i in payload.items) {
                var lineItemData = JSON.parse(payload.items[i].line_item_data);
                if (itemNumbering[lineItemData.group_item] == undefined) {
                  itemNumbering[lineItemData.group_item] = [];
                }
                itemNumbering[lineItemData.group_item].push(payload.items[i]);
              }

              var c = 1;
              for (var n in itemNumbering) {
                html += '                        <tr class="spec-number">';
                html += '                            <td colspan="4" style="color:grey; font-size: 10px !important;">#'+c+'</td>';
                html += '                        </tr>';

                for (var i in itemNumbering[n]) {
                  var lineItemData = JSON.parse(itemNumbering[n][i].line_item_data);

                  var dataUrl = payload.items[i].name.replace(/%20/g, " ");
                  dataUrl = dataUrl.replace(/%27/g, "'");
                  dataUrl = dataUrl.replace(/%3A/g, ":");
                  dataUrl = dataUrl.replace(/%3B/g, ";");
                  dataUrl = dataUrl.replace(/%3C/g, "<");
                  dataUrl = dataUrl.replace(/%3D/g, "=");
                  dataUrl = dataUrl.replace(/%3E/g, ">");
                  dataUrl = dataUrl.replace(/%2C/g, ",");
                  dataUrl = dataUrl.replace(/%28/g, "(");
                  dataUrl = dataUrl.replace(/%29/g, ")");
                  dataUrl = dataUrl.replace(/&sup/g, "");
                  dataUrl = dataUrl.replace(/;/g, "");
                  dataUrl = dataUrl.replace(/%AE/g, "&reg;");

                  if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
                    html += '<tr style="font-size:10px;border-bottom: 1px solid #ECECEC;padding-bottom:6px;">';
                    html += '<td style="width:50%;text-align:left;font-size:9px !important;"><span style="font-size:10px !important;">' + dataUrl + '</span></td>';
                    html += '<td style="width:50%;text-align:left;font-size:9px !important;"><span style="font-size:10px !important;">' + itemNumbering[n][i].quantity + ' '+itemNumbering[n][i].uom+'</span></td>';
                    html += '</tr>';
                  } else {
                    html += '<tr style="font-size:10px;border-bottom: 1px solid #ECECEC;padding-bottom:6px;">';
                    html += '<td style="width:50%;text-align:left;font-size:9px !important;"><span style="font-size:10px !important;">' + dataUrl + '</span></td>';
                    html += '<td style="width:10%;text-align:left;font-size:9px !important;"><span style="font-size:10px !important;">' + itemNumbering[n][i].quantity + ' ' + itemNumbering[n][i].uom + '</span></td>';

                    var price = parseFloat(payload.items[i].price);
                    if (objAuth.privileges.indexOf('VENDOR_COST_PRICE') != -1 && lineItemData.cost_price != undefined) {
                      price = parseFloat(lineItemData.cost_price);
                    }

                    price = price - payload.items[i].discount;

                    html += '<td style="width:20%;text-align:right;font-size:9px !important;" class="text-xs-right"><span style="font-size:10px !important;">R' + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';
                    var totalPrice = price * itemNumbering[n][i].quantity;

                    totalQuotePrice = parseFloat(totalQuotePrice) + parseFloat(totalPrice);
                    html += '<td style="width:20%;text-align:right;font-size:9px !important;" class="text-xs-right"><span style="font-size:10px !important;">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';
                    html += '</tr>';
                  }
                }
                c++;
              }
            } else {
              for (var i in payload.items) {
                var lineItemData = JSON.parse(payload.items[i].line_item_data);

                var dataUrl = payload.items[i].name.replace(/%20/g, " ");
                dataUrl = dataUrl.replace(/%27/g, "'");
                dataUrl = dataUrl.replace(/%3A/g, ":");
                dataUrl = dataUrl.replace(/%3B/g, ";");
                dataUrl = dataUrl.replace(/%3C/g, "<");
                dataUrl = dataUrl.replace(/%3D/g, "=");
                dataUrl = dataUrl.replace(/%3E/g, ">");
                dataUrl = dataUrl.replace(/%2C/g, ",");
                dataUrl = dataUrl.replace(/%28/g, "(");
                dataUrl = dataUrl.replace(/%29/g, ")");
                dataUrl = dataUrl.replace(/&sup/g, "");
                dataUrl = dataUrl.replace(/;/g, "");
                dataUrl = dataUrl.replace(/%AE/g, "&reg;");

                if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
                  html += '                        <tr>';
                  html += '                            <td style="width:50%;padding-left: 20px; padding-right: 50px;font-size:9px !important;">' + dataUrl + '</td>';
                  html += '                            <td style="width:50%;text-align: right;font-size:9px !important;">' + payload.items[i].quantity + ' ' + payload.items[i].uom + '</td>';
                  html += '                        </tr>';
                } else {

                  html += '                        <tr>';
                  html += '                            <td style="width:50%;padding-left: 20px; padding-right: 50px;font-size:9px !important;">' + dataUrl + '</td>';
                  html += '                            <td style="width:10%;text-align: left;font-size:9px !important;">' + payload.items[i].quantity + ' ' + payload.items[i].uom + '</td>';

                  var price = parseFloat(payload.items[i].price);
                  if (objAuth.privileges.indexOf('VENDOR_COST_PRICE') != -1 && lineItemData.cost_price != undefined) {
                    price = parseFloat(lineItemData.cost_price);
                  }

                  price = price - payload.items[i].discount;

                  // html += '<td style="text-align:right;font-size:10px;"><span style="font-size:10px;">R' + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';
                  var totalPrice = price * payload.items[i].quantity;

                  totalQuotePrice = parseFloat(totalQuotePrice) + parseFloat(totalPrice);
                  // html += '<td style="text-align:right;font-size:10px;"><span style="font-size:10px;">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';

                  html += '                            <td style="text-align: right;font-size:9px !important;">R' + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
                  html += '                            <td style="text-align: right;font-size:9px !important;">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';

                  html += '</tr>';
                }
              }
            }
            var taxValue = totalQuotePrice * 0.15;
            totalQuotePrice = totalQuotePrice * 1.15;


            html += '                        <tfoot>';
            html += '                        <tr><td colspan="4" style="padding: 0;">&nbsp;</td> </tr>';
            html += '                        <tr></tr>';
            html += '                        <td colspan="3"padding: 0;">&nbsp;</td>';
            html += '                        <td colspan="1" style="border-bottom: 1px solid black !important;padding: 0;">&nbsp;</td>';
            html += '                        </tr>';
            html += '                        <tr>';
            html += '                            <td colspan="3" style="text-align: right; font-size: 11px"><b>TOTAL</b></td>';
            html += '                            <td style="text-align: right; font-size: 11px; border-bottom: 4px double black;">R' + totalQuotePrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
            html += '                        </tr>';
            html += '                        <tr>';
            html += '                            <td colspan="4" style="text-align: right; font-size: 9px;margin-top: 10px;">&nbsp;</td>';
            html += '                        </tr>';
            html += '                        <tr>';
            html += '                            <td colspan="3" style="text-align: right; font-size: 9px;margin-top: 10px;">Including VAT @ 15%</td>';
            html += '                            <td style="text-align: right; font-size: 9px;">R'+taxValue.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+'</td>';
            html += '                        </tr>';
            html += '                        </tfoot>';
          }
          html += '                    </table>';
          html += '                </div>';
          html += '</body>';
          html += '</html>';
          html += '<html>';
          html += '<head>';
          html += '    <link rel="preconnect" href="https://fonts.googleapis.com">';
          html += '    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>';
          html += '    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap" rel="stylesheet">';
          //html += '    <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap" rel="stylesheet">';
          html += '    <style type="text/css">';
          html += '        body {';
          html += '            font-family: "Open Sans" !important;';
          html += '            font-size: 14px;';
          html += '        }';
          html += '        .line-items table th, .line-items table td {';
          html += '            padding: 4px 8px;';
          html += '            vertical-align: top;';
          html += '        }';
          html += '        .last-spec-item td {';
          html += '            border-bottom: 1px solid #f1f1f1;';
          html += '        }';
          html += '        table {';
          html += '            width: 100%;';
          html += '        }';
          html += '        table.quickestimate, table.quickestimate tr, table.quickestimate tr td, table.quickestimate tr th {';
          html += '            font-size: 10px !important;';
          html += '        }';
          html += '        table.specialordertable, table.specialordertable tr, table.specialordertable tr td, table.specialordertable tr th {';
          html += '            font-size: 10px !important;';
          html += '        }';
          html += '        table.specification-spec-table, table.specification-spec-table tr, table.specification-spec-table tr td, table.specification-spec-table tr th {';
          html += '            font-size: 10px !important;';
          html += '        }';
          html += '        table.blindOrder, table.blindOrder tr, table.blindOrder tr td, table.blindOrder tr th {';
          html += '            font-size: 10px !important;';
          html += '        }';
          html += '    </style>';
          html += '</head>';
          html += '<body>';
          html += '<div style="position: relative;height: 100%; page-break-before: always !important;margin-left: auto; margin-right: auto; max-width: 720px;">';

          html += '    <div class="section-header" style="padding-bottom: 3px;padding-top: 10px; font-size: 16px; border-bottom: 1px solid #f1f1f1; text-align: center"><b>PRODUCT INFORMATION</b></div>';

          var checkFourSure = JSON.parse( payload.items[0].line_item_data );

          if( checkFourSure.installation_customer_first_name != null ) {

            var lineDataCount = Object.keys(checkFourSure).length;
            lineDataCount = lineDataCount - 25;
            var productCount = Math.floor( lineDataCount / 6 );

            html += '<div class="lineItemDetails" style="font-size: 12px !important;">';
            html += '<br />';
            html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
            html += '            <tr>';
            html += '              <th colspan="4" style="font-size:12px;"><strong>Customer Details</strong></th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <th width="25%" style="font-size:10px !important;background: #ECECEC;">First Name</th>';
            html += '              <th width="25%" style="font-size:10px !important;background: #ECECEC;">Last Name</th>';
            html += '              <th width="25%" style="font-size:10px !important;background: #ECECEC;">Email Address</th>';
            html += '              <th width="25%" style="font-size:10px !important;background: #ECECEC;">Contact Number</th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_first_name +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_last_name +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_email +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_contact_number +'</td>';
            html += '            </tr>';
            html += '          </table>';
            html += '          <br />';
            html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
            html += '            <tr>';
            html += '              <th colspan="4" style="font-size:12px;"><strong>Address Details</strong></th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <th width="50%" colspan="2" style="font-size:10px !important;background: #ECECEC;">Address Found</th>';
            html += '              <th width="50%" colspan="2" style="font-size:10px !important;background: #ECECEC;">Address Searched</th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <td width="50%" colspan="2" style="font-size:9px !important;">'+checkFourSure.installation_address_found +'</td>';
            html += '              <td width="50%" colspan="2" style="font-size:9px !important;">'+checkFourSure.installation_address_searched +'</td>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <th width="25%" style="padding-top: 6px;font-size:10px !important;background: #ECECEC;">Suburb</th>';
            html += '              <th width="25%" style="padding-top: 6px;font-size:10px !important;background: #ECECEC;">Province</th>';
            html += '              <th width="25%" style="padding-top: 6px;font-size:10px !important;background: #ECECEC;">Installation Lat</th>';
            html += '              <th width="25%" style="padding-top: 6px;font-size:10px !important;background: #ECECEC;">Installation Long</th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_suburb +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_province +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_install_lat +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_install_long +'</td>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Store Lat</th>';
            html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Store Long</th>';
            html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Store Name</th>';
            html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Store Code</th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_lat +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_long +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_name +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.store_id +'</td>';
            html += '            </tr>';
            html += '          </table>';
            html += '          <br />';
            html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
            html += '            <tr>';
            html += '              <th colspan="5" style="font-size:12px;"><strong>Install Details</strong></th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Appointment Date Start</th>';
            html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Appointment Date End</th>';
            html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Appointment Contact Number</th>';
            html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Appointment Contact Person</th>';
            html += '            </tr>';
            var objDates = checkFourSure.installation_appointment_date_start.split(',');
            var toReturn = '<p>'+objDates[objDates.length - 1]+'</p>';
            if( objDates.length > 1 ) {
              toReturn += '<small><strong>OLD DATES</strong></small><br />';
              for( var d in objDates ) {
                if( objDates[d] != objDates[objDates.length - 1] ) {
                  toReturn += '<small>'+objDates[d]+'</small><br />';
                }
              }
            }
            html += '            <tr>';
            html += '              <td width="25%" style="font-size:9px !important;">'+toReturn +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_date_end +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_contact_number +'</td>';
            html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_contact_person +'</td>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <th width="100%" colspan="4" style="font-size:10px !important;padding-top: 6px;background: #ECECEC;">Lookup Service Rep</th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <td width="100%" colspan="4" style="font-size:9px !important;">'+checkFourSure.installation_lookup_service_ref +'</td>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <th width="80%" colspan="3" style="font-size:10px !important;background: #ECECEC;">Appointment Installation Notes</th>';
            html += '              <th width="20%" style="font-size:10px !important;background: #ECECEC;">Installation Sales Order Number</th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <td width="80%" colspan="3" style="font-size:9px !important;">'+checkFourSure.installation_notes+'</td>';
            html += '              <td width="20%" style="font-size:9px !important;">'+checkFourSure.installation_sales_order_number +'</td>';
            html += '            </tr>';
            html += '          </table>';
            html += '          <br />';
            html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
            html += '            <tr>';
            html += '              <th colspan="6" style="font-size:12px;"><strong>Product Details</strong></th>';
            html += '            </tr>';
            html += '            <tr>';
            html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product Description</th>';
            html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product Make</th>';
            html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product Type</th>';
            html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product SKU</th>';
            html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product MO ID</th>';
            html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product QTY</th>';
            html += '            </tr>';
            if( productCount >= 1 ) {
              html += '            <tr>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_1 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_1 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_1 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_1 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_1 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_1 +'</td>';
              html += '            </tr>';
            }
            if( productCount >= 2 ) {
              html += '            <tr>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_2 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_2 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_2 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_2 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_2 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_2 +'</td>';
              html += '            </tr>';
            }
            if( productCount >= 3 ) {
              html += '            <tr>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_3 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_3 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_3 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_3 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_3 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_3 +'</td>';
              html += '            </tr>';
            }
            if( productCount >= 4 ) {
              html += '            <tr>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_4 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_4 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_4 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_4 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_4 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_4 +'</td>';
              html += '            </tr>';
            }
            if( productCount >= 5 ) {
              html += '            <tr>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_5  +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_5 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_5 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_5 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_5 +'</td>';
              html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_5 +'</td>';
              html += '            </tr>';
            }
            html += '          </table>';
            html += '          <br />';
            html += '        </div>';

          } else {

            if( cdd.pdf_number_attachments == 1 ) {

              html += '<br /><div class="specHolder" style="font-size: 12px !important;">';

              var c = 1;
              for( var n in itemNumbering ) {
                html += '<tr style="font-size:9px;"><td colspan="4">#' + c + '</td></tr>';
                // for (var i in itemNumbering[n]) {

                if( itemNumbering[n] == 1 ){
                  if( itemNumbering[n][0].spec != '' ) {
                    html += itemNumbering[n][0].spec;
                  } else {
                    html += 'N/A';
                  }
                } else {
                  var hasLinked = false;
                  for (var i in itemNumbering[n]) {
                    if( itemNumbering[n][i].linked_props != '' ) {
                      hasLinked = true;
                    }
                  }
                  if( hasLinked == false ) {
                    html += itemNumbering[n][0].spec;
                  } else {
                    for (var i in itemNumbering[n]) {
                      if (itemNumbering[n][i].linked_props != '' || itemNumbering[n].length == 1) {
                        html += itemNumbering[n][i].spec;
                      }
                    }
                  }
                }

                // }
                c++;
              }

              html += '</div>';

            } else {

              var spec = payload.items[0].spec.replace(/(<style[\w\W]+style>)/g, "");
                  spec = spec.replace(/(<style[\w\W]+style>)/g, "");

              html += '<br /><div class="specHolder" style="font-size: 10px !important;">';
              if( payload.items.length == 1 ){
                if( payload.items[0].spec == '' ) {
                  html += '<span style="display: block; float: left;font-size: 10px !important;">N/A</span>';
                } else {
                  html += '<span style="display: block; float: left;font-size: 10px !important;">' + payload.items[0].spec + '</span>';
                }
              } else {
                var hasLinked = false;
                for (var i in payload.items) {
                  if( payload.items[i].linked_props != '' ) {
                    hasLinked = true;
                  }
                }
                if( hasLinked == false ) {
                  console.log( payload.items[0].spec );
                  html += '<span style="font-size: 10px !important;">' + payload.items[0].spec + '</span>';
                } else {
                  for (var i in payload.items) {
                    if (payload.items[i].linked_props != '' || payload.items.length == 1) {
                      console.log( payload.items[i].spec );
                      html += '<span style="font-size: 10px !important;">' + payload.items[i].spec + '</span>';
                    }
                  }
                }
              }
              html += '</div>';
            }

          }

          // we need to check if there are images
          var hasImage = false;
          for (var i in payload.items) {
            if( payload.items[i].image != '' ) {
              hasImage = true;
            }
          }

          if( hasImage == true ) {
            html += '<br /><br /><div class="section-header" style="padding-bottom: 3px;font-size: 16px; border-bottom: 1px solid #f1f1f1; text-align: center"><b>PRODUCT IMAGES</b></div>';
            if (cdd.pdf_number_attachments == 1) {

              html += '<br /><div class="specHolder" style="font-size: 12px !important;">';

              var c = 1;
              for (var n in itemNumbering) {
                html += '<tr style="font-size:9px;"><td colspan="4">#' + c + '</td></tr><br /><br />';
                // for (var i in itemNumbering[n]) {

                if (itemNumbering[n] == 1) {
                  html += '<img style="max-width:200px;" src="' + itemNumbering[n][0].image + '" />';
                } else {
                  var hasLinked = false;
                  for (var i in itemNumbering[n]) {
                    if (itemNumbering[n][i].linked_props != '') {
                      hasLinked = true;
                    }
                  }
                  if (hasLinked == false) {
                    html += '<img style="max-width:200px;" src="' + itemNumbering[n][0].image + '" />';
                  } else {
                    for (var i in itemNumbering[n]) {
                      if (itemNumbering[n][i].linked_props != '' || itemNumbering[n].length == 1) {
                        html += '<img style="max-width:200px;" src="' + itemNumbering[n][i].image + '" />';
                      }
                    }
                  }
                }

                // }
                c++;
              }

              html += '</div>';

            } else {
              html += '<br /><div class="specHolder" style="font-size: 12px !important;">';
              if (payload.items.length == 1) {
                html += '<img style="max-width:200px;" src="' + payload.items[0].image + '" />';
              } else {
                var hasLinked = false;
                for (var i in payload.items) {
                  if (payload.items[i].linked_props != '') {
                    hasLinked = true;
                  }
                }
                if (hasLinked == false) {
                  html += '<img style="max-width:200px;" src="' + payload.items[0].image + '" />';
                } else {
                  for (var i in payload.items) {
                    if (payload.items[i].linked_props != '' || payload.items.length == 1) {
                      html += '<img style="max-width:200px;" src="' + payload.items[i].image + '" />';
                    }
                  }
                }
              }
              html += '</div>';
            }
            html += '<div>';
          }

          html += '</div>';
          html += '</body>';
          html += '</html>';
          html += '<html>';
          html += '    <link rel="preconnect" href="https://fonts.googleapis.com">';
          html += '    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>';
          html += '    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap" rel="stylesheet">';
          //html += '    <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap" rel="stylesheet">';
          html += '    <style type="text/css">';
          html += '        body {';
          html += '            font-family: "Open Sans" !important;';
          html += '            font-size: 14px;';
          html += '            text-rendering: optimize-speed !important;';
          html += '        }';
          html += '        .line-items table th, .line-items table td {';
          html += '            padding: 4px 8px;';
          html += '            vertical-align: top;';
          html += '        }';
          html += '        .last-spec-item td {';
          html += '            border-bottom: 1px solid #f1f1f1;';
          html += '        }';
          html += '        table {';
          html += '            width: 100%;';
          html += '        }';
          html += '        .termsandconditions h3 {';
          html += '            font-size:12px: 100%;';
          html += '        }';
          html += '        .termsandconditions, .termsandconditions p  {';
          html += '            font-size:12px: 100%;';
          html += '        }';
          html += '    </style>';
          html += '</head>';
          html += '<body>';
          html += '<div style="position: relative;height: 100%; page-break-before: always !important;margin-left: auto; margin-right: auto; max-width: 720px;">';
          // html += '<div style="position: relative; padding-top: 30px; height: 100%; page-break-before: always !important;margin-left: auto; margin-right: auto; max-width: 720px;">';
          html += '    <div class="section-header" style="padding-bottom: 3px; padding-top: 40px font-size: 16px; border-bottom: 1px solid #f1f1f1; text-align: center"><b>TERMS AND CONDITIONS</b></div>';
          html += '    <div class="termsandconditions" style="padding-top: 25px;font-size:9px; line-height: 11px;">';
          if( termsConditions != '' ) {
            html += termsConditions;
          } else {
            html += cdd.tcs;
          }
          html += '    </div>';
          html += '</div>';
          html += '</body>';
          html += '</html>';

          var documentFormat = {};
          documentFormat.border = {};
          documentFormat.border.top = '15px';
          documentFormat.border.left = '15px';
          documentFormat.border.right = '15px';
          documentFormat.border.bottom = '15px';
          documentFormat.footer = {};
          // documentFormat.header = {};
          documentFormat.footer.contents = {};
          // documentFormat.header.contents = {};
          // documentFormat.header.height = {};
          var footer = '';
          footer += '<footer style="position: absolute; bottom: 0;width:100%;">';
          footer += '    <div class="footer" style="border-top: 1px solid #f1f1f1; text-align: center">';
          footer += '        <div class="page-number" style="font-size: 8px;line-height:10px;">PAGE {{page}} OF {{pages}}</div>';
          footer += '        <div class="client-name" style="font-size: 8px;line-height:10px; color: grey">'+objAuth.manufacturer_name.toUpperCase()+'</div>';
          footer += '        </div>';
          footer += '</footer>';
          /*var header = '';
          header += '    <div class="client-details" style="display: block; float: left; clear: both; width:100%;">';
          header += '        <span class="client-logo" style="border:1px solid blue !important; height:100px; vertical-align: top; display: block; float: left;width:50%">';
          header += '            <img width="100" height="100" src="'+logo+'" style="position: absolute; z-index:9999;display: block;border: 1px solid red; max-width: 150px">';
          header += '        </span>';
          header += '        <span class="client-logo" style="marin-top: -10px; line-height:11px;text-align: right; font-size:9px;vertical-align: top; display: block; float: right;width:50%">';
          header += address;
          header += '        </span>';
          header += '    </div>';*/

          documentFormat.footer.contents.default = footer;
          // documentFormat.header.contents.default = header;
          // documentFormat.header.height = '100px';

          var htmlDetails = {
            html: html,
            documentFormat: documentFormat
          }

          Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
            .then(response => {
              return response.body;
            }, error => {
              console.log(error);
            }).then(data => {

            var reportDownload = document.createElement('a');
            reportDownload.setAttribute('href', 'data:application/octet-stream;base64,' + data);
            reportDownload.setAttribute('download', 'SO-' + payload.quote_no+'.pdf');
            reportDownload.click();

          });
      });

        });

    });
  });

}

export const fncDownloadReportPoPdf = ({ commit, dispatch, state, rootState }, payload) => {

  // var html = "<html><head><style> .installation { border-collapse: collapse !important; width: 100% !important;} .installation th { font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .installation td { text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .glasscuttingSpecs { border-collapse: collapse !important; width: 70% !important; } .glasscuttingSpecs th { width: 50% !important;font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .glasscuttingSpecs td { width: 50% !important;text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .specialordertable { border-collapse: collapse !important; width: 50% !important; } .specialordertable td.celltitle { text-align: left !important; width: 50% !important; font-size: 12px !important; background: #92e273 !important; padding: 10px !important; } .specialordertable td { width: 50% !important; text-align: left !important; font-size: 12px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .blindOrderSpecs { max-width: 100px !important; min-width: 100px !important; font-size:8px !important; color: #7f7e7e !important } .so-total-row, .so-total-label, .so-total { font-size: 10px !important; } h2 { font-size: 20px; font-weight: normal; padding-bottom: 0px; margin-bottom: 0px; padding-top: 20px; } .so-header { font-size: 8px; } .so-description, .so-qty, .so-price, .so-uom { font-size: 8px !important; } table.blindOrder { font-size: 8px !important; color: #7f7e7e !important; border: 1px solid #eee!important; width: 100% !important; margin-top: 25px; } table.blindOrder tr { width: 100% !important; } table.blindOrder th { font-size: 8px !important; text-align: left!important; padding: 10px !important; width: 25% !important; } table.blindOrder .header { background: #f1f1f1!important; padding: 10px !important; font-size: 10px !important; font-weight: 900!important; } table.blindOrder th.mainheader { font-size: 10px !important; padding: 10px !important; } table.blindOrder td { padding: 0 10px 10px !important; vertical-align: top!important; text-align: left!important; width: 25 % !important; } table { width: 100px; max-width: 540px; min-width: 540px; margin: 0 auto; } body { font-family: helvetica, sans-serif; } table.so-lineitems {margin-top: 5px; } table.so-lineitems th {border-bottom: 1px solid #ddd; } table.so-lineitems td {padding: 10px 0; font-size: 12px; } td.so-qty {text-align: right; padding-right: 5px; } td.so-price {text-align: right; } td.so-total-label {font-weight: bold; font-size: 10px; } td.so-total {text-align: right; font-weight: bold; font-size: 10px; border-top: 1px solid #000; border-bottom: 4px double #000; } .so-qty-header, .so-price-header {text-align:right;  font-size: 10px; } .so-uom-header {font-size: 0; } .so-description-header {text-align: left; font-size: 10px; }</style></head><body>";

  var qd = payload.items;
  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.pricelist };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {

      var customerId = payload.customer;
      if( payload.customer == '0' || payload.customer == '' ) {
        customerId = payload.createdBy;
      }

      var deliveryAddress = 0;
      if( payload.items.length > 0 && payload.items[0].delivery_address != '0'){
        deliveryAddress = payload.items[0].delivery_address;
      }

      var apiDetails = { quoteId: payload.id, customerId: customerId, deliveryAddress: deliveryAddress, manufacturer: objAuth.manufacturer, departmentId: payload.departmentId, vendorId: payload.vendor };

      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=getSoDetails', apiDetails, rootState.headerDetails)
        .then(response => {
          return response.body;
        }, error => {
          console.log(error);
        }).then(cdd => {

            var poNo = String(payload.quoteId) + String(payload.vendor) + String(payload.customer);
            poNo = poNo.padEnd(12, '0');

        var html = '';

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();

        today = dd + '/' + mm + '/' + yyyy;

        var logo = window.location.protocol + process.env.MYSPEC_ENDPOINT + 'profile.php?t=/' + objAuth.myspec_url + '&p=' + objAuth.header_logo_img;

        var itemNumbering = [];

        for( var i in payload.items ) {
          var lineItemData = JSON.parse(payload.items[i].line_item_data);
          if( itemNumbering[lineItemData.group_item] == undefined ) {
            itemNumbering[lineItemData.group_item] = [];
          }
          itemNumbering[lineItemData.group_item].push( payload.items[i] );
        }

        html += '<html>';
        html += '<head>';
        html += '    <link rel="preconnect" href="https://fonts.googleapis.com">';
        html += '    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>';
        html += '    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap" rel="stylesheet">';
        //html += '    <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap" rel="stylesheet">';
        html += '    <style type="text/css">';
        html += '        body {';
        html += '            font-family: "Open Sans" !important;';
        html += '            font-size: 14px;';
        html += '            text-rendering: optimize-speed !important;';
        html += '        }';
        html += '        .line-items table th, .line-items table td {';
        html += '            padding: 4px 8px;';
        html += '            vertical-align: top;';
        html += '        }';
        html += '        .last-spec-item td {';
        html += '            border-bottom: 1px solid #f1f1f1;';
        html += '        }';
        html += '        table {';
        html += '            width: 100%;';
        html += '        }';
        html += '    </style>';
        html += '</head>';
        html += '<body>';
        html += '<div style=" style="position: relative;height: 100%; page-break-before: always !important;margin-left: auto; margin-right: auto; max-width: 720px;">';
        /*html += '    <div class="client-details">';
        html += '        <span class="client-logo" style="vertical-align: top">';
        html += '            <img src="logo.jpg">';
        html += '        </span>';*/

        var address = 'N/A';
        if( objAuth.manufacturer_address != null ) {
          var addressObj = objAuth.manufacturer_address.split('\n');
          address = addressObj.join('<br />');
        }

        var storeCode = '';
        for( var i in payload.items ) {
          if( payload.items[i].store_code != '' ) {
            storeCode = payload.items[i].store_code
          }
        }

        var termsConditions = '';
        if( storeCode != '' ) {
          for( var b in rootState.Branches.branchList ) {
            if( storeCode == rootState.Branches.branchList[b].code ) {

              if( rootState.Branches.branchList[b].switch == '1' ) {
                termsConditions = rootState.Branches.branchList[b].terms_and_conditions;
              }

              var objAddress = [];

              if( rootState.Branches.branchList[b].address_one && rootState.Branches.branchList[b].address_one != '' ) { objAddress.push(rootState.Branches.branchList[b].address_one); }
              if( rootState.Branches.branchList[b].address_two && rootState.Branches.branchList[b].address_two != '' ) { objAddress.push(rootState.Branches.branchList[b].address_two); }
              if( rootState.Branches.branchList[b].postal_code && rootState.Branches.branchList[b].postal_code != '' ) { objAddress.push(rootState.Branches.branchList[b].postal_code); }
              if( rootState.Branches.branchList[b].contact_no && rootState.Branches.branchList[b].contact_no != '' ) { objAddress.push(rootState.Branches.branchList[b].contact_no); }

              if( objAddress.length > 0 ) {
                address = objAddress.join('<br />');
              } else {
                address = 'N/A';
              }

            }
          }
        }

        html += '    <div class="client-details" style="display: block; float: left; clear: both; width:100%;">';
        html += '        <span class="client-logo" style="vertical-align: top; display: block; float: left;width:50%">';
        html += '            <img src="'+logo+'" style="max-width: 150px">';
        html += '        </span>';
        html += '        <span class="client-logo" style="line-height:11px;text-align: right; font-size:9px;vertical-align: top; display: block; float: right;width:50%">';
        html += address;
        html += '        </span>';
        html += '    </div>';

        /*html += '        <span class="client-address" style="border: 1px solid black !important;z-index:9999 !important;position:relative; top: -20px; float:right; font-size: 10px; line-height:12px; color: black; vertical-align: top">';
        html += address;
        html += '        </span>';*/
        //html += '    </div>';
        html += '    <div class="quote-header" style="background-color: #f1f1f1; padding: 15px 20px;float:left;clear:both; width:520px;margin-top:10px;">';
        html += '        <span class="customer-details" style="display: inline-block" style="width:50%">';

        if( cdd.customerDetails != '' ) {
          /*html += '            <div class="customer-company" style="font-size: 12px"><b>XYZ Trading</b></div>';*/
          html += '            <div class="customer" style="font-size:12px;line-height:12px">';
          html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;font-weight: 700 !important;"><b>Customer Details:</b></div>';
          html += '<span style="font-size: 9px;line-height:12px;">' + cdd.customerDetails + '</span>';
          html += '            </div>';
        }

        /*if(  ) {
          html += '            <div class="customer-delivery" style="padding-top: 15px">';
          html += '                <div class="label" style="font-size: 10px"><b>Delivery Address:</b></div>';
          html += '                <div class="address" style="font-size: 10px;line-height:12px;">';
          html += '                    18 Newbury Avenue, Constantia<br>';
          html += '                    Cape Town, 8976';
          html += '                </div>';
          html += '            </div>';
        }*/

        if( cdd.deliveryDetails != '' ) {
          html += '<span style="font-size: 9px !important;line-height:12px;">';
          if( objAuth.doc_show_delivery_details == false || objAuth.doc_show_delivery_details == 0 ) {
            if( cdd.vendorDetails != '' ) {
              html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;margin-top: 15px;"><b>Vendor Details:</b></div>';
              html += cdd.vendorDetails;
            }
          } else {
            if( cdd.deliveryDetails == '' || cdd.deliveryDetails == undefined ) {
              html += '            <div class="customer-delivery" style="padding-top: 15px">';
              html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;"><b>Delivery Address:</b></div>';
              html += '                <div class="address" style="font-size: 9px;line-height:12px;">';
              html += 'N/A';
              html += '                </div>';
              html += '            </div>';
            } else {
              html += '            <div class="customer-delivery" style="padding-top: 15px">';
              html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;"><b>Delivery Address:</b></div>';
              html += '                <div class="address" style="font-size: 9px;line-height:12px;">';
              html += cdd.deliveryDetails;
              html += '                </div>';
              html += '            </div>';
            }
          }
          html += '</span>';
        } else {
          html += '<span style="font-size: 10px !important;">';
          if( objAuth.doc_show_delivery_details == false || objAuth.doc_show_delivery_details == 0 ) {
            html += '            <div class="customer-delivery" style="padding-top: 15px">';
            html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;"><b>Delivery Address:</b></div>';
            html += '                <div class="address" style="font-size: 9px;line-height:12px;">';
            html += 'Collect';
            html += '                </div>';
            html += '            </div>';
          } else {
            html += '            <div class="customer-delivery" style="padding-top: 15px">';
            html += '                <div class="label" style="font-size: 11px;margin-bottom: 5px;"><b>Delivery Address:</b></div>';
            html += '                <div class="address" style="font-size: 9px;line-height:12px;">';
            html += cdd.vendorDetails;
            html += '                </div>';
            html += '            </div>';
          }
          html += '</span>';
        }

        html += '        </span>';
        html += '        <span class="document-details" style="display: inline-block; vertical-align: top; text-align: right; float:right;width:50%;">';
        html += '            <div class="document-type" style="font-size: 24px;margin-top: -4px;"><b>PURCHASE ORDER</b></div>';
        html += '            <div class="document-type" style="font-size: 9px;margin-top: 2px;"><b>Purchase Order NO:</b>&nbsp;'+poNo+'</div>';
        html += '            <div class="document-type" style="font-size: 9px;margin-top: 2px;"><b>Date:</b>&nbsp;'+today+'</div>';

        if( objAuth.doc_show_po_quote_details == '1' ) {
          html += '            <div class="document-type" style="font-size: 9px;margin-top: 2px;padding-top: 15px; color: grey;"><b>Quote Ref:</b>&nbsp;'+payload.quote_no+'</div>';
        }
        html += '        </span>';
        html += '    </div>';
        html += '                <div class="line-items" style="float: left; clear:both;width:100%;">';
        html += '                    <table style="margin-top: 20px;clear:both;border-collapse: collapse; font-size: 12px;width:100% !important;">';
        html += '                        <tbody>';

        if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
          html += '<tr style="border-bottom: 1px solid #ECECEC;">';
          html += '<td style="width:50%;font-size:11px;"><b>ITEM</b></td>';
          html += '<td style="width:50%;font-size:11px;"><b>QUANTITY</b></td>';
          html += '</tr>';
        } else {
          html += '<tr style="border-bottom: 1px solid #ECECEC;">';
          html += '<td style="width:50%;font-size:11px;"><b>ITEM</b></td>';
          html += '<td style="width:10%;font-size:11px;"><b>QUANTITY</b></td>';
          html += '<td style="width:20%;font-size:11px; white-space: nowrap;text-align:right;"><b>UNIT PRICE</b></td>';
          html += '<td style="width:20%;font-size:11px;white-space: nowrap;text-align:right;"><b>TOTAL PRICE</b></td>';
          html += '</tr>';
        }

        var totalQuotePrice = 0;
        if( payload.items.length > 0 ) {

          if (cdd.pdf_number_attachments == 1) {

            var itemNumbering = [];

            for (var i in payload.items) {
              var lineItemData = JSON.parse(payload.items[i].line_item_data);
              if (itemNumbering[lineItemData.group_item] == undefined) {
                itemNumbering[lineItemData.group_item] = [];
              }
              itemNumbering[lineItemData.group_item].push(payload.items[i]);
            }

            var c = 1;
            for (var n in itemNumbering) {
              html += '                        <tr class="spec-number">';
              html += '                            <td colspan="4" style="color:grey; font-size: 10px !important;">#'+c+'</td>';
              html += '                        </tr>';

              for (var i in itemNumbering[n]) {
                var lineItemData = JSON.parse(itemNumbering[n][i].line_item_data);

                var dataUrl = payload.items[i].itemName.replace(/%20/g, " ");
                dataUrl = dataUrl.replace(/%27/g, "'");
                dataUrl = dataUrl.replace(/%3A/g, ":");
                dataUrl = dataUrl.replace(/%3B/g, ";");
                dataUrl = dataUrl.replace(/%3C/g, "<");
                dataUrl = dataUrl.replace(/%3D/g, "=");
                dataUrl = dataUrl.replace(/%3E/g, ">");
                dataUrl = dataUrl.replace(/%2C/g, ",");
                dataUrl = dataUrl.replace(/%28/g, "(");
                dataUrl = dataUrl.replace(/%29/g, ")");
                dataUrl = dataUrl.replace(/&sup/g, "");
                dataUrl = dataUrl.replace(/;/g, "");
                dataUrl = dataUrl.replace(/%AE/g, "&reg;");

                if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
                  html += '<tr style="font-size:10px;border-bottom: 1px solid #ECECEC;padding-bottom:6px;">';
                  html += '<td style="width:50%;text-align:left;font-size:9px !important;"><span style="font-size:10px !important;">' + dataUrl + '</span></td>';
                  html += '<td style="width:50%;text-align:left;font-size:9px !important;"><span style="font-size:10px !important;">' + itemNumbering[n][i].quantity + ' '+itemNumbering[n][i].uom+'</span></td>';
                  html += '</tr>';
                } else {
                  html += '<tr style="font-size:10px;border-bottom: 1px solid #ECECEC;padding-bottom:6px;">';
                  html += '<td style="width:50%;text-align:left;font-size:9px !important;"><span style="font-size:10px !important;">' + dataUrl + '</span></td>';
                  html += '<td style="width:10%;text-align:left;font-size:9px !important;"><span style="font-size:10px !important;">' + itemNumbering[n][i].quantity + ' ' + itemNumbering[n][i].uom + '</span></td>';

                  var price = parseFloat(payload.items[i].price);
                  if (objAuth.privileges.indexOf('VENDOR_COST_PRICE') != -1 && lineItemData.cost_price != undefined) {
                    price = parseFloat(lineItemData.cost_price);
                  }

                  price = price - payload.items[i].discount;

                  html += '<td style="width:20%;text-align:right;font-size:9px !important;" class="text-xs-right"><span style="font-size:10px !important;">R' + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';
                  var totalPrice = price * itemNumbering[n][i].quantity;

                  totalQuotePrice = parseFloat(totalQuotePrice) + parseFloat(totalPrice);
                  html += '<td style="width:20%;text-align:right;font-size:9px !important;" class="text-xs-right"><span style="font-size:10px !important;">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';
                  html += '</tr>';
                }
              }
              c++;
            }
          } else {
            for (var i in payload.items) {
              var lineItemData = JSON.parse(payload.items[i].line_item_data);

              var dataUrl = payload.items[i].itemName.replace(/%20/g, " ");
              dataUrl = dataUrl.replace(/%27/g, "'");
              dataUrl = dataUrl.replace(/%3A/g, ":");
              dataUrl = dataUrl.replace(/%3B/g, ";");
              dataUrl = dataUrl.replace(/%3C/g, "<");
              dataUrl = dataUrl.replace(/%3D/g, "=");
              dataUrl = dataUrl.replace(/%3E/g, ">");
              dataUrl = dataUrl.replace(/%2C/g, ",");
              dataUrl = dataUrl.replace(/%28/g, "(");
              dataUrl = dataUrl.replace(/%29/g, ")");
              dataUrl = dataUrl.replace(/&sup/g, "");
              dataUrl = dataUrl.replace(/;/g, "");
              dataUrl = dataUrl.replace(/%AE/g, "&reg;");

              if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
                html += '                        <tr>';
                html += '                            <td style="width:50%;padding-left: 20px; padding-right: 50px;font-size:9px !important;">' + dataUrl + '</td>';
                html += '                            <td style="width:50%;text-align: right;font-size:9px !important;">' + payload.items[i].quantity + ' ' + payload.items[i].uom + '</td>';
                html += '                        </tr>';
              } else {

                html += '                        <tr>';
                html += '                            <td style="width:50%;padding-left: 20px; padding-right: 50px;font-size:9px !important;">' + dataUrl + '</td>';
                html += '                            <td style="width:10%;text-align: left;font-size:9px !important;">' + payload.items[i].quantity + ' ' + payload.items[i].uom + '</td>';

                var price = parseFloat(payload.items[i].price);
                if (objAuth.privileges.indexOf('VENDOR_COST_PRICE') != -1 && lineItemData.cost_price != undefined) {
                  price = parseFloat(lineItemData.cost_price);
                }

                price = price - payload.items[i].discount;

                // html += '<td style="text-align:right;font-size:10px;"><span style="font-size:10px;">R' + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';
                var totalPrice = price * payload.items[i].quantity;

                totalQuotePrice = parseFloat(totalQuotePrice) + parseFloat(totalPrice);
                // html += '<td style="text-align:right;font-size:10px;"><span style="font-size:10px;">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';

                html += '                            <td style="text-align: right;font-size:9px !important;">R' + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
                html += '                            <td style="text-align: right;font-size:9px !important;">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';

                html += '</tr>';
              }
            }
          }

          var taxValue = totalQuotePrice * 0.15;
          totalQuotePrice = totalQuotePrice * 1.15;

          html += '                        <tfoot>';
          html += '                        <tr><td colspan="4" style="padding: 0;">&nbsp;</td> </tr>';
          html += '                        <tr></tr>';
          html += '                        <td colspan="3"padding: 0;">&nbsp;</td>';
          html += '                        <td colspan="1" style="border-bottom: 1px solid black !important;padding: 0;">&nbsp;</td>';
          html += '                        </tr>';
          html += '                        <tr>';
          html += '                            <td colspan="3" style="text-align: right; font-size: 11px"><b>TOTAL</b></td>';
          html += '                            <td style="text-align: right; font-size: 11px; border-bottom: 4px double black;">R' + totalQuotePrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
          html += '                        </tr>';
          html += '                        <tr>';
          html += '                            <td colspan="4" style="text-align: right; font-size: 9px;margin-top: 10px;">&nbsp;</td>';
          html += '                        </tr>';
          html += '                        <tr>';
          html += '                            <td colspan="3" style="text-align: right; font-size: 9px;margin-top: 10px;">Including VAT @ 15%</td>';
          html += '                            <td style="text-align: right; font-size: 9px;">R '+taxValue.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+'</td>';
          html += '                        </tr>';
          html += '                        </tfoot>';
        }
        html += '                    </table>';
        html += '                </div>';
        html += '<html>';
        html += '<head>';
        html += '    <link rel="preconnect" href="https://fonts.googleapis.com">';
        html += '    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>';
        html += '    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap" rel="stylesheet">';
        //html += '    <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap" rel="stylesheet">';
        html += '    <style type="text/css">';
        html += '        body {';
        html += '            font-family: "Open Sans" !important;';
        html += '            font-size: 14px;';
        html += '        }';
        html += '        .line-items table th, .line-items table td {';
        html += '            padding: 4px 8px;';
        html += '            vertical-align: top;';
        html += '        }';
        html += '        .last-spec-item td {';
        html += '            border-bottom: 1px solid #f1f1f1;';
        html += '        }';
        html += '        table {';
        html += '            width: 100%;';
        html += '        }';
        html += '        table.quickestimate, table.quickestimate tr, table.quickestimate tr td, table.quickestimate tr th {';
        html += '            font-size: 10px !important;';
        html += '        }';
        html += '        table.specialordertable, table.specialordertable tr, table.specialordertable tr td, table.specialordertable tr th {';
        html += '            font-size: 10px !important;';
        html += '        }';
        html += '        table.specification-spec-table, table.specification-spec-table tr, table.specification-spec-table tr td, table.specification-spec-table tr th {';
        html += '            font-size: 10px !important;';
        html += '        }';
        html += '        table.blindOrder, table.blindOrder tr, table.blindOrder tr td, table.blindOrder tr th {';
        html += '            font-size: 10px !important;';
        html += '        }';
        html += '    </style>';
        html += '</head>';
        html += '<body>';
        html += '<div style="position: relative;height: 100%; page-break-before: always !important;margin-left: auto; margin-right: auto; max-width: 720px;">';

        html += '    <div class="section-header" style="padding-bottom: 3px;padding-top: 10px; font-size: 16px; border-bottom: 1px solid #f1f1f1; text-align: center"><b>PRODUCT INFORMATION</b></div>';

        var checkFourSure = JSON.parse( payload.items[0].line_item_data );

        if( checkFourSure.installation_customer_first_name != null ) {

          var lineDataCount = Object.keys(checkFourSure).length;
          lineDataCount = lineDataCount - 25;
          var productCount = Math.floor( lineDataCount / 6 );

          html += '<div class="lineItemDetails" style="font-size: 12px !important;">';
          html += '<br />';
          html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
          html += '            <tr>';
          html += '              <th colspan="4" style="font-size:12px;"><strong>Customer Details</strong></th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="25%" style="font-size:10px !important;background: #ECECEC;">First Name</th>';
          html += '              <th width="25%" style="font-size:10px !important;background: #ECECEC;">Last Name</th>';
          html += '              <th width="25%" style="font-size:10px !important;background: #ECECEC;">Email Address</th>';
          html += '              <th width="25%" style="font-size:10px !important;background: #ECECEC;">Contact Number</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_first_name +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_last_name +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_email +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_contact_number +'</td>';
          html += '            </tr>';
          html += '          </table>';
          html += '          <br />';
          html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
          html += '            <tr>';
          html += '              <th colspan="4" style="font-size:12px;"><strong>Address Details</strong></th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="50%" colspan="2" style="font-size:10px !important;background: #ECECEC;">Address Found</th>';
          html += '              <th width="50%" colspan="2" style="font-size:10px !important;background: #ECECEC;">Address Searched</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="50%" colspan="2" style="font-size:9px !important;">'+checkFourSure.installation_address_found +'</td>';
          html += '              <td width="50%" colspan="2" style="font-size:9px !important;">'+checkFourSure.installation_address_searched +'</td>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="25%" style="padding-top: 6px;font-size:10px !important;background: #ECECEC;">Suburb</th>';
          html += '              <th width="25%" style="padding-top: 6px;font-size:10px !important;background: #ECECEC;">Province</th>';
          html += '              <th width="25%" style="padding-top: 6px;font-size:10px !important;background: #ECECEC;">Installation Lat</th>';
          html += '              <th width="25%" style="padding-top: 6px;font-size:10px !important;background: #ECECEC;">Installation Long</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_suburb +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_province +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_install_lat +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_install_long +'</td>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Store Lat</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Store Long</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Store Name</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Store Code</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_lat +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_long +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_name +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.store_id +'</td>';
          html += '            </tr>';
          html += '          </table>';
          html += '          <br />';
          html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
          html += '            <tr>';
          html += '              <th colspan="5" style="font-size:12px;"><strong>Install Details</strong></th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Appointment Date Start</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Appointment Date End</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Appointment Contact Number</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;background: #ECECEC;" width="25%">Appointment Contact Person</th>';
          html += '            </tr>';
          var objDates = checkFourSure.installation_appointment_date_start.split(',');
          var toReturn = '<p>'+objDates[objDates.length - 1]+'</p>';
          if( objDates.length > 1 ) {
            toReturn += '<small><strong>OLD DATES</strong></small><br />';
            for( var d in objDates ) {
              if( objDates[d] != objDates[objDates.length - 1] ) {
                toReturn += '<small>'+objDates[d]+'</small><br />';
              }
            }
          }
          html += '            <tr>';
          html += '              <td width="25%" style="font-size:9px !important;">'+toReturn +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_date_end +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_contact_number +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_contact_person +'</td>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="100%" colspan="4" style="font-size:10px !important;padding-top: 6px;background: #ECECEC;">Lookup Service Rep</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="100%" colspan="4" style="font-size:9px !important;">'+checkFourSure.installation_lookup_service_ref +'</td>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="80%" colspan="3" style="font-size:10px !important;background: #ECECEC;">Appointment Installation Notes</th>';
          html += '              <th width="20%" style="font-size:10px !important;background: #ECECEC;">Installation Sales Order Number</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="80%" colspan="3" style="font-size:9px !important;">'+checkFourSure.installation_notes+'</td>';
          html += '              <td width="20%" style="font-size:9px !important;">'+checkFourSure.installation_sales_order_number +'</td>';
          html += '            </tr>';
          html += '          </table>';
          html += '          <br />';
          html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
          html += '            <tr>';
          html += '              <th colspan="6" style="font-size:12px;"><strong>Product Details</strong></th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product Description</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product Make</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product Type</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product SKU</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product MO ID</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;background: #ECECEC;">Product QTY</th>';
          html += '            </tr>';
          if( productCount >= 1 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_1 +'</td>';
            html += '            </tr>';
          }
          if( productCount >= 2 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_2 +'</td>';
            html += '            </tr>';
          }
          if( productCount >= 3 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_3 +'</td>';
            html += '            </tr>';
          }
          if( productCount >= 4 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_4 +'</td>';
            html += '            </tr>';
          }
          if( productCount >= 5 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_5  +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_5 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_5 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_5 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_5 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_5 +'</td>';
            html += '            </tr>';
          }
          html += '          </table>';
          html += '          <br />';
          html += '        </div>';

        } else {

          if( cdd.pdf_number_attachments == 1 ) {

            html += '<br /><div class="specHolder" style="font-size: 12px !important;">';

            var c = 1;
            for( var n in itemNumbering ) {
              html += '<tr style="font-size:9px;"><td colspan="4">#' + c + '</td></tr>';
              // for (var i in itemNumbering[n]) {

              if( itemNumbering[n] == 1 ){
                if( itemNumbering[n][0].spec != '' ) {
                  html += itemNumbering[n][0].spec;
                } else {
                  html += 'N/A';
                }
              } else {
                var hasLinked = false;
                for (var i in itemNumbering[n]) {
                  if( itemNumbering[n][i].linked_props != '' ) {
                    hasLinked = true;
                  }
                }
                if( hasLinked == false ) {
                  html += itemNumbering[n][0].spec;
                } else {
                  for (var i in itemNumbering[n]) {
                    if (itemNumbering[n][i].linked_props != '' || itemNumbering[n].length == 1) {
                      html += itemNumbering[n][i].spec;
                    }
                  }
                }
              }

              // }
              c++;
            }

            html += '</div>';

          } else {

            var spec = payload.items[0].spec.replace(/(<style[\w\W]+style>)/g, "");
            spec = spec.replace(/(<style[\w\W]+style>)/g, "");

            html += '<br /><div class="specHolder" style="font-size: 10px !important;">';
            if( payload.items.length == 1 ){
              if( payload.items[0].spec == '' ) {
                html += '<span style="display: block; float: left;font-size: 10px !important;">N/A</span>';
              } else {
                console.log( payload.items[0].spec );
                html += '<span style="display: block; float: left;font-size: 10px !important;">' + payload.items[0].spec + '</span>';
              }
            } else {
              var hasLinked = false;
              for (var i in payload.items) {
                if( payload.items[i].linked_props != '' ) {
                  hasLinked = true;
                }
              }
              if( hasLinked == false ) {
                console.log( payload.items[0].spec );
                html += '<span style="font-size: 10px !important;">' + payload.items[0].spec + '</span>';
              } else {
                for (var i in payload.items) {
                  if (payload.items[i].linked_props != '' || payload.items.length == 1) {
                    console.log( payload.items[i].spec );
                    html += '<span style="font-size: 10px !important;">' + payload.items[i].spec + '</span>';
                  }
                }
              }
            }
            html += '</div>';
          }

        }

        // we need to check if there are images
        var hasImage = false;
        for (var i in payload.items) {
          if( payload.items[i].image != '' ) {
            hasImage = true;
          }
        }

        if( hasImage == true ) {
          html += '<br /><br /><div class="section-header" style="padding-bottom: 3px;font-size: 16px; border-bottom: 1px solid #f1f1f1; text-align: center"><b>PRODUCT IMAGES</b></div>';
          if (cdd.pdf_number_attachments == 1) {

            html += '<br /><div class="specHolder" style="font-size: 12px !important;">';

            var c = 1;
            for (var n in itemNumbering) {
              html += '<tr style="font-size:9px;"><td colspan="4">#' + c + '</td></tr><br /><br />';
              // for (var i in itemNumbering[n]) {

              if (itemNumbering[n] == 1) {
                html += '<img style="max-width:200px;" src="' + itemNumbering[n][0].image + '" />';
              } else {
                var hasLinked = false;
                for (var i in itemNumbering[n]) {
                  if (itemNumbering[n][i].linked_props != '') {
                    hasLinked = true;
                  }
                }
                if (hasLinked == false) {
                  html += '<img style="max-width:200px;" src="' + itemNumbering[n][0].image + '" />';
                } else {
                  for (var i in itemNumbering[n]) {
                    if (itemNumbering[n][i].linked_props != '' || itemNumbering[n].length == 1) {
                      html += '<img style="max-width:200px;" src="' + itemNumbering[n][i].image + '" />';
                    }
                  }
                }
              }

              // }
              c++;
            }

            html += '</div>';

          } else {
            html += '<br /><div class="specHolder" style="font-size: 12px !important;">';
            if (payload.items.length == 1) {
              html += '<img style="max-width:200px;" src="' + payload.items[0].image + '" />';
            } else {
              var hasLinked = false;
              for (var i in payload.items) {
                if (payload.items[i].linked_props != '') {
                  hasLinked = true;
                }
              }
              if (hasLinked == false) {
                html += '<img style="max-width:200px;" src="' + payload.items[0].image + '" />';
              } else {
                for (var i in payload.items) {
                  if (payload.items[i].linked_props != '' || payload.items.length == 1) {
                    html += '<img style="max-width:200px;" src="' + payload.items[i].image + '" />';
                  }
                }
              }
            }
            html += '</div>';
          }
          html += '<div>';
        }

        html += '</div>';
        html += '</body>';
        html += '</html>';
        html += '<html>';
        html += '    <link rel="preconnect" href="https://fonts.googleapis.com">';
        html += '    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>';
        html += '    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap" rel="stylesheet">';
        //html += '    <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap" rel="stylesheet">';
        html += '    <style type="text/css">';
        html += '        body {';
        html += '            font-family: "Open Sans" !important;';
        html += '            font-size: 14px;';
        html += '            text-rendering: optimize-speed !important;';
        html += '        }';
        html += '        .line-items table th, .line-items table td {';
        html += '            padding: 4px 8px;';
        html += '            vertical-align: top;';
        html += '        }';
        html += '        .last-spec-item td {';
        html += '            border-bottom: 1px solid #f1f1f1;';
        html += '        }';
        html += '        table {';
        html += '            width: 100%;';
        html += '        }';
        html += '        .termsandconditions h3 {';
        html += '            font-size:12px: 100%;';
        html += '        }';
        html += '        .termsandconditions, .termsandconditions p  {';
        html += '            font-size:12px: 100%;';
        html += '        }';
        html += '    </style>';
        html += '</head>';
        html += '<body>';
        html += '<div style="position: relative;height: 100%; page-break-before: always !important;margin-left: auto; margin-right: auto; max-width: 720px;">';
        // html += '<div style="position: relative; padding-top: 30px; height: 100%; page-break-before: always !important;margin-left: auto; margin-right: auto; max-width: 720px;">';
        html += '    <div class="section-header" style="padding-bottom: 3px; font-size: 16px; border-bottom: 1px solid #f1f1f1; text-align: center"><b>TERMS AND CONDITIONS</b></div>';
        html += '    <div class="termsandconditions" style="padding-top: 25px;font-size:9px; line-height: 11px;">';
        if( termsConditions != '' ) {
          html += termsConditions;
        } else {
          html += cdd.tcs;
        }
        html += '    </div>';
        html += '</div>';
        html += '</body>';
        html += '</html>';

        var documentFormat = {};
        documentFormat.border = {};
        documentFormat.border.top = '15px';
        documentFormat.border.left = '15px';
        documentFormat.border.right = '15px';
        documentFormat.border.bottom = '15px';
        documentFormat.footer = {};
        // documentFormat.header = {};
        documentFormat.footer.contents = {};
        // documentFormat.header.contents = {};
        // documentFormat.header.height = {};
        var footer = '';
        footer += '<footer style="position: absolute; bottom: 0;width:100%;">';
        footer += '    <div class="footer" style="border-top: 1px solid #f1f1f1; text-align: center">';
        footer += '        <div class="page-number" style="font-size: 8px;line-height:10px;">PAGE {{page}} OF {{pages}}</div>';
        footer += '        <div class="client-name" style="font-size: 8px;line-height:10px; color: grey">'+objAuth.manufacturer_name.toUpperCase()+'</div>';
        footer += '        </div>';
        footer += '</footer>';
        /*var header = '';
        header += '    <div class="client-details">';
        header += '        <span class="client-logo" style="vertical-align: top; display: block; float: left;width:50%">';
        header += '            <img src="'+logo+'" width="150">';
        header += '        </span>';
        header += '        <span class="client-logo" style="marin-top: -10px; line-height:11px;text-align: right; font-size:9px;vertical-align: top; display: block; float: right;width:50%">';
        header += address;
        header += '        </span>';
        header += '    </div>';*/

        documentFormat.footer.contents.default = footer;
        //documentFormat.header.contents.default = header;
        //documentFormat.header.height = '15mm';

        var htmlDetails = {
          html: html,
          documentFormat: documentFormat
        }

        Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
          .then(response => {
            return response.body;
          }, error => {
            console.log(error);
          }).then(data => {

          var reportDownload = document.createElement('a');
          reportDownload.setAttribute('href', 'data:application/octet-stream;base64,' + data);
          reportDownload.setAttribute('download', 'PO-' + poNo+'.pdf');
          reportDownload.click();

        });

          /*var salesOrderNumber = payload.bwSalesOrderNo;
          if( salesOrderNumber == '' ) { salesOrderNumber = 'N/A' }

        var html = '';

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();

        today = dd + '/' + mm + '/' + yyyy;

        var logo = window.location.protocol + process.env.MYSPEC_ENDPOINT + 'profile.php?t=/' + objAuth.myspec_url + '&p=' + objAuth.header_logo_img;

        var poNo = String(payload.quoteId) + String(payload.vendor) + String(payload.customer);
            poNo = poNo.padEnd(12, '0');

        html += '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">';
        html += '<html lang="en">';
        html += '<head>';
        html += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">';
        html += '<meta name="viewport" content="width=device-width, initial-scale=1">';
        html += '<meta http-equiv="X-UA-Compatible" content="IE=edge">';
        html += '<title>Purchase Order</title>';
        html += '<link rel="preconnect" href="https://fonts.googleapis.com">';
        html += '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>';
        html += '<link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap" rel="stylesheet">';
        html += '<style type="text/css">';
        html += "body {  font-family: 'Source Sans Pro', sans-serif; !important; }";
        html += '.lineItemDetails .spec-lineitem-number {';
        html += 'padding: 5px;';
        html += '}';
        html += '.lineItemDetails h2 {';
        html += 'margin-bottom: 0;';
        html += '}';
        html += '.BasketCode {';
        html += 'font-style: italic;';
        html += '}';
        html += '.spec-lineitem-number {';
        html += 'font-weight: bold;';
        html += 'font-size: 10px;';
        html += 'border-top: 1px solid #f1f1f1;';
        html += '}';
        html += '.subtotalexvatprice {';
        html += 'border-top: 1px solid #000;';
        html += '}';
        html += 'body {';
        html += 'font-size: 10px;';
        html += '}';
        html += 'h2 {';
        html += 'padding: 5px;';
        html += 'background: #f1f1f1;';
        html += '}';
        html += '.headertitle {';
        html += 'font-weight: bold';
        html += '}';
        html += '.quoteDetailsLogo img {';
        html += 'max-width: 300px;';
        html += 'max-height: 80px;';
        html += '}';
        html += '.quoteDetailsLogo {';
        html += 'width: 50%;';
        html += 'float: left;';
        html += '}';
        html += '.quoteDetailsHeaderRight {';
        html += 'width: 33%;';
        html += 'float: right;';
        html += '}';
        html += '.documenttype {';
        html += 'font-weight: bold;';
        html += 'font-size: 16px;';
        html += 'margin-bottom: 0px;';
        html += '}';
        html += '.quoteDetails {';
        html += 'max-width: 540px;';
        html += 'width: 540px;';
        html += 'margin: 0 auto;';
        html += '}';
        html += '.quoteDetailsHeaderCustomer,';
        html += '.quoteDetailsHeaderCustomerDelivery,';
        html += '.quoteDetailsHeaderQuote {';
        html += 'margin-top: 20px;';
        html += 'display: inline-block;';
        html += 'width: 33%;';
        html += 'vertical-align: top;';
        html += '}';
        html += '.quoteDetailsHeaderInfo {';
        html += 'float: left;';
        html += 'width: 100%;';
        html += 'margin-top: 10px;';
        html += '}';
        html += '.quoteDetailsHeaderTitle {';
        html += 'font-weight: bold;font-size: 10px !important;';
        html += '}';
        html += 'table.quotetable {';
        html += 'width: 100%;';
        html += 'border-collapse: collapse;';
        html += '}';
        html += '.quotecontent {';
        html += 'margin-top: 30px;';
        html += 'float: left;';
        html += 'width: 100%;';
        html += '}';
        html += '.datatableheadermain {';
        html += 'background: #f1f1f1;';
        html += '}';
        html += '.datatableheadermain th {';
        html += 'padding: 10px;';
        html += '}';
        html += '.text-xs-right {';
        html += 'text-align: right;';
        html += '}';
        html += 'table.quotetable td {';
        html += 'padding: 10px 2px 10px 5px;font-size: 10px !important';
        html += '}';
        html += 'tfoot {';
        html += 'border-top: 1px solid #828080;';
        html += '}';
        html += '.totallabel {';
        html += 'font-weight: bold;';
        html += '}';
        html += '.totalprice {';
        html += 'border-top: 1px solid grey;';
        html += 'border-bottom: 4px double grey;';
        html += '}';
        html += '.lineItemDetail table {';
        html += 'width: 100%;';
        html += 'max-width: 1024px;';
        html += '}';
        html += '.lineItemDetail table td {';
        html += 'width: 50%;';
        html += 'font-size: 10px;';
        html += 'padding-bottom: 5px;';
        html += '}';
        html += '.lineItemDetails {';
        html += 'padding-top: 10px;';
        html += '}';
        html += 'h4.lineItemDetailsHeader {';
        html += 'font-size: 10px;';
        html += 'margin-bottom: 20px;';
        html += '}';
        html += '.lineItemDetail table td.cellheader {';
        html += 'font-weight: bold;';
        html += '}';
        html += '.lineItemDetail table td.cellheader .cellinfo {';
        html += 'font-weight: 400;';
        html += '}';
        html += '.lineItemDetail table td.cellheader {';
        html += 'font-weight: bold;';
        html += 'padding-top: 15px;';
        html += '}';
        html += '.lineItemDetail .bwpaintspecs th {';
        html += 'text-align: left;';
        html += 'font-size: 10px;';
        html += '}';
        html += '.lineItemDetail .bwpaintspecs td {';
        html += 'font-size: 10px !important;';
        html += '}';
        html += '.installation tbody {';
        html += 'height: auto;';
        html += 'min-height: auto;';
        html += '}';
        html += '.installation th strong {';
        html += 'background: #333;';
        html += 'width: 100%;';
        html += 'display: block;';
        html += 'color: #fff;';
        html += 'padding: 5px;';
        html += '}';
        html += '.installation td {';
        html += 'text-align: center !important;';
        html += 'font-size: 10px !important;';
        html += 'background: #fff !important;';
        html += 'border: 1px solid #ddd !important;';
        html += 'padding: 10px !important;';
        html += '}';
        html += '.lineItemDetail table.specification-spec-table td {';
        html += 'width: 25%;';
        html += '}';
        html += '.lineItemDetail li {';
        html += 'font-size: 10px;';
        html += '}';
        html += '.payment-text {';
        html += 'padding-top: 10px;';
        html += '}';
        html += '</style>';
        html += '</head>';
        html += '<body>';
        html += '<div class="container quoteDetails">';
        html += '<div class="layout wrap">';
        html += '<div class="quoteDetailsLogo">';
        html += '<img style="max-width:150px;" src="'+logo+'"><br>';
        html += '</div>';
        html += '<div class="quoteDetailsHeaderRight">';
        html += '<div class="documenttype" style="text-align: right;margin-bottom: 10px;font-size:18px !important">PURCHASE ORDER</div>';
        html += '<div style="text-align: right;"><span class="headertitle" style="font-size: 10px">Purchase Order No:</span> <span style="font-size: 10px">'+poNo+'</span></div>';
        html += '<div style="text-align: right;"><span class="headertitle" style="font-size: 10px">Date:</span> <span style="font-size: 10px">'+today+'</span></div><br>';
        if( objAuth.doc_show_delivery_details == 1 || objAuth.doc_show_delivery_details == '1' ) {
          html += '<div style="text-align: right;"><span class="headertitle" style="font-size: 10px">Vendor</span><br /><span style="font-size: 10px">'+payload.vendorName+'<br />'+payload.vendorDetails.email+'<br />'+payload.vendorDetails.address+'</span></div>';
        } else {
          html += '<div style="text-align: right;"><span class="headertitle" style="font-size: 10px">Vendor</span>: <span style="font-size: 10px">'+payload.vendorName+'</span></div>';
        }

        html += '</div>';
        html += '<div class="quoteDetailsHeaderInfo">';

        if( objAuth.doc_show_customer_details == true || objAuth.doc_show_customer_details == 1 ) {
          html += '<div class="quoteDetailsHeaderCustomer">';
          html += '<div class="quoteDetailsHeaderTitle" style="font-size:12px !important;margin-bottom: 6px;">CUSTOMER DETAILS</div>';
          if (cdd.customerDetails != '') {
            html += '<span style="font-size: 10px">';
            html += cdd.customerDetails;
            html += '</span>';
          } else {
            html += '<span style="font-size: 10px">';
            html += 'N/A';
            html += '</span>';
          }
          html += '</div>';
        }

        html += '<div class="quoteDetailsHeaderCustomerDelivery">';
        html += '<div class="quoteDetailsHeaderTitle" style="font-size:12px !important;margin-bottom: 6px;">DELIVERY DETAILS</div>';
        html += '<span>';
        if( cdd.deliveryDetails != '' ) {
          html += '<span style="font-size: 10px">';
          if( objAuth.doc_show_delivery_details == true || objAuth.doc_show_customer_details == 1 ) {
            html += cdd.deliveryDetails;
          } else {
            html += cdd.vendorDetails;
          }
          html += '</span>';
        } else {
          html += '<span style="font-size: 10px">';
          if( objAuth.doc_show_delivery_details == true || objAuth.doc_show_customer_details == 1 ) {
            html += 'N/A';
          } else {
            html += cdd.vendorDetails;
          }
          html += '</span>';
        }
        html += '</span>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        html += '<div class="quotecontent">';
        html += '<table class="quotetable">';
        html += '<thead>';
        if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
          html += '<tr class="datatableheadermain">';
          html += '<th style="text-align:left;">ITEM</th>';
          html += '<th style="text-align:left;" colspan="2">QUANTITY</th>';
          html += '</tr>';
        } else {
          html += '<tr class="datatableheadermain">';
          html += '<th style="text-align:left;">ITEM</th>';
          html += '<th style="text-align:left;" colspan="2">QUANTITY</th>';
          html += '<th style="text-align:right;" class="text-xs-right">UNIT PRICE</th>';
          html += '<th style="text-align:right;" class="text-xs-right">TOTAL PRICE</th>';
          html += '</tr>';
        }
        html += '</thead>';
        html += '<tbody>';
        var totalQuotePrice = 0;
        if( payload.items.length > 0 ) {
          if( cdd.pdf_number_attachments == 1 ) {

            var itemNumbering = [];

            for( var i in payload.items ) {
              var lineItemData = JSON.parse(payload.items[i].line_item_data);
              if( itemNumbering[lineItemData.group_item] == undefined ) {
                itemNumbering[lineItemData.group_item] = [];
              }
              itemNumbering[lineItemData.group_item].push( payload.items[i] );
            }

            var c = 1;
            for( var n in itemNumbering ) {
              html += '<tr style="font-size:9px;padding-bottom: 0px !important;"><td colspan="4">#'+c+'</td></tr>';

              for( var i in itemNumbering[n] ) {
                var lineItemData = JSON.parse( itemNumbering[n][i].line_item_data );

                if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
                  html += '<tr style="font-size:10px;">';
                  html += '<td style="font-size:10px;"><span style="font-size:10px;">'+itemNumbering[n][i].itemName+'</span></td>';
                  html += '<td style="font-size:10px;"><span style="font-size:10px;">'+itemNumbering[n][i].quantity+'</span></td>';
                  html += '<td style="font-size:10px;"><span style="font-size:10px;">'+itemNumbering[n][i].uom+'</span></td>';
                  // html += '<td style="font-size:9px;" class="text-xs-right"><span style="font-size:8px;">R'+itemNumbering[n][i].price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+'</span></td>';
                  html += '</tr>';
                } else {
                  html += '<tr style="font-size:10px;">';
                  html += '<td style="font-size:10px;"><span style="font-size:10px;">'+itemNumbering[n][i].itemName+'</span></td>';
                  html += '<td style="font-size:10px;"><span style="font-size:10px;">'+itemNumbering[n][i].quantity+'</span></td>';
                  html += '<td style="font-size:10px;"><span style="font-size:10px;">'+itemNumbering[n][i].uom+'</span></td>';

                  var price = parseFloat(payload.items[i].price);
                  if (objAuth.privileges.indexOf('VENDOR_COST_PRICE') != -1 && lineItemData.cost_price != undefined) {
                    price = parseFloat(lineItemData.cost_price);
                  }

                  price = price - parseFloat(payload.items[i].discount);

                  html += '<td style="font-size:10px;" class="text-xs-right"><span style="font-size:10px;">R'+price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+'</span></td>';

                  var totalPrice = price * itemNumbering[n][i].quantity;

                  totalQuotePrice = parseFloat(totalQuotePrice) + parseFloat(totalPrice);

                  html += '<td style="font-size:10px;" class="text-xs-right"><span style="font-size:10px;">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';

                  html += '</tr>';
                }
              }
              c++;
            }
          } else {
            for( var i in payload.items ) {
              var lineItemData = JSON.parse( payload.items[i].line_item_data );

              if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
                html += '<tr style="font-size:10px;">';
                html += '<td style="font-size:10px;"><span style="font-size:10px;">'+payload.items[i].itemName+'</span></td>';
                html += '<td style="font-size:10px;" class="text-xs-right"><span style="font-size:10px;">'+payload.items[i].quantity+'</span></td>';
                html += '<td style="font-size:10px;"><span style="font-size:10px;">'+payload.items[i].uom+'</span></td>';
                // html += '<td style="font-size:9px;" class="text-xs-right"><span style="font-size:9px;">R'+payload.items[i].price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+'</span></td>';
                html += '</tr>';
              } else {
                html += '<tr style="font-size:10px;">';
                html += '<td style="font-size:10px;"><span style="font-size:10px;">'+payload.items[i].itemName+'</span></td>';
                html += '<td style="font-size:10px;" class="text-xs-right"><span style="font-size:10px;">'+payload.items[i].quantity+'</span></td>';
                html += '<td style="font-size:10px;"><span style="font-size:10px;">'+payload.items[i].uom+'</span></td>';

                var price = parseFloat(payload.items[i].price);
                if (objAuth.privileges.indexOf('VENDOR_COST_PRICE') != -1 && lineItemData.cost_price != undefined) {
                  price = parseFloat(lineItemData.cost_price);
                }

                price = price - parseFloat(payload.items[i].discount);


                html += '<td style="font-size:10px;" class="text-xs-right"><span style="font-size:10px;">R' + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';

                var totalPrice = price * payload.items[i].quantity;

                totalQuotePrice = parseFloat(totalQuotePrice) + parseFloat(totalPrice);
                html += '<td style="font-size:10px;" class="text-xs-right"><span style="font-size:10px;">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span></td>';

                html += '</tr>';
              }
            }
          }
        }
        html += '</tbody>';
        if( payload.items.length > 0 && objAuth.privileges.indexOf('VENDOR_NO_PRICE') == -1 ) {
          html += '<tfoot>';
          html += '<tr>';
          html += '<td colspan="4" class="text-xs-right totallabel">TOTAL PRICE (excl VAT)</td>';
          html += '<td class="text-xs-right totalprice">R'+totalQuotePrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+'</td>';
          html += '</tr>';
          html += '</tfoot>';
        }
        html += '</table>';
        html += '<br>';
        var checkFourSure = JSON.parse( payload.items[0].line_item_data );

        if( checkFourSure.installation_customer_first_name != null ) {

          var lineDataCount = Object.keys(checkFourSure).length;
          lineDataCount = lineDataCount - 25;
          var productCount = Math.floor( lineDataCount / 6 );

          var lineDataCount = Object.keys(checkFourSure).length;
          lineDataCount = lineDataCount - 25;
          var productCount = Math.floor( lineDataCount / 6 );

          html += '<div class="lineItemDetails">';
          html += '          <br /><br /><h2 style="font-size:14px; padding-left:20px !important;padding-bottom:10px !important;">Installation Details</h2>';
          html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
          html += '            <tr>';
          html += '              <th colspan="4"><strong>Customer Details</strong></th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="25%" style="font-size:10px !important;">First Name</th>';
          html += '              <th width="25%" style="font-size:10px !important;">Last Name</th>';
          html += '              <th width="25%" style="font-size:10px !important;">Email Address</th>';
          html += '              <th width="25%" style="font-size:10px !important;">Contact Number</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_first_name +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_last_name +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_email +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_customer_contact_number +'</td>';
          html += '            </tr>';
          html += '          </table>';
          html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
          html += '            <tr>';
          html += '              <th colspan="4"><strong>Address Details</strong></th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="50%" colspan="2" style="font-size:10px !important;">Address Found</th>';
          html += '              <th width="50%" colspan="2" style="font-size:10px !important;">Address Searched</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="50%" colspan="2" style="font-size:9px !important;">'+checkFourSure.installation_address_found +'</td>';
          html += '              <td width="50%" colspan="2" style="font-size:9px !important;">'+checkFourSure.installation_address_searched +'</td>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th style="padding-top: 6px;" width="25%" style="font-size:10px !important;">Suburb</th>';
          html += '              <th style="padding-top: 6px;" width="25%" style="font-size:10px !important;">Province</th>';
          html += '              <th style="padding-top: 6px;" width="25%" style="font-size:10px !important;">Installation Lat</th>';
          html += '              <th style="padding-top: 6px;" width="25%" style="font-size:10px !important;">Installation Long</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_suburb +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_province +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_install_lat +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_install_long +'</td>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;" width="25%">Store Lat</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;" width="25%">Store Long</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;" width="25%">Store Name</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;" width="25%">Store Code</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_lat +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_long +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_address_store_name +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.store_id +'</td>';
          html += '            </tr>';
          html += '          </table>';
          html += '          <table style="page-break-inside: avoid !important;" cellpadding="2" width="100%" class="installation">';
          html += '            <tr>';
          html += '              <th colspan="5"><strong>Install Details</strong></th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;" width="25%">Appointment Date Start</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;" width="25%">Appointment Date End</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;" width="25%">Appointment Contact Number</th>';
          html += '              <th style="padding-top: 6px;font-size:10px !important;" width="25%">Appointment Contact Person</th>';
          html += '            </tr>';
          var objDates = checkFourSure.installation_appointment_date_start.split(',');
          var toReturn = '<p>'+objDates[objDates.length - 1]+'</p>';
          if( objDates.length > 1 ) {
            toReturn += '<small><strong>OLD DATES</strong></small><br />';
            for( var d in objDates ) {
              if( objDates[d] != objDates[objDates.length - 1] ) {
                toReturn += '<small>'+objDates[d]+'</small><br />';
              }
            }
          }
          html += '            <tr>';
          html += '              <td width="25%" style="font-size:9px !important;">'+toReturn +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_date_end +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_contact_number +'</td>';
          html += '              <td width="25%" style="font-size:9px !important;">'+checkFourSure.installation_appointment_contact_person +'</td>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th style="padding-top: 6px;" width="100%" colspan="4" style="font-size:10px !important;">Lookup Service Rep</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="100%" colspan="4" style="font-size:9px !important;">'+checkFourSure.installation_lookup_service_ref +'</td>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="80%" colspan="3" style="font-size:10px !important;">Appointment Installation Notes</th>';
          html += '              <th width="20%" style="font-size:10px !important;">Installation Sales Order Number</th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <td width="80%" colspan="3" style="font-size:9px !important;">'+checkFourSure.installation_notes+'</td>';
          html += '              <td width="20%" style="font-size:8px !important;">'+checkFourSure.installation_sales_order_number +'</td>';
          html += '            </tr>';
          html += '          </table>';
          html += '          <br />';
          html += '          <table cellpadding="2" width="100%" class="installation">';
          html += '            <tr>';
          html += '              <th colspan="6"><strong>Product Details</strong></th>';
          html += '            </tr>';
          html += '            <tr>';
          html += '              <th width="16.66%" style="font-size:10px !important;">Product Description</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;">Product Make</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;">Product Type</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;">Product SKU</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;">Product MO ID</th>';
          html += '              <th width="16.66%" style="font-size:10px !important;">Product QTY</th>';
          html += '            </tr>';
          if( productCount >= 1 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_1 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_1 +'</td>';
            html += '            </tr>';
          }
          if( productCount >= 2 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_2 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_2 +'</td>';
            html += '            </tr>';
          }
          if( productCount >= 3 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_3 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_3 +'</td>';
            html += '            </tr>';
          }
          if( productCount >= 4 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_4 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_4 +'</td>';
            html += '            </tr>';
          }
          if( productCount >= 5 ) {
            html += '            <tr>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_description_5  +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_make_5 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_type_5 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_sku_5 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_moid_5 +'</td>';
            html += '              <td width="16.66%" style="font-size:9px !important;">'+checkFourSure.installation_product_qty_5 +'</td>';
            html += '            </tr>';
          }
          html += '          </table>';
          html += '          <br />';
          html += '        </div>';

        } else {

          if( cdd.pdf_number_attachments == 1 ) {

            html += '<br /><br /><div class="specHolder">';

            var c = 1;
            for( var n in itemNumbering ) {
              html += '<div style="page-break-inside: avoid !important;">';
                html += '<span>#' + c + '</span>';
                // for (var i in itemNumbering[n]) {

                if( itemNumbering[n] == 1 ){
                  html += itemNumbering[n][0].spec;
                } else {
                  var hasLinked = false;
                  for (var i in itemNumbering[n]) {
                    if( itemNumbering[n][i].linked_props != '' ) {
                      hasLinked = true;
                    }
                  }
                  if( hasLinked == false ) {
                    html += itemNumbering[n][0].spec;
                  } else {
                    for (var i in itemNumbering[n]) {
                      if (itemNumbering[n][i].linked_props != '' || itemNumbering[n].length == 1) {
                        html += itemNumbering[n][i].spec;
                      }
                    }
                  }
                }
              html += '</div>';

              // }
              c++;
            }

            html += '</div>';

          } else {
            html += '<br /><br /><div class="specHolder">';
            if( payload.items.length == 1 ){
              html += payload.items[0].spec;
            } else {
              var hasLinked = false;
              for (var i in payload.items) {
                if( payload.items[i].linked_props != '' ) {
                  hasLinked = true;
                }
              }
              if( hasLinked == false ) {
                html += payload.items[0].spec;
              } else {
                for (var i in payload.items) {
                  if (payload.items[i].linked_props != '' || payload.items.length == 1) {
                    html += payload.items[i].spec;
                  }
                }
              }
            }
            html += '</div>';
          }
        }
        if( cdd.tcs != '' ) {
          html += '<div class="termsandconditions" style="page-break-inside: avoid !important;">';
          html += '<h2>TERMS AND CONDITIONS</h2>';
          html += '<div class="payment-text">';
          html += '<span style="font-size: 9px !important;">'+cdd.tcs+'</span><br>';
          html += '<br>';
          html += '</div>';
          html += '</div>';
        }
        html += '</div>';
        html += '</div>';
        html += '</body>';
        html += '</html>';

        var documentFormat = {};
            documentFormat.border = {};
            documentFormat.border.top = '15px';
            documentFormat.border.left = '15px';
            documentFormat.border.right = '15px';
            documentFormat.border.bottom = '15px';

        var htmlDetails = {
          html: html,
          documentFormat: documentFormat
        }

        Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
          .then(response => {
            return response.body;
          }, error => {
            console.log(error);
          }).then(data => {

          var reportDownload = document.createElement('a');
          reportDownload.setAttribute('href', 'data:application/octet-stream;base64,' + data);
          reportDownload.setAttribute('download', 'PO-' + payload.quoteNo+'.pdf');
          reportDownload.click();

        });*/


      });

    });
  });

}

export const fncPrintInvoice = ({ commit, dispatch, state, rootState }, payload) => {

  var storeName = 'N/A';
  var parsedItem = JSON.parse( payload.items[0].line_item_data );
  if( parsedItem.store_id != undefined && parsedItem.store_id != null ) {
    for( var b in rootState.Branches.branchList ) {
      if( rootState.Branches.branchList[b].code == parsedItem.store_id ) {
        storeName = rootState.Branches.branchList[b].name;
      }
    }
  }

  var html = "<html><head><style>.glasscuttingSpecs, .glasscuttingSpecs th, .glasscuttingSpecs td, .glasscuttingSpecs span { font-size: 12px !important; } .installation { border-collapse: collapse !important; width: 100% !important;} .installation th { font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .installation td { text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .glasscuttingSpecs { border-collapse: collapse !important; width: 70% !important; } .glasscuttingSpecs th { width: 50% !important;font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .glasscuttingSpecs td { width: 50% !important;text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .specialordertable { border-collapse: collapse !important; width: 50% !important; } .specialordertable td.celltitle { text-align: left !important; width: 50% !important; font-size: 12px !important; background: #92e273 !important; padding: 10px !important; } .specialordertable td { width: 50% !important; text-align: left !important; font-size: 12px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .blindOrderSpecs { max-width: 100px !important; min-width: 100px !important; font-size:8px !important; color: #7f7e7e !important } .so-total-row, .so-total-label, .so-total { font-size: 10px !important; } h2 { font-size: 20px; font-weight: normal; padding-bottom: 0px; margin-bottom: 0px; padding-top: 20px; } .so-header { font-size: 8px; } .so-description, .so-qty, .so-price, .so-uom { font-size: 8px !important; } table.blindOrder { font-size: 8px !important; color: #7f7e7e !important; border: 1px solid #eee!important; width: 100% !important; margin-top: 25px; } table.blindOrder tr { width: 100% !important; } table.blindOrder th { font-size: 8px !important; text-align: left!important; padding: 10px !important; width: 25% !important; } table.blindOrder .header { background: #f1f1f1!important; padding: 10px !important; font-size: 10px !important; font-weight: 900!important; } table.blindOrder th.mainheader { font-size: 10px !important; padding: 10px !important; } table.blindOrder td { padding: 0 10px 10px !important; vertical-align: top!important; text-align: left!important; width: 25 % !important; } table { width: 100px; max-width: 540px; min-width: 540px; margin: 0 auto; } body { font-family: helvetica, sans-serif; } table.so-lineitems {margin-top: 5px; } table.so-lineitems th {border-bottom: 1px solid #ddd; } table.so-lineitems td {padding: 10px 0; font-size: 12px; } td.so-qty {text-align: right; padding-right: 5px; } td.so-price {text-align: right; } td.so-total-label {font-weight: bold; font-size: 10px; } td.so-total {text-align: right; font-weight: bold; font-size: 10px; border-top: 1px solid #000; border-bottom: 4px double #000; } .so-qty-header, .so-price-header, .so-uom-header {text-align:right;  font-size: 10px; } .so-description-header {text-align: left; font-size: 10px; }</style></head><body>";

  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.pricelist };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {
      if (dt[0]) {
        var vat = dt[0].pl_tax_percentage / 100;
      } else {
        var vat = 0.15;
      }
      var salesOrderNumber = payload.items[0].sales_order_number;
      html += '<table class="so-header">';
      html += '<tr>';
      html += '<td width="50%" style="line-height: 12px !important;text-align: left;padding-top: 30px; !important;">';
      html += '<strong>Invoice Date:</strong> ' + payload.date + '<br />';
      html += '<strong>Vendor:</strong> ' + payload.vendorName + '<br />';
      html += '<strong>Invoice Number:</strong> ' + payload.quoteNo + '<br />';
      html += '<strong>Customer Name:</strong> ' + payload.fullname + '<br />';
      html += '<strong>Customer Email:</strong> ' + payload.email + '<br />';
      html += '<strong>Store Name:</strong> ' + storeName + '<br />';
      html += '<strong>Purchase Order Number:</strong> ' + payload.setSoNumber + '<br />';
      if( salesOrderNumber != undefined && salesOrderNumber != '' && salesOrderNumber != null && salesOrderNumber != 0 ) {
        html += '<strong>Sales Order Number:</strong> ' + salesOrderNumber + '<br />';
      } else {
        html += '<strong>Sales Order Number:</strong><br />';
      }
      html += '</td > ';
      html += '<td width="50%" style="text-align: right;">';
      html += '<h2 style="margin-top: 0px; padding-top: 0px;">Glass Baron</h2>';
      html += '<p style="line-height: 12px !important;"><strong>Address:</strong> 485 Moreleta Street Silverton<br /><strong>Registration:</strong> 2012/176366/07<br /><strong>VAT Number:</strong> 4890287941</p>';
      html += '</td>';
      html += '</tr>';
      html += '<tr>';
      html += '<td colspan="2"><h2>Tax Invoice</h2></td>';
      html += '</tr>';
      html += '</table>';

      if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
        html += '<table class="so-lineitems">';
        html += '<tr>';
        html += '<th class="so-description-header" width="60%">Description</th>';
        html += '<th class="so-qty-header" width="20%">Quantity</th>';
        html += '<th class="so-uom-header" width="20%">UOM</th>';
        html += '</tr>';
      } else {
        html += '<table class="so-lineitems">';
        html += '<tr>';
        html += '<th class="so-description-header" width="40%">Description</th>';
        html += '<th class="so-qty-header" width="20%">Quantity</th>';
        html += '<th class="so-uom-header" width="20%">UOM</th>';
        html += '<th class="so-price-header" width="20%">Price</th>';
        html += '</tr>';
      }

      var totalPrice = 0;

      for (var i in payload.items) {
        var lineData = JSON.parse(payload.items[i].line_item_data);
        var cost = 0;
        if (lineData.cost_price != null) {
          cost = lineData.cost_price
        } else {
          cost = payload.items[i].price;
        }
        totalPrice += parseFloat(parseInt(payload.items[i].quantity) * parseFloat(cost));

        if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
          html += '<tr>';
          html += '<td class="so-description" width="60%">' + payload.items[i].itemName + '</td>';
          html += '<td class="so-qty" width="20%">' + payload.items[i].quantity + '</td>';
          html += '<td class="so-uom" width="20%" style="text-align: right">' + payload.items[i].uom + '</td>';
          html += '</tr>';
        } else {

          cost = parseFloat( cost * payload.items[i].quantity ).toFixed(2);

          html += '<tr>';
          html += '<td class="so-description" width="40%">' + payload.items[i].itemName + '</td>';
          html += '<td class="so-qty" width="20%">' + payload.items[i].quantity + '</td>';
          html += '<td class="so-uom" width="20%" style="text-align: right">' + payload.items[i].uom + '</td>';
          html += '<td class="so-price" width="20%">R' + cost.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
          html += '</tr>';
        }
      }

      if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
        html += '<tr class="so-total-row">';
        html += '<td class="so-total-label" style="text-align: right;" colspan="3"width="80%">Total Excl VAT: </td>';
        html += '<td class="so-total" width="20%">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
        html += '</tr>';
        html += '</table>';
      } else {
        html += '</table>';
      }

      html += '<br />';

      var checkFourSure = JSON.parse( payload.items[0].line_item_data );

      if( checkFourSure.installation_customer_first_name != null ) {

        var lineDataCount = Object.keys(checkFourSure).length;
        lineDataCount = lineDataCount - 25;
        var productCount = Math.floor( lineDataCount / 6 );

        html += '<div v-if="lineData.installation_customer_first_name != null" class="lineItemDetails">';
        html += '          <br /><br /><h2 style="font-size:14px; padding-left:20px !important;padding-bottom:10px !important;">Installation Details</h2>';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="4"><strong>Customer Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">First Name</th>';
        html += '              <th width="25%">Last Name</th>';
        html += '              <th width="25%">Email Address</th>';
        html += '              <th width="25%">Contact Number</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_first_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_last_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_email +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_contact_number +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br /><br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="4"><strong>Address Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="50%" colspan="2">Address Found</th>';
        html += '              <th width="50%" colspan="2">Address Searched</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="50%" colspan="2">'+checkFourSure.installation_address_found +'</td>';
        html += '              <td width="50%" colspan="2">'+checkFourSure.installation_address_searched +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Suburb</th>';
        html += '              <th width="25%">Province</th>';
        html += '              <th width="25%">Installation Lat</th>';
        html += '              <th width="25%">Installation Long</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_address_suburb +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_province +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_install_lat +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_install_long +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Store Lat</th>';
        html += '              <th width="25%">Store Long</th>';
        html += '              <th width="25%">Store Name</th>';
        html += '              <th width="25%">Store Code</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_lat +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_long +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.store_id +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br /><br /><br /><br /><br /><br /><br /><br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="5"><strong>Install Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Appointment Date Start</th>';
        html += '              <th width="25%">Appointment Date End</th>';
        html += '              <th width="25%">Appointment Contact Number</th>';
        html += '              <th width="25%">Appointment Contact Person</th>';
        html += '            </tr>';
        var objDates = checkFourSure.installation_appointment_date_start.split(',');
        var toReturn = '<p>'+objDates[objDates.length - 1]+'</p>';
        if( objDates.length > 1 ) {
          toReturn += '<small><strong>OLD DATES</strong></small><br />';
          for( var d in objDates ) {
            if( objDates[d] != objDates[objDates.length - 1] ) {
              toReturn += '<small>'+objDates[d]+'</small><br />';
            }
          }
        }
        html += '            <tr>';
        html += '              <td width="25%">'+toReturn +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_date_end +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_contact_number +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_contact_person +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="100%" colspan="4">Lookup Service Rep</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="100%" colspan="4">'+checkFourSure.installation_lookup_service_ref +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="80%" colspan="3">Appointment Installation Notes</th>';
        html += '              <th width="20%">Installation Sales Order Number</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="80%" colspan="3">'+checkFourSure.installation_notes+'</td>';
        html += '              <td width="20%">'+checkFourSure.installation_sales_order_number +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="6"><strong>Product Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="16.66%">Product Description</th>';
        html += '              <th width="16.66%">Product Make</th>';
        html += '              <th width="16.66%">Product Type</th>';
        html += '              <th width="16.66%">Product SKU</th>';
        html += '              <th width="16.66%">Product MO ID</th>';
        html += '              <th width="16.66%">Product QTY</th>';
        html += '            </tr>';
        if( productCount >= 1 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_1 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 2 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_2 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 3 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_3 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 4 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_4 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 5 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_5  +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_5 +'</td>';
          html += '            </tr>';
        }
        html += '          </table>';
        html += '          <br />';
        html += '        </div>';


      } else {
        if( payload.items.length == 1 ){
          html += payload.items[0].spec;
        } else {
          var hasLinked = false;
          for (var i in payload.items) {
            if( payload.items[i].linked_props != '' ) {
              hasLinked = true;
            }
          }
          if( hasLinked == false ) {
            html += payload.items[0].spec;
          } else {
            for (var i in payload.items) {
              if (payload.items[i].linked_props != '' || payload.items.length == 1) {
                html += payload.items[i].spec;
              }
            }
          }
        }
      }

      html += '<br /><br />';

      html += '<table width="100%">';
      html += '<tr>';
      html += '<td width="40%"><hr /></td>';
      html += '<td width="20%">&nbsp;</td>';
      html += '<td width="40%"><hr /></td>';
      html += '</tr>';
      html += '<tr>';
      html += '<td width="40%" style="font-size:12px;">Full Name</td>';
      html += '<td width="20%">&nbsp;</td>';
      html += '<td width="40%" style="font-size:12px;">Signature</td>';
      html += '</tr>';
      html += '</table>';

      html += '</body></html>';

      var htmlDetails = {
        html: html
      }

      Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
        .then(response => {
          return response.body;
        }, error => {
          console.log(error);
        }).then(data => {

        let blob = null;
        var contentType = 'application/pdf';
        const sliceSize = 512;
        // method which converts base64 to binary
        const byteCharacters = window.atob(data);

        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        blob = new Blob(byteArrays, {
          type: contentType
        }); // statement which creates the blob
        const blobURL = URL.createObjectURL(blob);
        const theWindow = window.open(blobURL);
        const theDoc = theWindow.document;
        const theScript = document.createElement('script');
        function injectThis() {
          window.print();
        }
        theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
        theDoc.body.appendChild(theScript);

        commit('hideModal');

      });

    });
  });

}

export const fncPrintReportPdf = ({ commit, dispatch, state, rootState }, payload) => {
  var storeName = 'N/A';
  var parsedItem = JSON.parse( payload.items[0].line_item_data );
  if( parsedItem.store_id != undefined && parsedItem.store_id != null ) {
    for( var b in rootState.Branches.branchList ) {
      if( rootState.Branches.branchList[b].code == parsedItem.store_id ) {
        storeName = rootState.Branches.branchList[b].name;
      }
    }
  }

  var html = "<html><head><style> .installation { border-collapse: collapse !important; width: 100% !important;} .installation th { font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .installation td { text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .glasscuttingSpecs { border-collapse: collapse !important; width: 70% !important; } .glasscuttingSpecs th { width: 50% !important;font-size: 10px !important; background: #92e273 !important; padding: 10px !important; } .glasscuttingSpecs td { width: 50% !important;text-align: center !important; font-size: 10px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .specialordertable { border-collapse: collapse !important; width: 50% !important; } .specialordertable td.celltitle { text-align: left !important; width: 50% !important; font-size: 12px !important; background: #92e273 !important; padding: 10px !important; } .specialordertable td { width: 50% !important; text-align: left !important; font-size: 12px !important; background: #fff !important; border: 1px solid #92e273 !important; padding: 10px !important; } .blindOrderSpecs { max-width: 100px !important; min-width: 100px !important; font-size:8px !important; color: #7f7e7e !important } .so-total-row, .so-total-label, .so-total { font-size: 10px !important; } h2 { font-size: 20px; font-weight: normal; padding-bottom: 0px; margin-bottom: 0px; padding-top: 20px; } .so-header { font-size: 8px; } .so-description, .so-qty, .so-price, .so-uom { font-size: 8px !important; } table.blindOrder { font-size: 8px !important; color: #7f7e7e !important; border: 1px solid #eee!important; width: 100% !important; margin-top: 25px; } table.blindOrder tr { width: 100% !important; } table.blindOrder th { font-size: 8px !important; text-align: left!important; padding: 10px !important; width: 25% !important; } table.blindOrder .header { background: #f1f1f1!important; padding: 10px !important; font-size: 10px !important; font-weight: 900!important; } table.blindOrder th.mainheader { font-size: 10px !important; padding: 10px !important; } table.blindOrder td { padding: 0 10px 10px !important; vertical-align: top!important; text-align: left!important; width: 25 % !important; } table { width: 100px; max-width: 540px; min-width: 540px; margin: 0 auto; } body { font-family: helvetica, sans-serif; } table.so-lineitems {margin-top: 5px; } table.so-lineitems th {border-bottom: 1px solid #ddd; } table.so-lineitems td {padding: 10px 0; font-size: 12px; } td.so-qty {text-align: right; padding-right: 5px; } td.so-uom {text-align: right; padding-right: 5px; } td.so-price {text-align: right; } td.so-total-label {font-weight: bold; font-size: 10px; } td.so-total {text-align: right; font-weight: bold; font-size: 10px; border-top: 1px solid #000; border-bottom: 4px double #000; } .so-qty-header, .so-price-header {text-align:right;  font-size: 10px; } .so-uom-header {font-size: 10; } .so-description-header {text-align: left; font-size: 10px; }</style></head><body>";

  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, pricelist_id: payload.pricelist };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {
      if (dt[0]) {
        var vat = dt[0].pl_tax_percentage / 100;
      } else {
        var vat = 0.15;
      }
      var salesOrderNumber = payload.items[0].sales_order_number;
      html += '<table class="so-header" width="100%">';
      html += '<tr>';
      html += '<td width="80%" style="text-align: left;">';
      html += '<strong>Quote Date:</strong> ' + payload.date + '<br />';
      html += '<strong>Vendor:</strong> ' + payload.vendorName + '<br />';
      html += '<strong>Quote Number:</strong> ' + payload.quoteNo + '<br />';
      html += '<strong>Customer Name:</strong> ' + payload.fullname + '<br />';
      html += '<strong>Customer Email:</strong> ' + payload.email + '<br />';
      html += '<strong>Store Name:</strong> ' + storeName + '<br />';
      if( salesOrderNumber != undefined && salesOrderNumber != '' && salesOrderNumber != null && salesOrderNumber != 0 ) {
        html += '<strong>Sales Order Number:</strong> ' + salesOrderNumber + '<br />';
      } else {
        html += '<strong>Sales Order Number:</strong><br />';
      }
      html += '</td > ';
      html += '<td width="20%"><img src="' + window.location.protocol + process.env.MYSPEC_ENDPOINT + 'profile.php?t=/' + objAuth.myspec_url + '&p=' + objAuth.header_logo_img +'" /></td>';
      html += '</tr>';
      html += '<tr>';
      html += '<td colspan="2"><h2>Jobcard / POD</h2></td>';
      html += '</tr>';
      html += '</table>';

      if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
        html += '<table class="so-lineitems" width="100%">';
        html += '<tr>';
        html += '<th class="so-description-header" width="60%">Description</th>';
        html += '<th class="so-qty-header" width="40%">Quantity</th>';
        html += '</tr>';
      } else {
        html += '<table class="so-lineitems">';
        html += '<tr>';
        html += '<th class="so-description-header" width="60%">Description</th>';
        html += '<th class="so-qty-header" width="40%">Quantity</th>';
        // html += '<th class="so-uom-header" width="20%">UOM</th>';
        // html += '<th class="so-price-header" width="20%">Price</th>';
        html += '</tr>';
      }

      var totalPrice = 0;

      for (var i in payload.items) {
        var lineData = JSON.parse(payload.items[i].line_item_data);
        var cost = 0;
        if (lineData.cost_price != null) {
          cost = lineData.cost_price
        } else {
          cost = payload.items[i].price;
        }
        totalPrice += parseFloat(parseInt(payload.items[i].quantity) * parseFloat(cost));

        if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') != -1) {
          html += '<tr>';
          html += '<td class="so-description" width="60%">' + payload.items[i].itemName + '</td>';
          html += '<td class="so-qty" width="40%">' + payload.items[i].quantity + '</td>';
          // html += '<td class="so-uom" width="20%">' + payload.items[i].uom + '</td>';
          html += '</tr>';
        } else {

          cost = parseFloat( cost * payload.items[i].quantity ).toFixed(2);

          html += '<tr>';
          html += '<td class="so-description" width="60%">' + payload.items[i].itemName + '</td>';
          html += '<td class="so-qty" width="40%">' + payload.items[i].quantity + '</td>';
          // html += '<td class="so-uom" width="20%">' + payload.items[i].uom + '</td>';
          // html += '<td class="so-price" width="20%">R' + cost.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
          html += '</tr>';
        }
      }

      /*if (objAuth.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
        html += '<tr class="so-total-row">';
        html += '<td class="so-total-label" style="text-align: right;" colspan="3"width="80%">Total: </td>';
        html += '<td class="so-total" width="20%">R' + totalPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</td>';
        html += '</tr>';
        html += '</table>';
      } else {
        html += '</table>';
      }*/

      html += '</table>';

      html += '<br />';

      var checkFourSure = JSON.parse( payload.items[0].line_item_data );

      if( checkFourSure.installation_customer_first_name != null ) {

        var lineDataCount = Object.keys(checkFourSure).length;
        lineDataCount = lineDataCount - 25;
        var productCount = Math.floor( lineDataCount / 6 );

        html += '<div v-if="lineData.installation_customer_first_name != null" class="lineItemDetails">';
        html += '          <br /><br /><h2 style="font-size:14px; padding-left:20px !important;padding-bottom:10px !important;">Installation Details</h2>';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="4"><strong>Customer Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">First Name</th>';
        html += '              <th width="25%">Last Name</th>';
        html += '              <th width="25%">Email Address</th>';
        html += '              <th width="25%">Contact Number</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_first_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_last_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_email +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_customer_contact_number +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br /><br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="4"><strong>Address Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="50%" colspan="2">Address Found</th>';
        html += '              <th width="50%" colspan="2">Address Searched</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="50%" colspan="2">'+checkFourSure.installation_address_found +'</td>';
        html += '              <td width="50%" colspan="2">'+checkFourSure.installation_address_searched +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Suburb</th>';
        html += '              <th width="25%">Province</th>';
        html += '              <th width="25%">Installation Lat</th>';
        html += '              <th width="25%">Installation Long</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_address_suburb +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_province +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_install_lat +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_install_long +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Store Lat</th>';
        html += '              <th width="25%">Store Long</th>';
        html += '              <th width="25%">Store Name</th>';
        html += '              <th width="25%">Store Code</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_lat +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_long +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_address_store_name +'</td>';
        html += '              <td width="25%">'+checkFourSure.store_id +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br /><br /><br /><br /><br /><br /><br /><br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="5"><strong>Install Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="25%">Appointment Date Start</th>';
        html += '              <th width="25%">Appointment Date End</th>';
        html += '              <th width="25%">Appointment Contact Number</th>';
        html += '              <th width="25%">Appointment Contact Person</th>';
        html += '            </tr>';
        var objDates = checkFourSure.installation_appointment_date_start.split(',');
        var toReturn = '<p>'+objDates[objDates.length - 1]+'</p>';
        if( objDates.length > 1 ) {
          toReturn += '<small><strong>OLD DATES</strong></small><br />';
          for( var d in objDates ) {
            if( objDates[d] != objDates[objDates.length - 1] ) {
              toReturn += '<small>'+objDates[d]+'</small><br />';
            }
          }
        }
        html += '            <tr>';
        html += '              <td width="25%">'+toReturn +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_date_end +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_contact_number +'</td>';
        html += '              <td width="25%">'+checkFourSure.installation_appointment_contact_person +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="100%" colspan="4">Lookup Service Rep</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="100%" colspan="4">'+checkFourSure.installation_lookup_service_ref +'</td>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="80%" colspan="3">Appointment Installation Notes</th>';
        html += '              <th width="20%">Installation Sales Order Number</th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <td width="80%" colspan="3">'+checkFourSure.installation_notes+'</td>';
        html += '              <td width="20%">'+checkFourSure.installation_sales_order_number +'</td>';
        html += '            </tr>';
        html += '          </table>';
        html += '          <br />';
        html += '          <table cellpadding="10" width="100%" class="installation">';
        html += '            <tr>';
        html += '              <th colspan="6"><strong>Product Details</strong></th>';
        html += '            </tr>';
        html += '            <tr>';
        html += '              <th width="16.66%">Product Description</th>';
        html += '              <th width="16.66%">Product Make</th>';
        html += '              <th width="16.66%">Product Type</th>';
        html += '              <th width="16.66%">Product SKU</th>';
        html += '              <th width="16.66%">Product MO ID</th>';
        html += '              <th width="16.66%">Product QTY</th>';
        html += '            </tr>';
        if( productCount >= 1 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_1 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_1 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 2 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_2 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_2 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 3 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_3 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_3 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 4 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_4 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_4 +'</td>';
          html += '            </tr>';
        }
        if( productCount >= 5 ) {
          html += '            <tr>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_description_5  +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_make_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_type_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_sku_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_moid_5 +'</td>';
          html += '              <td width="16.66%">'+checkFourSure.installation_product_qty_5 +'</td>';
          html += '            </tr>';
        }
        html += '          </table>';
        html += '          <br />';
        html += '        </div>';


      } else {
        if( payload.items.length == 1 ){
          html += payload.items[0].spec;
        } else {
          var hasLinked = false;
          for (var i in payload.items) {
            if( payload.items[i].linked_props != '' ) {
              hasLinked = true;
            }
          }
          if( hasLinked == false ) {
            html += '<br /><br />' + payload.items[0].spec;
          } else {
            for (var i in payload.items) {
              if (payload.items[i].linked_props != '' || payload.items.length == 1) {
                html += payload.items[i].spec;
              }
            }
          }
        }
      }

      html += '</body></html>';

      var htmlDetails = {
        html: html
      }

      Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
        .then(response => {
          return response.body;
        }, error => {
          console.log(error);
        }).then(data => {

        let blob = null;
        var contentType = 'application/pdf';
        const sliceSize = 512;
        // method which converts base64 to binary
        const byteCharacters = window.atob(data);

        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        blob = new Blob(byteArrays, {
          type: contentType
        }); // statement which creates the blob
        const blobURL = URL.createObjectURL(blob);
        const theWindow = window.open(blobURL);
        const theDoc = theWindow.document;
        const theScript = document.createElement('script');
        function injectThis() {
          window.print();
        }
        theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
        theDoc.body.appendChild(theScript);

      });

    });
  });

}

export const fncUploadSoImage = ({ commit, dispatch, state, rootState }, payload) => {

  var uploadData = new FormData();
  var objAuth = JSON.parse(rootState.objAuthorize);
  var randInt = Math.floor((Math.random() * 9999) + 1000);
  uploadData.append('fileInput', payload.files, payload.files.name);
  //uploadData.append('allowed_types', objAuth.allowed_file_types);
  uploadData.append('manufacturerID', objAuth.manufacturer);
  uploadData.append('max_upload_size', objAuth.max_upload_size);
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'QuoteAttachment.php', uploadData, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    var vendorId = payload.fullQuote.vendor;
    if( vendorId == 'undefined' || vendorId == undefined ) {
      vendorId = payload.fullQuote.vendorId;
      if (vendorId === undefined){
        vendorId = payload.vendorId
      }
    }
    var soId = payload.fullQuote.soId;
    if( soId == 'undefined' ) {
      soId = payload.fullQuote.sales_order_id;

    }

    if( soId === undefined && payload.hasOwnProperty('isQuoteReport')) {
      soId = payload.soId
    }

    if( vendorId === undefined && payload.hasOwnProperty('isQuoteReport')) {
      vendorId = payload.vendor_second
    }
    else if(vendorId === undefined){
      vendorId = payload.fullQuote.fullQuote.vendorId
      if(vendorId === undefined && payload.objSoSettings.length > 0){
        vendorId = payload.objSoSettings[0].vendor
      }
    }

    // if (soId === undefined){
    //   soId = payload.fullQuote.soAttachments[0].sales_order_id
    // }


    var uploadImg = {
      params: {
        user: objAuth.id,
        path: window.location.protocol + process.env.API_ATTACHMENTS + data.file_name,
        original_filename: data.original_filename,
        quote: payload.quoteId,
        vendor: vendorId,
        soId: soId,
        category: payload.category
      }
    }

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=addSoAttachment', uploadImg, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
        commit('setSnack', snackDetails);
      }).then(d => {
      var snackDetails = { color: 'success', message: 'The purchase order file was uploaded successfully', display: true };
      commit('setSnack', snackDetails);
      if (payload.hasOwnProperty('isQuoteReport')){
        dispatch('fncQuoteSettings', payload);
      }
      else{
        dispatch('fncSoSettingsNew', payload);
      }
    });
  });
}

export const fncSoSettings = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var attDetails = { params: { quote: payload.quoteId, soId: payload.soId } }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getSoAttachments', attDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the purchase order attachments', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit({
      type: 'fncSetSoSettings',
      attachments: data
    });

    var statusDetails = { id: payload.quoteId };

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getAttachments', statusDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = {color: 'error', message: 'An error occured while trying to retrieve the quote attachments', display: true};
        commit('setSnack', snackDetails);
      }).then(ddd => {
      var modalDetails = { title: 'Purchase Order Attachments - ' + payload.quoteNo, component: 'modal-so-settings', mstate: true, params: { fullQuote: payload, quote: payload.quoteId, vendor: payload.vendor, quoteNo: payload.quoteNo, quoteAttachments: ddd, statusList: payload.statusList, metaData: payload.metaData } };
      commit({
        type: 'setModal',
        details: modalDetails
      });
    });

  });
}

export const fncSoSettingsNew = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var attDetails = { params: payload }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getSoAttachments', attDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the purchase order attachments', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit({
      type: 'fncSetSoSettings',
      attachments: data
    });

    var statusDetails = { id: payload.quoteId };

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getAttachments', statusDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = {color: 'error', message: 'An error occured while trying to retrieve the quote attachments', display: true};
        commit('setSnack', snackDetails);
      }).then(ddd => {
      var modalDetails = { title: 'Purchase Order Attachments - ' + payload.quoteNo, component: 'modal-so-settings', mstate: true, params: { fullQuote: payload, quote: payload.quoteId, vendor: payload.vendor, quoteNo: payload.quoteNo, quoteAttachments: ddd, statusList: payload.statusList, metaData: payload.metaData } };
      commit({
        type: 'setModal',
        details: modalDetails
      });
    });

  });
}

export const fncRemoveSoAttachment = ({ commit, dispatch, state, rootState }, payload) => {

  payload.details.quoteId = payload.details.quote;
  var attDetails = { params: { attachment_id: payload.details.id } };
  payload.details.quoteNo = payload.quoteNo;

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=deleteSoAttachment', attDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to remove the purchase order file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    var snackDetails = { color: 'success', message: 'The purchase order file was removed successfully', display: true };
    commit('setSnack', snackDetails);
    payload.details.soId = payload.details.sales_order_id;
    if (payload.hasOwnProperty('isQuoteReport')){
      dispatch('fncQuoteSettings', payload.details);
    }
    else{
      dispatch('fncSoSettings', payload.details);
    }
  });

}

export const fncSoPlaceOrder = ({ commit, dispatch, state, rootState }, payload) => {

  var orderDetails = { vendor: payload.vendor, quote: payload.quote };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=salesOrderPlaceOrder', orderDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to remove the purchase order file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    if ( data == true ) {
      var snackDetails = { color: 'success', message: 'The order has been created successfully', display: true };
      commit('setSnack', snackDetails);
      dispatch('fncPopulateSalesOrders', false);
    } else {
      var snackDetails = { color: 'error', message: 'There has been an error while creating the order', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncSoCancelOrder = ({ commit, dispatch, state, rootState }, payload) => {

  var orderDetails = { vendor: payload.vendor, quote: payload.quote };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=salesOrderCancelOrder', orderDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to remove the purchase order file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    if (data == true) {
      var snackDetails = { color: 'success', message: 'The order has been cancelled successfully', display: true };
      commit('setSnack', snackDetails);
      dispatch({
        type: 'fncUpdateReportStatus',
        statusId: payload.statusId,
        comment: 'Changed by Vendor in Purchase Order Report',
        quoteId: payload.quote,
        vendorId: payload.vendor
      })
      dispatch('fncPopulateSalesOrders', false);
    } else {
      var snackDetails = { color: 'error', message: 'There has been an error while cancelling the order', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncReturnExcel = ({ commit, dispatch, state, rootState }, payload) => {

  var rows = { rows: JSON.stringify(payload) };
  // var rows = { rows: payload };
  // var rows = { rows: JSON.stringify(['Test']) };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=create_excel', rows, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to create the excel file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    if( data.success == true ) {
      var reportDownload = document.createElement('a');
      reportDownload.setAttribute('href', data.file);
      reportDownload.setAttribute('download', 'report.xlsx');
      reportDownload.click();
      commit( 'fncExcelLoading', false );
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to create the excel file', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncReturnExcelVendor = ({ commit, dispatch, state, rootState }, payload) => {

  var rows = { rows: JSON.stringify(payload) };
  // var rows = { rows: payload };
  // var rows = { rows: JSON.stringify(['Test']) };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=create_excel', rows, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to create the excel file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    if( data.success == true ) {
      var reportDownload = document.createElement('a');
      reportDownload.setAttribute('href', data.file);
      reportDownload.setAttribute('download', 'vendor_list.xlsx');
      reportDownload.click();
      commit( 'fncExcelLoading', false );
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to create the excel file', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncUpdateAttachmentCategory = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=update_attachment', payload.attachmentId, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to create the excel file', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The attachment category was updates successfully', display: true };
      commit('setSnack', snackDetails);
      dispatch('fncGetQuoteFiles', payload.quoteId);
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the attachment category', display: true };
      commit('setSnack', snackDetails);
    }

  });
}

export const fncDoQuoteReportExcel = ({ commit, dispatch, state, rootState }, payload) => {
  var page_start = 0;
  var page_end = 10000000;
  var objAuth = JSON.parse(rootState.objAuthorize);
  let key = getTabKey()

  var currency_data = [];
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);

    }).then(data => {
    var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(pricelists => {

      for (var p in pricelists) {
        var cur_data = { id: pricelists[p].pl_id, default: pricelists[p].pl_is_default, currency_sym: pricelists[p].pl_currency_sym, tax_label: pricelists[p].pl_tax_label, tax_percentage: pricelists[p].pl_tax_percentage, currency_code: pricelists[p].pl_currency_code };
        currency_data.push(cur_data);
      }

      if (payload.date_from != 'null' && payload.date_from != null) {
        let da = new Date(payload.date_from)
        var startDate = new Date(da + ' GMT').toISOString().slice(0, 10);
        var objStartDate = startDate.split("-");
        startDate = objStartDate[0] + '-' + objStartDate[1] + '-' + objStartDate[2];
      } else {
        startDate = 'null';
      }


      if (payload.date_to != 'null' && payload.date_to != null) {
        var endDate = new Date(payload.date_to + ' GMT').toISOString().slice(0, 10);
        var objEndDate = endDate.split("-");
        endDate = objEndDate[0] + '-' + objEndDate[1] + '-' + objEndDate[2];
      } else {
        endDate = 'null';
      }

      var quote_age = '';
      if( payload.start_date ) {
        quote_age = payload.start_date;
        if( quote_age.length > 10 || quote_age.length == undefined ) {
          var startDate = new Date(quote_age);
          startDate.setDate(startDate.getDate() + 1);
          quote_age = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);
        }
      }
      var quote_age_end = '';
      if( payload.end_date ) {
        quote_age_end = payload.end_date;
        if( quote_age_end.length > 10 || quote_age_end.length == undefined ) {
          var endDate = new Date(quote_age_end);
          endDate.setDate(endDate.getDate() + 1);
          quote_age_end = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);
        }
      }

      // added for dashboard speed
      if( payload.start_date && payload.start_date != '' && payload.end_date && payload.end_date != '' ) {
        var newPush = [];
        newPush.push('date');
      }

      /*if( payload.lite ) {
        quote_age = payload.date_from;
        quote_age_end = payload.date_to;
      }*/

      var reportDates = []
      reportDates.push(quote_age);
      reportDates.push(quote_age_end);

      // filter params

      var quote_details = {
        a: 'getAll',
        currency_data: currency_data,
        filter_params: {
          manufacturer: objAuth.manufacturer,
          user: objAuth.id,
          page_start: 0,
          page_end: 5000,
          date_from: quote_age,
          date_to: quote_age_end,
          isExcel: true
          //key: key
        }
      };

      if( quote_details['date_from'] == 'undefined' ) {
        delete quote_details['date_from'];
      }

      if( ( payload.originator != 'null' && payload.originator != null ) && payload.originator[0] != 'all' ) {
        quote_details.filter_params.originator = payload.originator;
      }
      if( ( payload.status != 'null' && payload.status != null ) && payload.status[0] != 'all' ) {
        quote_details.filter_params.filterStatus = payload.status;
      }
      if( ( payload.customer != 'null' && payload.customer != null ) && payload.customer[0] != 'all' ) {
        quote_details.filter_params.customer = payload.customer;
      }
      if( ( payload.vendor != 'null' && payload.vendor != null ) && payload.vendor[0] != 'all' ) {
        quote_details.filter_params.vendor = payload.vendor;
      }
      if( ( payload.store != 'null' && payload.store != null ) && payload.store[0] != 'all' ) {
        quote_details.filter_params.store = payload.store;
      }
      if( ( payload.search != 'null' && payload.search != null ) ) {
        quote_details.filter_params.keywords = payload.search;
      }
      if( ( payload.department != 'null' && payload.department != null ) && payload.department[0] != 'all' ) {
        quote_details.filter_params.department = payload.department;
      }
      if( ( payload.quoteRegion != 'null' && payload.quoteRegion != null ) ) {
        quote_details.filter_params.quoteRegion = payload.quoteRegion;
      }
      if( ( payload.quoteRep != 'null' && payload.quoteRep != null ) ) {
        quote_details.filter_params.quoteRep = payload.quoteRep;
      }
      if( ( payload.commercial_kam != 'null' && payload.commercial_kam != null ) ) {
        quote_details.filter_params.commercial_kam = payload.commercial_kam;
      }
      if( ( payload.commercial_originator != 'null' && payload.commercial_originator != null ) ) {
        quote_details.filter_params.commercial_originator = payload.commercial_originator;
      }
      if( ( payload.quote_type != 'null' && payload.quote_type != null ) ) {
        quote_details.filter_params.quote_type = payload.quote_type;
      }
      if( ( payload.service_type != 'null' && payload.service_type != null ) && payload.service_type[0] != 'all' ) {
        quote_details.filter_params.service_type = payload.service_type;
      }
      if( payload.selectedTab !== undefined && payload.selectedTab != null ) {
        quote_details.filter_params.selectedTab = payload.selectedTab;
      }

      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(qdata => {

          data = qdata.quotes;
        var reportData = [];

        if( objAuth.manufacturer == '385889803' ) {
          var headerData = ['VENDOR'];
        } else {
          var headerData = [];
        }

        for( var c in state.objQuoteSettings ) {
          if( state.objQuoteSettings[c].checked == true ) {
            if( objAuth.manufacturer == '16777962' ) {

              if( state.objQuoteSettings[c].id == 'total' || state.objQuoteSettings[c].id == 'vat' || state.objQuoteSettings[c].id == 'responsible_representative' || state.objQuoteSettings[c].id == 'project' ) {
                // do nothing
              } else if( state.objQuoteSettings[c].label == 'Responsible Rep' ) {
                headerData.push('USERS LINKED TO QUOTE');
              } else {
                if( state.objQuoteSettings[c].id == 'sub_total' ) {
                  headerData.push('TOTAL');
                } else {
                  headerData.push(state.objQuoteSettings[c].label.replace('-', ' ').toUpperCase());
                }
              }


            } else if( state.objQuoteSettings[c].label == 'Responsible Rep' ) {
              headerData.push('USERS LINKED TO QUOTE');
            } else {
              headerData.push(state.objQuoteSettings[c].label.replace('-', ' ').toUpperCase());
            }
          }
        }

        if( objAuth.manufacturer == '385889803' ) {
          if( data.length > 0 ) {
            var maxCount = 0;
            var maxInstallationCount = 0;
            for (var q in data) {
              var newCount = data[q].productNames.split(',').length;
              if( newCount > maxCount){
                maxCount = newCount;
              }

              if( data[q].product_codes.indexOf('installation_product_description_5') != -1 && maxInstallationCount < 5 ) {
                maxInstallationCount = 5;
              }
              if( data[q].product_codes.indexOf('installation_product_description_4') != -1 && maxInstallationCount < 4 ) {
                maxInstallationCount = 4;
              }
              if( data[q].product_codes.indexOf('installation_product_description_3') != -1 && maxInstallationCount < 3 ) {
                maxInstallationCount = 3;
              }
              if( data[q].product_codes.indexOf('installation_product_description_2') != -1 && maxInstallationCount < 2 ) {
                maxInstallationCount = 2;
              }
              if( data[q].product_codes.indexOf('installation_product_description_1') != -1 && maxInstallationCount < 1 ) {
                maxInstallationCount = 1;
              }
            }
            var maxCountLoop = maxCount + 1;
            var p = 1;
            while( p <= maxInstallationCount ) {
              headerData.push('INSTALLATION PRODUCT NAME ' + p);
              p++;
            }
            var n = 1;
            while( n < maxCountLoop ) {
              headerData.push('PRODUCT NAME ' + n);
              headerData.push('PRODUCT CODE ' + n);
              n++;
            }
          }
        }

        reportData.push( headerData );

        var roleReference = [];
        if( rootState.Roles.userRoles ) {
          for( var r in rootState.Roles.userRoles ) {
            roleReference[rootState.Roles.userRoles[r].id] = rootState.Roles.userRoles[r].name;
          }
        }

        if( data.length > 0 ) {
          for (var q in data) {
            var toPush = [];
            if( objAuth.manufacturer == '385889803' ) {
              toPush.push(data[q].vendorName)
            }
            for( var c in state.objQuoteSettings ) {
              if( state.objQuoteSettings[c].id == 'total' || state.objQuoteSettings[c].id == 'vat' || state.objQuoteSettings[c].id == 'project' ) {
              //if( state.objQuoteSettings[c].id == 'total' || state.objQuoteSettings[c].id == 'vat' || state.objQuoteSettings[c].id == 'responsible_representative' || state.objQuoteSettings[c].id == 'project' ) {
                // do nothing
              } else if (state.objQuoteSettings[c].checked == true) {

                switch ( state.objQuoteSettings[c].id ) {
                  case 'department':

                    var returnDepartment = 'N/A';
                    if (typeof data[q].departmentName !== "undefined" || data[q].departmentName !== null || data[q].departmentName !== "") {
                      returnDepartment = data[q].departmentName
                    }
                    toPush.push(returnDepartment);
                    break;
                  case 'poNumbers':

                    var poSplit = data[q].po_numbers.split(',');
                    if( poSplit.length == 0 ) {
                      toPush.push('N/A');
                    } else {
                      var newPo = [];
                      for( var p in poSplit ) {
                        if( poSplit[p] != '' && poSplit[p] != '0' ) {
                          newPo[poSplit[p]] = poSplit[p];
                        }
                      }
                      if( newPo.length != 0 ) {
                        var strPo = [];

                        for( var p in newPo ) {
                          strPo.push(p);
                        }
                        toPush.push(strPo.join(', '));
                      } else {
                        toPush.push('N/A');
                      }
                    }
                    /*if( data.po_numbers != '' && data.po_numbers != '0' && data.po_numbers != null ) {
                      toPush.push(data[q].po_numbers);
                    } else {
                      toPush.push('N/A');
                    }*/
                    break;
                  case 'quote_date':
                    toPush.push(data[q].quote_date);
                    break;
                  case 'survey_type':
                    if( rootState.Reports.surveyList[data[q].id] == '1' ) {
                      toPush.push('Contact Customer');
                    } else if( rootState.Reports.surveyList[data[q].id] == '2' ) {
                      toPush.push('Request Quote');
                    } else if( rootState.Reports.surveyList[data[q].id] == '3' ) {
                      toPush.push('Callout Request');
                    } else if( rootState.Reports.surveyList[data[q].id] == '4' ) {
                      toPush.push('Callout Conversion');
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                    //toPush.push('Survey Type');
                    break;
                  case 'customerRejectReason':
                    var objItem = data[q];
                    if( objItem.audit_data == '' || objItem.audit_data == null || objItem.audit_data == 'null' ) {
                      toPush.push('N/A');
                    } else {
                      var cancelReasons = ["Cost", "Not Interested Anymore", "Unhappy With The Service", "Was Just Checking Cost"];
                      var objReasons = objItem.audit_data.split(',');
                      var hasPushed = false;
                      for( var r in objReasons ){
                        if( cancelReasons.indexOf( objReasons[r] ) != -1 && hasPushed == false ) {
                          toPush.push(objReasons[r]);
                          hasPushed = true;
                        }
                      }
                      if( hasPushed == false ) {
                        // toPush.push(objItem.audit_data);
                        toPush.push('N/A');
                      }
                    }
                    break;
                  case 'quote_age':
                    toPush.push(data[q].quote_age );
                    break;
                  case 'quote_no':
                    toPush.push(data[q].quote_no);
                    break;
                  case 'orig_name':
                    if( data[q].orig_name != '' && data[q].orig_name!= null ) {
                      var origName = data[q].orig_name.split(' ');
                      if (origName.length == 2) {
                        if (origName[0] == origName[1]) {
                          toPush.push(origName[0]);
                        } else {
                          toPush.push(data[q].orig_name);
                        }
                      } else {
                        toPush.push(data[q].orig_name);
                      }
                    }
                    break;
                  case 'customer_name':
                    if (data[q].customer_name == null ) {
                      toPush.push('N/A');
                    } else {

                      var toSplit = 'N/A';
                      var userSplit = data[q].customer_name.split(' - ');
                      if (userSplit.length == 1) {
                        toSplit = userSplit[0];
                      } else if (userSplit.length == 2) {
                        toSplit = userSplit[1];
                      } else if (userSplit.length == 3) {
                        toSplit = userSplit[2];
                      }

                      var cusName = toSplit.split(' ');
                      if( cusName.length == 2 ) {
                        if( cusName[0] == cusName[1] ) {
                          toPush.push(cusName[0]);
                        } else {
                          toPush.push(toSplit);
                        }
                      } else {
                        toPush.push(toSplit);
                      }

                    }
                    break;
                  case 'sub_total':
                    toPush.push(data[q].pricing_subtotal);
                    break;
                  case 'status':
                    toPush.push(data[q].status);
                    break;
                  case  'status_change_reason':
                    toPush.push(data[q].status_change_reason)
                    break;
                  case 'project':
                    toPush.push(data[q].project);
                    break;
                  case 'responsible_representative':
                    /*if( objAuth.manufacturer != '385889803' ) {
                      var resRep = data[q].responsible_representative;
                      if ( resRep == 'N/A' ) {
                        resRep = 'None';
                      }

                      if (resRep.length >  24 ) {
                        toPush.push(resRep.substr(0,24));
                      } else {
                        toPush.push(resRep);
                      }
                    } else {
                      toPush.push('N/A');
                    }*/
                    var resRep = data[q].responsible_representative;
                    if ( resRep == 'N/A' ) {
                      resRep = 'None';
                    }
                    toPush.push(resRep);
                    break;
                  case 'store_name':
                    var storeName = 'N/A';
                    for( var b in rootState.Branches.branchList ) {
                      if( rootState.Branches.branchList[b].code == data[q].store_name ) {
                        storeName = rootState.Branches.branchList[b].name;
                      }
                    }
                    toPush.push(storeName);
                    break;
                  case 'pmoc':
                    var pmoc = 'N/A';
                    if( data[q].pmoc == undefined || data[q].pmoc == null || data[q].pmoc == '' ) {
                      pmoc = 'N/A';
                    } else {
                      pmoc = data[q].pmoc;
                    }
                    toPush.push(pmoc);
                    break;
                  case 'customerRating':
                    if( data[q].rating == '0' || data[q].rating == '' ) {
                      toPush.push('N/A');
                    } else {
                      toPush.push(data[q].rating);
                    }
                    break;
                  case 'process_order':
                    toPush.push('Action On Site');
                    break;
                  case 'orig_type':
                    if(  objAuth.manufacturer == '385889803' && data[q].orig_type == 'Manufacturer User' ) {
                      toPush.push('Builders User');
                    } else {
                      toPush.push(data[q].orig_type);
                    }
                    break;
                  case 'customer_type':
                    toPush.push(data[q].customer_type_code);
                    break;
                  case 'company_name':
                    if( data[q].company_name != '' && data[q].company_name != 'None' ) {
                      toPush.push(data[q].company_name);
                    } else if (data[q].customer_name != null ) {
                      var userSplit = data[q].customer_name.split(' - ');
                      if (userSplit.length > 1) {
                        toPush.push(userSplit[0]);
                      } else {
                        toPush.push('None');
                      }
                    } else {
                      toPush.push('None');
                    }
                    break;
                  case 'customer_manager':
                    toPush.push(data[q].customer_manager);
                    break;
                  case 'discount_value':
                    toPush.push(data[q].discount_val.toFixed(2));
                    break;
                  case 'discount_perc':
                    if( data[q].discount_perc ) {
                      toPush.push(data[q].discount_perc.toFixed(2));
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'pre_discount_total':
                    if( data[q].discount_val ) {
                      toPush.push(data[q].discount_val.toFixed(2));
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'order_no':
                    toPush.push(data[q].order_no);
                    break;
                  case 'customer_region':
                    toPush.push(data[q].customer_region);
                    break;
                  case 'project_region':
                    toPush.push(data[q].project_region);
                    break;
                  case 'originator_region':
                    toPush.push(data[q].originator_region);
                    break;
                  case 'specifier':
                    toPush.push(data[q].specifier);
                    break;
                  case 'user_type':
                    toPush.push(data[q].user_type);
                    break;
                  case 'soNumber':
                    toPush.push(data[q].sales_order_number);
                    break;
                  case 'serviceType':
                    /*if( data[q].is_commercial == true ) {
                      toPush.push('Commercial');
                    } else if( data[q].originator != data[q].customer_id ) {
                      toPush.push('Assisted');
                    } else if( data[q].originator == data[q].customer_id ) {
                      if( data[q].customer_email.indexOf('@builders') != -1 ) {
                        toPush.push('ASM Issue');
                      } else {
                        toPush.push('Self Service');
                      }
                    } else {
                      toPush.push('Unknown');
                    }*/
                    if( data[q].service_type == '3' ) {
                      toPush.push('Commercial');
                    } else if( data[q].service_type == '1' ) {
                      toPush.push('Assisted Service');
                    } else if( data[q].service_type == '2' ) {
                      toPush.push('Self Service');
                    } else {
                      toPush.push('Unknown');
                    }
                    break;
                  case 'installationDate':
                    var lineData = data[q].product_codes;
                    var installationDate = 'N/A';
                    if( lineData.indexOf('installation_appointment_date_start') != -1 ) {
                      var timeSplit = lineData.split('installation_appointment_date_start');
                      var newSplit = timeSplit[1].replace(/"/g, "");
                      newSplit = newSplit.replace(/'/g, "");
                      newSplit = newSplit.replace(/:/g, "");
                      newSplit = newSplit.replace(/\//g,'')
                      newSplit = newSplit.split('\\');
                      installationDate = newSplit[2];
                    }
                    toPush.push(installationDate);
                    break;
                  case 'installationDescription':
                    var lineData = data[q].product_codes
                    var installationDescription = 'N/A';
                    if( lineData.indexOf('installation_product_description_1') != -1 ) {
                      var timeSplit = lineData.split('installation_product_description_1');
                      var newSplit = timeSplit[1].replace(/"/g, "");
                      newSplit = newSplit.replace(/'/g, "");
                      newSplit = newSplit.replace(/:/g, "");
                      newSplit = newSplit.replace(/\//g,'')
                      newSplit = newSplit.split('\\');
                      installationDescription = newSplit[2];
                    }
                    toPush.push(installationDescription);
                    break;
                  case 'onsiteTime':
                    var statusName = '';
                    for( var s in rootState.Reports.statusList ) {
                      if( rootState.Reports.statusList[s].fs_on_site == 'Yes' || rootState.Reports.statusList[s].fs_on_site == '1' ) {
                        statusName = rootState.Reports.statusList[s].description;
                      }
                    }
                    var toReturn = 'N/A';
                    if( rootState.Reports.manufacturerAudits != undefined && rootState.Reports.manufacturerAudits[data[q].id] != null ) {
                      if( rootState.Reports.manufacturerAudits[data[q].id][statusName] != null ) {
                        toReturn = rootState.Reports.manufacturerAudits[data[q].id][statusName].time;
                      }
                    }
                    toPush.push(toReturn);
                    break;
                  case 'jobCompleteDate':
                    var statusName = '';
                    for( var s in rootState.Reports.statusList ) {
                      if( rootState.Reports.statusList[s].fs_job_complete == 'Yes' || rootState.Reports.statusList[s].fs_job_complete == '1' ) {
                        statusName = rootState.Reports.statusList[s].description;
                      }
                    }
                    var toReturn = 'N/A';
                    if( rootState.Reports.manufacturerAudits != undefined && rootState.Reports.manufacturerAudits[data[q].id] != null ) {
                      if( rootState.Reports.manufacturerAudits[data[q].id][statusName] != null ) {
                        toReturn = rootState.Reports.manufacturerAudits[data[q].id][statusName].time;
                      }
                    }
                    toPush.push(toReturn);
                    break;
                  case 'cancellationReason':
                    var statusName = '';
                    for( var s in rootState.Reports.statusList ) {
                      if( rootState.Reports.statusList[s].fs_job_cancelled == 'Yes' || rootState.Reports.statusList[s].fs_job_cancelled == '1' ) {
                        statusName = rootState.Reports.statusList[s].description;
                      }
                    }
                    var toReturn = 'N/A';
                    if( rootState.Reports.manufacturerAudits != undefined && rootState.Reports.manufacturerAudits[data[q].id] != null ) {
                      if( rootState.Reports.manufacturerAudits[data[q].id][statusName] != null ) {
                        toReturn = rootState.Reports.manufacturerAudits[data[q].id][statusName].data;
                      }
                    }
                    toPush.push(toReturn);
                    break;
                  case 'surveyType':
                    if( rootState.Reports.surveyList[data[q].id] == '1' ) {
                      toPush.push('Contact Customer');
                    } else if( rootState.Reports.surveyList[data[q].id] == '2' ) {
                      toPush.push('Request Quote');
                    } else if( rootState.Reports.surveyList[data[q].id] == '3' ) {
                      toPush.push('Request Measure to Quote - Request');
                    } else if( rootState.Reports.surveyList[data[q].id] == '4' ) {
                      toPush.push('Request Measure to Quote - Conversion');
                    } else if( rootState.Reports.surveyList[data[q].id] == '5' ) {
                      toPush.push('Calculator Request');
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'customerTelephone':
                    if( data[q].customer_telephone != '' ) {
                      toPush.push(data[q].customer_telephone);
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'customerEmail':
                    if( data[q].customer_email != '' ) {
                      toPush.push(data[q].customer_email);
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'vat':
                    if( data[q].pricing_vat ) {
                      toPush.push(data[q].pricing_vat.toFixed(2));
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'total':
                    if( data[q].pricing_total ) {
                      toPush.push(data[q].pricing_total.toFixed(2));
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'quoteRegion':
                    var branchProvince = 'N/A';
                    for( var b in rootState.Branches.branchList ) {
                      if( rootState.Branches.branchList[b].code == data[q].store_name ) {
                        if( rootState.Branches.branchList[b].locationName != '' ) {
                          branchProvince = rootState.Branches.branchList[b].locationName;
                        }
                      }
                    }
                    toPush.push(branchProvince);
                    break;
                  case 'appointmentDate':
                    var hasAdded = false;
                    if( data[q].process_data != null && data[q].process_data != 'null' ) {
                      var processData = JSON.parse( data[q].process_data );
                      for( var f in processData.tabs ) {
                        for( var fd in processData.tabs[f] ) {
                          for( var td in processData.tabs[f].form ) {
                            if( processData.tabs[f].form[td].label == 'Preferred Date') {
                              if( processData.tabs[f].form[td].value != '' && hasAdded == false ) {
                                toPush.push(processData.tabs[f].form[td].value);
                                hasAdded = true;
                              } else if( hasAdded == false ) {
                                toPush.push('N/A');
                                hasAdded = true;
                              }
                            }
                          }
                        }
                      }
                    } else if( hasAdded == false ) {
                      hasAdded = true;
                      toPush.push('N/A');
                    }
                    break;
                  case 'appointmentTime':
                    var hasAdded = false;
                    if( data[q].process_data != null && data[q].process_data != 'null' ) {
                      var processData = JSON.parse( data[q].process_data );
                      for( var f in processData.tabs ) {
                        for( var fd in processData.tabs[f] ) {
                          for( var td in processData.tabs[f].form ) {
                            if( processData.tabs[f].form[td].label == 'Preferred Time') {
                              if( processData.tabs[f].form[td].value != '' && hasAdded == false ) {
                                toPush.push(processData.tabs[f].form[td].value);
                                hasAdded = true;
                              } else if( hasAdded == false ) {
                                toPush.push('N/A');
                                hasAdded = true;
                              }
                            }
                          }
                        }
                      }
                    } else if( hasAdded == false ) {
                      hasAdded = true;
                      toPush.push('N/A');
                    }
                    break;
                  case 'quoteType':
                    if( data[q].product_codes.includes('installation_lookup_service_ref') ) {
                      toPush.push('Lookup Service');
                    } else if( rootState.Reports.surveyList[data[q].id] != undefined ) {
                      toPush.push('Service Form');
                    } else {
                      toPush.push('Calculator');
                    }
                    break;
                  case 'calculator':
                    if( rootState.Reports.surveyList[data[q].id] != undefined ) {
                      toPush.push('Service Form');
                    } else if( data[q].item_range != '' ) {
                      toPush.push(data[q].item_range);
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'commercialKam':
                    toPush.push(data[q].responsible_kam_name);
                    break;
                    case 'installationDate':
                    toPush.push(data[q].installationDate);
                    break;
                    case 'manufacturer_date_api':
                    toPush.push(data[q].manufacturer_date_api);
                    break;
                    case 'delivery_date_api':
                    toPush.push(data[q].delivery_date_api);
                    break;
                  case 'commercialOriginator':
                    toPush.push(data[q].responsible_originator_name);
                    break;
                  case 'kamRegion':
                    if( data[q].spec ) {
                      var regionSplit = data[q].spec.split("<span class='quoteRegion'>");
                      if( regionSplit.length > 1 ) {
                        var regionSplitName = regionSplit[1].split('</span>');
                        toPush.push(regionSplitName[0]);
                      } else {
                        toPush.push('N/A');
                      }
                    } else {
                      toPush.push('N/A');
                    }
                    break;
                  case 'linkedQuotes':
                    toPush.push(data[q].linked_quotes);
                    break;
                  default:
                    if( !isNaN(state.objQuoteSettings[c].id) ) {

                      if( roleReference[state.objQuoteSettings[c].id] != null ) {

                        var subRoles = [];
                        var repSplit = data[q].responsible_representative.split( ',');

                         for( var r in repSplit ) {

                           if( repSplit[r] != undefined && repSplit[r] != 'N/A' ) {
                             var objRepSplit = repSplit[r].split('(');

                             if( objRepSplit[1] != undefined ) {
                               var objRepSplitRole = objRepSplit[1].split(')');

                               var user = objRepSplit[0].trim();
                               var role = objRepSplitRole[0].trim();

                               if( roleReference[state.objQuoteSettings[c].id] == role ) {
                                 subRoles.push( user );
                               }
                             }

                           }

                           /*if( repSplit[r].includes(roleReference[state.objQuoteSettings[c].id]) == true ) {
                             var subSplit = repSplit[r].split('(');
                             subRoles.push( subSplit[0] );
                           }*/
                         }

                         if( subRoles.length == 0 ) {
                           subRoles = ['N/A'];
                         }

                         subRoles = subRoles.join(',');

                        toPush.push(subRoles);

                      }
                    } else {
                      toPush.push('');
                    }
                }
              }
            }
            if( objAuth.manufacturer == '385889803' ) {
              // installation products
              var lineData = data[q].product_codes;
              var z = 1;
              while( z <= maxInstallationCount ) {
                var prodDescription = 'N/A';
                if( data[q].product_codes.indexOf('installation_product_description_'+z) != -1 ) {
                  var timeSplit = lineData.split('installation_product_description_'+z);
                  var newSplit = timeSplit[1].replace(/"/g, "");
                  newSplit = newSplit.replace(/'/g, "");
                  newSplit = newSplit.replace(/:/g, "");
                  newSplit = newSplit.replace(/\//g,'')
                  newSplit = newSplit.split('\\');
                  prodDescription = newSplit[2];
                }
                toPush.push(prodDescription);
                z++;
              }

              var productNames = data[q].productNames.split(',');
              var productCodes = data[q].productCodes.split(',');

              var maxCountLoop = productNames.length;
              var n = 0;
              while( n < maxCountLoop ) {
                toPush.push(productNames[n]);
                toPush.push(productCodes[n]);
                n++;
              }
            }
            reportData.push( toPush );
          }

          dispatch('fncReturnExcel', reportData);
        } else {
          dispatch('fncReturnExcel', []);
        }

        /*if( objAuth.manufacturer == '385889803' ) {
          var headersPush = ['QUOTE DATE', 'QUOTE NO.', 'ORIGINATOR TYPE', 'ORIGINATOR', 'CUSTOMER TYPE', 'CUSTOMER', 'CUSTOMER MANAGER', 'DISCOUNT (R/c)', 'SUB TOTAL', 'TAX VALUE', 'GRAND TOTAL', 'STATUS', 'PROJECT REGION', 'ORIGINATOR REGION', 'PROJECT', 'SPECIFIER', 'RESPONSIBLE REP', 'FOLLOW UP', 'VENDOR', 'CUSTOMER RATING', 'INSTALLATION DATE', 'INSTALLATION DESCRIPTION', 'ONSITE TIME', 'JOB COMPLETE', 'CANCELLATION REASON'];

          if( data.length > 0 ) {
            var maxCount = 0;
            var maxInstallationCount = 0;
            for (var q in data) {
              var newCount = data[q].productNames.split(',').length;
              if( newCount > maxCount){
                maxCount = newCount;
              }

              if( data[q].product_codes.indexOf('installation_product_description_5') != -1 && maxInstallationCount < 5 ) {
                maxInstallationCount = 5;
              }
              if( data[q].product_codes.indexOf('installation_product_description_4') != -1 && maxInstallationCount < 4 ) {
                maxInstallationCount = 4;
              }
              if( data[q].product_codes.indexOf('installation_product_description_3') != -1 && maxInstallationCount < 3 ) {
                maxInstallationCount = 3;
              }
              if( data[q].product_codes.indexOf('installation_product_description_2') != -1 && maxInstallationCount < 2 ) {
                maxInstallationCount = 2;
              }
              if( data[q].product_codes.indexOf('installation_product_description_1') != -1 && maxInstallationCount < 1 ) {
                maxInstallationCount = 1;
              }
            }
            var maxCountLoop = maxCount + 1;
            var p = 1;
            while( p <= maxInstallationCount ) {
              headersPush.push('INSTALLATION PRODUCT NAME ' + p);
              p++;
            }
            var n = 1;
            while( n < maxCountLoop ) {
              headersPush.push('PRODUCT NAME ' + n);
              headersPush.push('PRODUCT CODE ' + n);
              n++;
            }
          }

          //reportData.push(['QUOTE DATE', 'QUOTE NO.', 'ORIGINATOR TYPE', 'ORIGINATOR', 'CUSTOMER TYPE', 'CUSTOMER', 'CUSTOMER MANAGER', 'DISCOUNT (R/c)', 'SUB TOTAL', 'TAX VALUE', 'GRAND TOTAL', 'STATUS', 'PROJECT REGION', 'ORIGINATOR REGION', 'PROJECT', 'SPECIFIER', 'RESPONSIBLE REP', 'FOLLOW UP', 'VENDOR', 'INSTALLATION DATE', 'PRODUCT CODE', 'PRODUCT NAME']);
          reportData.push(headersPush);
        } else {
          reportData.push(['QUOTE DATE', 'QUOTE NO.', 'ORIGINATOR TYPE', 'ORIGINATOR', 'CUSTOMER TYPE', 'CUSTOMER', 'CUSTOMER MANAGER', 'DISCOUNT (R/c)', 'SUB TOTAL', 'TAX VALUE', 'GRAND TOTAL', 'STATUS', 'PROJECT REGION', 'ORIGINATOR REGION', 'PROJECT', 'SPECIFIER', 'RESPONSIBLE REP', 'FOLLOW UP', 'VENDOR']);
        }*/

        /*if( data.length > 0 ) {
          for (var q in data) {

            var toPush = [];
            var projectRegion = '-';
            if (data[q].project_region != null) {
              projectRegion = data[q].project_region.replace(/,/g, ' | ')
            }

            var options = {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "numeric",
              minute: "numeric",
              hour12: false
            };

            var newDate = new Date( Date.parse(data[q].quote_date + ' UTC') );
            var dateString = newDate.toLocaleString("en", options);
            var objDate = dateString.split(',');

            var newDate = objDate[0].split('/');

            var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

            toPush.push(strDate);
            toPush.push(data[q].quote_no);
            toPush.push(data[q].orig_type);
            toPush.push(data[q].orig_name);
            toPush.push(data[q].customer_type);
            toPush.push(data[q].customer_name);
            toPush.push(data[q].customer_manager);
            toPush.push(data[q].discount_val.toFixed(2));
            if( data[q].pricing_subtotal ) {
              toPush.push(data[q].pricing_subtotal.toFixed(2));
            } else {
              toPush.push('N/A');
            }
            if( data[q].pricing_vat ) {
              toPush.push(data[q].pricing_vat.toFixed(2));
            } else {
              toPush.push('N/A');
            }
            if( data[q].pricing_total ) {
              toPush.push(data[q].pricing_total.toFixed(2));
            } else {
              toPush.push('N/A');
            }*/
        /*toPush.push(data[q].pricing_vat.toFixed(2));
        toPush.push(data[q].pricing_total.toFixed(2));*/
        /*toPush.push('R' + data[q].discount_val);
        toPush.push('R' + data[q].pricing_subtotal);
        toPush.push('R' + data[q].pricing_vat);
        toPush.push('R' + data[q].pricing_total);*/
        /*toPush.push(data[q].status);
        toPush.push(projectRegion);
        toPush.push(data[q].originator_region);
        toPush.push(data[q].project.replace(/,/g, ' | '));
        toPush.push(data[q].specifier);
        toPush.push(data[q].responsible_representative.replace(/,/g, ' | '));
        toPush.push(data[q].pmoc);
        toPush.push(data[q].vendorName);

        if( objAuth.manufacturer == '385889803' ) {
          var lineData = data[q].product_codes
          var installationDate = 'N/A';
          if( lineData.indexOf('installation_appointment_date_start') != -1 ) {
            var timeSplit = lineData.split('installation_appointment_date_start');
            var newSplit = timeSplit[1].replace(/"/g, "");
                newSplit = newSplit.replace(/'/g, "");
                newSplit = newSplit.replace(/:/g, "");
                newSplit = newSplit.replace(/\//g,'')
                newSplit = newSplit.split('\\');
            installationDate = newSplit[2];
          }

          var installationDescription = 'N/A';
          if( lineData.indexOf('installation_product_description_1') != -1 ) {
            var timeSplit = lineData.split('installation_product_description_1');
            var newSplit = timeSplit[1].replace(/"/g, "");
            newSplit = newSplit.replace(/'/g, "");
            newSplit = newSplit.replace(/:/g, "");
            newSplit = newSplit.replace(/\//g,'')
            newSplit = newSplit.split('\\');
            installationDescription = newSplit[2];
          }

          if( data[q].rating == '0' ) {
            toPush.push('N/A');
          } else {
            toPush.push(data[q].rating);
          }

          toPush.push(installationDate);
          toPush.push(installationDescription);

          // on site date
          var statusName = '';
          for( var s in rootState.Reports.statusList ) {
            if( rootState.Reports.statusList[s].fs_on_site == 'Yes' || rootState.Reports.statusList[s].fs_on_site == '1' ) {
              statusName = rootState.Reports.statusList[s].description;
            }
          }
          var toReturn = 'N/A';
          if( rootState.Reports.manufacturerAudits[data[q].id] != null ) {
            if( rootState.Reports.manufacturerAudits[data[q].id][statusName] != null ) {
              toReturn = rootState.Reports.manufacturerAudits[data[q].id][statusName].time;
            }
          }
          toPush.push(toReturn);

          // job completed
          var statusName = '';
          for( var s in rootState.Reports.statusList ) {
            if( rootState.Reports.statusList[s].fs_job_complete == 'Yes' || rootState.Reports.statusList[s].fs_job_complete == '1' ) {
              statusName = rootState.Reports.statusList[s].description;
            }
          }
          var toReturn = 'N/A';
          if( rootState.Reports.manufacturerAudits[data[q].id] != null ) {
            if( rootState.Reports.manufacturerAudits[data[q].id][statusName] != null ) {
              toReturn = rootState.Reports.manufacturerAudits[data[q].id][statusName].time;
            }
          }
          toPush.push(toReturn);

          // job cancelled
          var statusName = '';
          for( var s in rootState.Reports.statusList ) {
            if( rootState.Reports.statusList[s].fs_job_cancelled == 'Yes' || rootState.Reports.statusList[s].fs_job_cancelled == '1' ) {
              statusName = rootState.Reports.statusList[s].description;
            }
          }
          var toReturn = 'N/A';
          if( rootState.Reports.manufacturerAudits[data[q].id] != null ) {
            if( rootState.Reports.manufacturerAudits[data[q].id][statusName] != null ) {
              toReturn = rootState.Reports.manufacturerAudits[data[q].id][statusName].data;
            }
          }
          toPush.push(toReturn);

          // installation products
          var z = 1;
          while( z <= maxInstallationCount ) {
            var prodDescription = 'N/A';
            if( data[q].product_codes.indexOf('installation_product_description_'+z) != -1 ) {
              var timeSplit = lineData.split('installation_product_description_'+z);
              var newSplit = timeSplit[1].replace(/"/g, "");
              newSplit = newSplit.replace(/'/g, "");
              newSplit = newSplit.replace(/:/g, "");
              newSplit = newSplit.replace(/\//g,'')
              newSplit = newSplit.split('\\');
              prodDescription = newSplit[2];
            }
            toPush.push(prodDescription);
            z++;
          }

          var productNames = data[q].productNames.split(',');
          var productCodes = data[q].productCodes.split(',');

          var maxCountLoop = productNames.length;
          var n = 0;
          while( n < maxCountLoop ) {
            toPush.push(productNames[n]);
            toPush.push(productCodes[n]);
            n++;
          }

        }

        var strPush = toPush;

        reportData.push( strPush );

      }
    }*/

      });

    });
  });

};

/*export const fncGetSalesOrderColumns = ({ commit, dispatch, state, rootState }, payload) => {
  if( payload.sales_order_columns != undefined && payload.sales_order_columns != 'null'&& payload.sales_order_columns != '' ) {
    var columns = JSON.parse( payload.sales_order_columns );
    // we need to check for new columns 2020.11.16
    var hasRating = false;
    var hasInstallationDate = false;
    var hasInstallationDescription = false;
    var hasOnsiteTime = false;
    var hasJobComplete = false;
    var hasCancellationReason = false;
    for( var c in columns ) {
      if( columns[c].id == 'customerRating' ) { hasRating = true; }
      if( columns[c].id == 'installationDate' ) { hasInstallationDate = true; }
      if( columns[c].id == 'installationDescription' ) { hasInstallationDescription = true; }
      if( columns[c].id == 'onsiteTime' ) { hasOnsiteTime = true; }
      if( columns[c].id == 'jobComplete' ) { hasJobComplete = true; }
      if( columns[c].id == 'cancellationReason' ) { hasCancellationReason = true; }
    }
    var n = columns.length + 1;
    if( hasRating == false ) {
      columns.push({checked: false, id: 'customerRating', label: 'Customer Rating', order: n, width: 'auto'});
      n++;
    }
    if( hasInstallationDate == false ) {
      columns.push({checked: false, id: 'installationDate', label: 'Installation Date', order: n, width: 'auto'});
      n++;
    }
    if( hasInstallationDate == false ) {
      columns.push({checked: false, id: 'installationDate', label: 'Installation Date', order: n, width: 'auto'});
      n++;
    }
    if( hasInstallationDescription == false ) {
      columns.push({checked: false, id: 'installationDescription', label: 'Installation Description', order: n, width: 'auto'});
      n++;
    }
    if( hasOnsiteTime == false ) {
      columns.push({checked: false, id: 'onsiteTime', label: 'Onsite Time', order: n, width: 'auto'});
      n++;
    }
    if( hasJobComplete == false ) {
      columns.push({checked: false, id: 'jobComplete', label: 'Job Complete', order: n, width: 'auto'});
      n++;
    }
    if( hasCancellationReason == false ) {
      columns.push({checked: false, id: 'cancellationReason', label: 'Cancellation Reason', order: n, width: 'auto'});
      n++;
    // we need to check for departments
    var hasDepartment = false;
    for( var c in columns ) {
      if( columns[c].id == 'soDepartment' ) {
        hasDepartment = true;
      }
    }
    if( hasDepartment == false ) {
      columns.push({checked: false, id: 'soDepartment', label: 'Department', order: columns.length, width: '200px'});
    }
    commit( 'fncSetSoColumns', columns );
  } else {
    var soColumns = [];
    if( hasInstallationDate == false ) {
      columns.push({checked: false, id: 'installationDate', label: 'Installation Date', order: n, width: 'auto'});
      n++;
    }
    if( hasInstallationDescription == false ) {
      columns.push({checked: false, id: 'installationDescription', label: 'Installation Description', order: n, width: 'auto'});
      n++;
    }
    if( hasOnsiteTime == false ) {
      columns.push({checked: false, id: 'onsiteTime', label: 'Onsite Time', order: n, width: 'auto'});
      n++;
    }
    if( hasJobComplete == false ) {
      columns.push({checked: false, id: 'jobComplete', label: 'Job Complete', order: n, width: 'auto'});
      n++;
    }
    if( hasCancellationReason == false ) {
      columns.push({checked: false, id: 'cancellationReason', label: 'Cancellation Reason', order: n, width: 'auto'});
      n++;
    }
    if (payload.type == '6' || payload.privileges.indexOf('VENDOR_HIDE_DETAILS') != -1 ) {
      soColumns.push({ "id": "date", "label": "Quote Date", "checked": true, "width": "auto", "order": 1 });
      soColumns.push({ "id": "vendorName", "label": "Vendor", "checked": true, "width": "auto", "order": 2 });
      soColumns.push({ "id": "items", "label": "Items", "checked": true, "width": "auto", "order": 3 });
      soColumns.push({ "id": "status", "label": "Status", "checked": true, "width": "auto", "order": 4 });
      soColumns.push({ "id": "quoteNo", "label": "Quote No", "checked": true, "width": "auto", "order": 5 });
      soColumns.push({ "id": "soNo", "label": "Sales order No", "checked": false, "width": "auto", "order": 6 });
      soColumns.push({ "id": "bwSalesOrderNo", "label": "BW Sales Order No", "checked": false, "width": "auto", "order": 7 });
      soColumns.push({ "id": "serviceType", "label": "Service Type", "checked": false, "width": "auto", "order": 8 });
      soColumns.push({ "id": "originatorName", "label": "Originator Name", "checked": false, "width": "auto", "order": 9 });
      soColumns.push({ "id": "soQty", "label": "Quantity", "checked": false, "width": "auto", "order": 10 });
      soColumns.push({ "id": "soGlassType", "label": "Glass Type", "checked": false, "width": "auto", "order": 11 });
      soColumns.push({ "id": "soGlassSize", "label": "Glass Size", "checked": false, "width": "auto", "order": 12 });
      soColumns.push({ "id": "soBranch", "label": "Store", "checked": false, "width": "auto", "order": 13 });
      soColumns.push({ "id": "customerRating", "label": "Customer Rating", "checked": false, "width": "auto", "order": 14 });
      soColumns.push({ "id": "installationDate", "label": "Store", "checked": false, "width": "auto", "order": 15 });
      soColumns.push({ "id": "installationDescription", "label": "Store", "checked": false, "width": "auto", "order": 16 });
      soColumns.push({ "id": "onsiteTime", "label": "Store", "checked": false, "width": "auto", "order": 17 });
      soColumns.push({ "id": "jobComplete", "label": "Store", "checked": false, "width": "auto", "order": 18 });
      soColumns.push({ "id": "cancellationReason", "label": "Store", "checked": false, "width": "auto", "order": 19 });
      if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1 ) {
        soColumns.push({ "id": "totalPrice", "label": "Total", "checked": true, "width": "auto", "order": 20 });
      soColumns.push({"id": "soDepartment", "label": "Department", "checked": false, "width": "auto", "order": 14});

      if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1 ) {
        soColumns.push({ "id": "totalPrice", "label": "Total", "checked": true, "width": "auto", "order": 15 });
      }
    } else {
      soColumns.push({ "id": "date", "label": "Quote Date", "checked": true, "width": "auto", "order": 1 });
      soColumns.push({ "id": "vendorName", "label": "Vendor", "checked": true, "width": "auto", "order": 2 });
      soColumns.push({ "id": "items", "label": "Items", "checked": true, "width": "auto", "order": 3 });
      soColumns.push({ "id": "status", "label": "Status", "checked": true, "width": "auto", "order": 4 });
      soColumns.push({ "id": "fullname", "label": "Customer Name", "checked": false, "width": "auto", "order": 5 });
      soColumns.push({ "id": "email", "label": "Customer Email", "checked": false, "width": "auto", "order": 6 });
      soColumns.push({ "id": "contactnum", "label": "Customer Contact", "checked": false, "width": "auto", "order": 7 });
      soColumns.push({ "id": "quoteNo", "label": "Quote No", "checked": true, "width": "auto", "order": 8 });
      soColumns.push({ "id": "soNo", "label": "Sales order No", "checked": false, "width": "auto", "order": 9 });
      soColumns.push({ "id": "bwSalesOrderNo", "label": "BW Sales Order No", "checked": false, "width": "auto", "order": 10 });
      soColumns.push({ "id": "serviceType", "label": "Service Type", "checked": false, "width": "auto", "order": 11 });
      soColumns.push({ "id": "originatorName", "label": "Originator Name", "checked": false, "width": "auto", "order": 12 });
      soColumns.push({ "id": "soQty", "label": "Quantity", "checked": false, "width": "auto", "order": 13 });
      soColumns.push({ "id": "soGlassType", "label": "Glass Type", "checked": false, "width": "auto", "order": 14 });
      soColumns.push({ "id": "soGlassSize", "label": "Glass Size", "checked": false, "width": "auto", "order": 15 });
      soColumns.push({ "id": "soBranch", "label": "Store", "checked": false, "width": "auto", "order": 16 });
      soColumns.push({ "id": "customerRating", "label": "Customer Rating", "checked": false, "width": "auto", "order": 17 });
      soColumns.push({ "id": "installationDate", "label": "Store", "checked": false, "width": "auto", "order": 18 });
      soColumns.push({ "id": "installationDescription", "label": "Store", "checked": false, "width": "auto", "order": 19 });
      soColumns.push({ "id": "onsiteTime", "label": "Store", "checked": false, "width": "auto", "order": 20 });
      soColumns.push({ "id": "jobComplete", "label": "Store", "checked": false, "width": "auto", "order": 21 });
      soColumns.push({ "id": "cancellationReason", "label": "Store", "checked": false, "width": "auto", "order": 22 });
      if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
        soColumns.push({ "id": "totalPrice", "label": "Total", "checked": true, "width": "auto", "order": 23 });
      soColumns.push({"id": "soDepartment", "label": "Department", "checked": false, "width": "auto", "order": 17});
      if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
        soColumns.push({ "id": "totalPrice", "label": "Total", "checked": true, "width": "auto", "order": 18 });
      }
    }
    var stringColumns = JSON.stringify( soColumns );

    var params = {
      columns: stringColumns,
      user: payload.id
    }

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=save_sales_order_columns', params, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to save the sales order columns', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {

        var settings_details = {
          sales_order_columns: stringColumns
        };
        dispatch({
          type: 'updateObjAuth',
          objChanges: settings_details
        });
        commit( 'fncSetSoColumns', JSON.parse( stringColumns ) );

    });

  }

}*/

export const fncGetSalesOrderColumns = ({ commit, dispatch, state, rootState }, payload) => {
  if( payload.sales_order_columns != undefined && payload.sales_order_columns != 'null'&& payload.sales_order_columns != '' ) {
    var columns = JSON.parse( payload.sales_order_columns );
    // we need to check for new columns 2020.11.16
    var hasRating = false;
    var hasInstallationDate = false;
    var hasInstallationDescription = false;
    var hasOnsiteTime = false;
    var hasJobComplete = false;
    var hasCancellationReason = false;
    var hasQuoteRegion = false;
    var hasPurchaseOrder = false;
    var hasResponsibleReps = false;
    var hasDeliveryDate = false;
    var hasManuDate = false;

    for( var c in columns ) {
      if( columns[c].id == 'customerRating' ) { hasRating = true; }
      if( columns[c].id == 'installationDate' ) { hasInstallationDate = true; }
      if( columns[c].id == 'installationDescription' ) { hasInstallationDescription = true; }
      if( columns[c].id == 'onsiteTime' ) { hasOnsiteTime = true; }
      if( columns[c].id == 'jobComplete' ) { hasJobComplete = true; }
      if( columns[c].id == 'cancellationReason' ) { hasCancellationReason = true; }
      if( columns[c].id == 'quoteRegion' ) { hasQuoteRegion = true; }
      if( columns[c].id == 'purchaseOrder' ) { hasPurchaseOrder = true; }
      if( columns[c].id == 'responsibleReps' ) {columns[c].label = 'Person Responsible For POD'; hasResponsibleReps = true; }
    }
    var n = columns.length + 1;
    if( hasRating == false ) {
      columns.push({checked: false, id: 'customerRating', label: 'Customer Rating', order: n, width: 'auto'});
      n++;
    }
    if( hasInstallationDate == false ) {
      columns.push({checked: false, id: 'installationDate', label: 'Installation Date', order: n, width: 'auto'});
      n++;
    }
    if( hasInstallationDescription == false ) {
      columns.push({checked: false, id: 'installationDescription', label: 'Installation Description', order: n, width: 'auto'});
      n++;
    }
    if( hasOnsiteTime == false ) {
      columns.push({checked: false, id: 'onsiteTime', label: 'Onsite Time', order: n, width: 'auto'});
      n++;
    }
    if( hasJobComplete == false ) {
      columns.push({checked: false, id: 'jobComplete', label: 'Job Complete', order: n, width: 'auto'});
      n++;
    }
    if( hasCancellationReason == false ) {
      columns.push({checked: false, id: 'cancellationReason', label: 'Cancellation Reason', order: n, width: 'auto'});
      n++;
    }
    if( hasPurchaseOrder == false ) {
      columns.push({checked: false, id: 'purchaseOrder', label: 'Purchase Order Number', order: n, width: 'auto'});
      n++;
    }
    if( hasResponsibleReps == false ) {
      columns.push({checked: false, id: 'responsibleReps', label: 'Person Responsible For POD', order: n, width: 'auto'});
      n++;
    }
    if( hasDeliveryDate == false ) {
      columns.push({checked: false, id: 'delivery_date_api', label: 'Delivery Date', order: n, width: 'auto'});
      n++;
    }

    // if( hasManuDate == false ) {
    //   columns.push({checked: false, id: 'manufacturer_date_api', label: 'Manufacturer Date', order: n, width: 'auto'});
    //   n++;
    // }
    /*if( hasQuoteRegion == false ) {
      columns.push({checked: false, id: 'quoteRegion', label: 'Quote Region', order: n, width: 'auto'});
      n++;
    }*/

    commit( 'fncSetSoColumns', columns );

  } else {
    var soColumns = [];
    if( hasInstallationDate == false ) {
      columns.push({checked: false, id: 'installationDate', label: 'Installation Date', order: n, width: 'auto'});
      n++;
    }
    if( hasInstallationDescription == false ) {
      columns.push({checked: false, id: 'installationDescription', label: 'Installation Description', order: n, width: 'auto'});
      n++;
    }
    if( hasOnsiteTime == false ) {
      columns.push({checked: false, id: 'onsiteTime', label: 'Onsite Time', order: n, width: 'auto'});
      n++;
    }
    if( hasJobComplete == false ) {
      columns.push({checked: false, id: 'jobComplete', label: 'Job Complete', order: n, width: 'auto'});
      n++;
    }
    if( hasCancellationReason == false ) {
      columns.push({checked: false, id: 'cancellationReason', label: 'Cancellation Reason', order: n, width: 'auto'});
      n++;
    }
    // if( hasManuDate == false ) {
    //   columns.push({checked: false, id: 'manufacturer_date_api', label: 'Manufacturere Date', order: n, width: 'auto'});
    //   n++;
    // }
    /*if( hasQuoteRegion == false ) {
      columns.push({checked: false, id: 'quoteRegion', label: 'Quote Region', order: n, width: 'auto'});
      n++;
    }*/
    if (payload.type == '6' || payload.privileges.indexOf('VENDOR_HIDE_DETAILS') != -1 ) {
      soColumns.push({ "id": "date", "label": "Quote Date", "checked": true, "width": "auto", "order": 1 });
      soColumns.push({ "id": "vendorName", "label": "Vendor", "checked": true, "width": "auto", "order": 2 });
      soColumns.push({ "id": "items", "label": "Items", "checked": true, "width": "auto", "order": 3 });
      soColumns.push({ "id": "status", "label": "Status", "checked": true, "width": "auto", "order": 4 });
      soColumns.push({ "id": "quoteNo", "label": "Quote No", "checked": true, "width": "auto", "order": 5 });
      soColumns.push({ "id": "soNo", "label": "Sales order No", "checked": false, "width": "auto", "order": 6 });
      soColumns.push({ "id": "bwSalesOrderNo", "label": "BW Sales Order No", "checked": false, "width": "auto", "order": 7 });
      soColumns.push({ "id": "serviceType", "label": "Service Type", "checked": false, "width": "auto", "order": 8 });
      soColumns.push({ "id": "originatorName", "label": "Originator Name", "checked": false, "width": "auto", "order": 9 });
      soColumns.push({ "id": "soQty", "label": "Quantity", "checked": false, "width": "auto", "order": 10 });
      soColumns.push({ "id": "soGlassType", "label": "Glass Type", "checked": false, "width": "auto", "order": 11 });
      soColumns.push({ "id": "soGlassSize", "label": "Glass Size", "checked": false, "width": "auto", "order": 12 });
      soColumns.push({ "id": "soBranch", "label": "Store", "checked": false, "width": "auto", "order": 13 });
      soColumns.push({ "id": "customerRating", "label": "Customer Rating", "checked": false, "width": "auto", "order": 14 });
      soColumns.push({ "id": "installationDate", "label": "Installation Date", "checked": false, "width": "auto", "order": 15 });
      soColumns.push({ "id": "installationDescription", "label": "Store", "checked": false, "width": "auto", "order": 16 });
      soColumns.push({ "id": "onsiteTime", "label": "Store", "checked": false, "width": "auto", "order": 17 });
      soColumns.push({ "id": "jobComplete", "label": "Store", "checked": false, "width": "auto", "order": 18 });
      soColumns.push({ "id": "cancellationReason", "label": "Store", "checked": false, "width": "auto", "order": 19 });
      soColumns.push({ "id": "manufacturer_date_api", "label": "Manufacturer Date", "checked": false, "width": "auto", "order": 20 });
      if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1 ) {
        soColumns.push({ "id": "totalPrice", "label": "Total", "checked": true, "width": "auto", "order": 21 });
        soColumns.push({ "id": "quoteRegion", "label": "Quote Region", "checked": false, "width": "auto", "order": 22 });
      } else {
        soColumns.push({ "id": "quoteRegion", "label": "Quote Region", "checked": false, "width": "auto", "order": 21 });
      }
    } else {
      soColumns.push({ "id": "date", "label": "Quote Date", "checked": true, "width": "auto", "order": 1 });
      soColumns.push({ "id": "vendorName", "label": "Vendor", "checked": true, "width": "auto", "order": 2 });
      soColumns.push({ "id": "items", "label": "Items", "checked": true, "width": "auto", "order": 3 });
      soColumns.push({ "id": "status", "label": "Status", "checked": true, "width": "auto", "order": 4 });
      soColumns.push({ "id": "fullname", "label": "Customer Name", "checked": false, "width": "auto", "order": 5 });
      soColumns.push({ "id": "email", "label": "Customer Email", "checked": false, "width": "auto", "order": 6 });
      soColumns.push({ "id": "contactnum", "label": "Customer Contact", "checked": false, "width": "auto", "order": 7 });
      soColumns.push({ "id": "quoteNo", "label": "Quote No", "checked": true, "width": "auto", "order": 8 });
      soColumns.push({ "id": "soNo", "label": "Sales order No", "checked": false, "width": "auto", "order": 9 });
      soColumns.push({ "id": "bwSalesOrderNo", "label": "BW Sales Order No", "checked": false, "width": "auto", "order": 10 });
      soColumns.push({ "id": "serviceType", "label": "Service Type", "checked": false, "width": "auto", "order": 11 });
      soColumns.push({ "id": "originatorName", "label": "Originator Name", "checked": false, "width": "auto", "order": 12 });
      soColumns.push({ "id": "soQty", "label": "Q uantity", "checked": false, "width": "auto", "order": 13 });
      soColumns.push({ "id": "soGlassType", "label": "Glass Type", "checked": false, "width": "auto", "order": 14 });
      soColumns.push({ "id": "soGlassSize", "label": "Glass Size", "checked": false, "width": "auto", "order": 15 });
      soColumns.push({ "id": "soBranch", "label": "Store", "checked": false, "width": "auto", "order": 16 });
      soColumns.push({ "id": "customerRating", "label": "Customer Rating", "checked": false, "width": "auto", "order": 17 });
      soColumns.push({ "id": "installationDate", "label": "Installation Date", "checked": false, "width": "auto", "order": 18 });
      soColumns.push({ "id": "installationDescription", "label": "Store", "checked": false, "width": "auto", "order": 19 });
      soColumns.push({ "id": "onsiteTime", "label": "Store", "checked": false, "width": "auto", "order": 20 });
      soColumns.push({ "id": "jobComplete", "label": "Store", "checked": false, "width": "auto", "order": 21 });
      soColumns.push({ "id": "cancellationReason", "label": "Store", "checked": false, "width": "auto", "order": 22 });
      soColumns.push({ "id": "manufacturer_date_api", "label": "Manufacturer Date", "checked": false, "width": "auto", "order": 23 });
      if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
        soColumns.push({ "id": "totalPrice", "label": "Total", "checked": true, "width": "auto", "order": 24 });
        soColumns.push({ "id": "quoteRegion", "label": "Quote Region", "checked": false, "width": "auto", "order": 25 });
      } else {
        soColumns.push({ "id": "quoteRegion", "label": "Quote Region", "checked": false, "width": "auto", "order": 24 });
      }
    }
    var stringColumns = JSON.stringify( soColumns );

    var params = {
      columns: stringColumns,
      user: payload.id
    }

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=save_sales_order_columns', params, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to save the sales order columns', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {

      var settings_details = {
        sales_order_columns: stringColumns
      };
      dispatch({
        type: 'updateObjAuth',
        objChanges: settings_details
      });
      commit( 'fncSetSoColumns', JSON.parse( stringColumns ) );

    });

  }

}

export const fncSaveSalesOrderColumns = ({ commit, dispatch, state, rootState }, payload) => {

  var stringColumns = JSON.stringify( state.soColumns );
  var params = {
    columns: stringColumns,
    user: payload
  };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=save_sales_order_columns', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to save the purchase order columns', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data.success != undefined ) {
      var snackDetails = { color: 'success', message: 'Purchase Order Report columns have been updated', display: true };
      commit('setSnack', snackDetails);
      commit('fncEmptySalesOrders');
      var settings_details = {
        sales_order_columns: JSON.stringify(state.soColumns)
      };
      dispatch({
        type: 'updateObjAuth',
        objChanges: settings_details
      });
      commit( 'fncSetSoColumns', state.soColumns );
      setTimeout(function(){
        window.location.reload();
      }, 100);
      /*dispatch('fncPopulateSalesOrders', false);
      commit('hideModal');*/
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to save the purchase order columns', display: true };
      commit('setSnack', snackDetails);
    }
  });

}

export const fncSetupQuoteEdit = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  if( objAuth.hide_vendors == '1' ) {

    var statusDetails = { id: payload.id, ordered: true };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getContent', statusDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(data => {

      for( var d in data ) {
        // console.log( typeof(data[d].line_item_data) );
        var lineItemData = JSON.parse( data[d].line_item_data );
        // console.log( lineItemData );
        var bwCode = '0';
        if( lineItemData.bw_code != null && lineItemData.bw_code != '' && lineItemData.bw_code != null ) {
          bwCode = lineItemData.bw_code;
        }
        var markup = '0';
        if( lineItemData.markup != '' && lineItemData.markup != null ) {
          markup = lineItemData.markup;
        }
        var costPrice = '0';
        if( lineItemData.cost_price != '' && lineItemData.cost_price != null ) {
          costPrice = lineItemData.cost_price;
        }
        var priceEx = '0';
        if( lineItemData.price_ex != '' && lineItemData.price_ex != null ) {
          priceEx = lineItemData.price_ex;
        }

        var vendorCode = '';
        if( lineItemData.vendor_code != '' && lineItemData.vendor_code != null ) {
          vendorCode = lineItemData.vendor_code;
        }

        var hireDateEnd = '';
        if( lineItemData.hire_date_end != '' && lineItemData.hire_date_end != null ) {
          hireDateEnd = lineItemData.hire_date_end;
        }

        var hireDateStart = '';
        if( lineItemData.hire_date_start != '' && lineItemData.hire_date_start != null ) {
          hireDateStart = lineItemData.hire_date_start;
        }

        var deliveryMethod = '';
        if( lineItemData.delivery_method != '' && lineItemData.delivery_method != null ) {
          deliveryMethod = lineItemData.delivery_method;
        }

        var receivalTime = '';
        if( lineItemData.receival_time != '' && lineItemData.receival_time != null ) {
          receivalTime = lineItemData.receival_time;
        }

        var hirePeriod = '';
        if( lineItemData.hire_period != '' && lineItemData.hire_period != null ) {
          hirePeriod = lineItemData.hire_period;
        }

        data[d].markup = markup;
        data[d].bw_code = bwCode;
        data[d].cost_price = costPrice;
        data[d].price_ex = priceEx;
        data[d].vendor_code = vendorCode;
        data[d].hire_date_start = hireDateStart;
        data[d].hire_date_end = hireDateEnd;
        data[d].delivery_method = deliveryMethod;
        data[d].receival_time = receivalTime;
        data[d].hire_period = hirePeriod;
        data[d].vat = parseFloat(priceEx) * 0.15;
        data[d].deleted = false;

      }

      commit('fncSetEditLoading', false);
      var modalDetails = { title: 'Update Details - ' + payload.quote_no, component: 'modal-edit-quote-details', mstate: true, params: { details: data, objRanges: [], id: payload.id, vendorId: payload.vendorId, plistItems: [], vendorCodes: [], storeName: payload.store_name, status: payload.status, departmentId: payload.departmentId, customer: payload.customer_email } };
      commit({
        type: 'setModal',
        details: modalDetails
      });


    });

      /*commit('fncSetEditLoading', false);
      var modalDetails = { title: 'Update Details - ' + payload.quote_no, component: 'modal-edit-quote-details', mstate: true, params: { details: data, objRanges: [], id: payload.id, vendorId: payload.vendorId, plistItems: totalSdt, vendorCodes: codes, storeName: payload.store_name, status: payload.status, departmentId: payload.departmentId, customer: payload.customer_email } };
      commit({
        type: 'setModal',
        details: modalDetails
      });*/

  } else {

    // main call
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getAllVendorProductCodes', [], rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(codes => {

      var vendorDetails = { vendor: payload.vendorId, departmentId: payload.departmentId, storeCode: payload.store_name }

      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getVendorProductCodes', vendorDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured', display: true };
          commit('setSnack', snackDetails);
          console.log(error);
        }).then(vpc => {

        //var articles = vpc.split(',');
        var articles = vpc;

        var statusDetails = { id: payload.id, ordered: true };
        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getContent', statusDetails, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            var snackDetails = { color: 'error', message: 'An error has occured', display: true };
            commit('setSnack', snackDetails);
            console.log(error);
          }).then(data => {

          for( var d in data ) {
            // console.log( typeof(data[d].line_item_data) );
            var lineItemData = JSON.parse( data[d].line_item_data );
            // console.log( lineItemData );
            var bwCode = '0';
            if( lineItemData.bw_code != null && lineItemData.bw_code != '' && lineItemData.bw_code != null ) {
              bwCode = lineItemData.bw_code;
            }
            var markup = '0';
            if( lineItemData.markup != '' && lineItemData.markup != null ) {
              markup = lineItemData.markup;
            }
            var costPrice = '0';
            if( lineItemData.cost_price != '' && lineItemData.cost_price != null ) {
              costPrice = lineItemData.cost_price;
            }
            var priceEx = '0';
            if( lineItemData.price_ex != '' && lineItemData.price_ex != null ) {
              priceEx = lineItemData.price_ex;
            }

            var vendorCode = '';
            if( lineItemData.vendor_code != '' && lineItemData.vendor_code != null ) {
              vendorCode = lineItemData.vendor_code;
            }

            var hireDateEnd = '';
            if( lineItemData.hire_date_end != '' && lineItemData.hire_date_end != null ) {
              hireDateEnd = lineItemData.hire_date_end;
            }

            var hireDateStart = '';
            if( lineItemData.hire_date_start != '' && lineItemData.hire_date_start != null ) {
              hireDateStart = lineItemData.hire_date_start;
            }

            var deliveryMethod = '';
            if( lineItemData.delivery_method != '' && lineItemData.delivery_method != null ) {
              deliveryMethod = lineItemData.delivery_method;
            }

            var receivalTime = '';
            if( lineItemData.receival_time != '' && lineItemData.receival_time != null ) {
              receivalTime = lineItemData.receival_time;
            }

            var hirePeriod = '';
            if( lineItemData.hire_period != '' && lineItemData.hire_period != null ) {
              hirePeriod = lineItemData.hire_period;
            }

            data[d].markup = markup;
            data[d].bw_code = bwCode;
            data[d].cost_price = costPrice;
            data[d].price_ex = priceEx;
            data[d].vendor_code = vendorCode;
            data[d].hire_date_start = hireDateStart;
            data[d].hire_date_end = hireDateEnd;
            data[d].delivery_method = deliveryMethod;
            data[d].receival_time = receivalTime;
            data[d].hire_period = hirePeriod;
            data[d].vat = parseFloat(priceEx) * 0.15;
            data[d].deleted = false;

          }

          var objAuth = JSON.parse(rootState.objAuthorize);
          Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              var snackDetails = { color: 'error', message: 'An error has occured', display: true };
              commit('setSnack', snackDetails);
              console.log(error);
            }).then(sdata => {

            if( articles.length > 0 ) {

              if( articles.length > 100 ) {

                var pages = Math.ceil(articles.length / 100);
                var resultArray = [];
                var perChunk = 100;

                var result = articles.reduce((articles, item, index) => {
                  var chunkIndex = Math.floor(index/perChunk);

                  if(!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = [] // start a new chunk
                  }

                  resultArray[chunkIndex].push(item);

                  return resultArray;
                }, []);

                var logCounter = 0;
                var totalSdt = [];

                for( var n in result ) {
                  logCounter++;
                  var tokenDetails = { token: sdata.token, retailer_id: '1', limit: 1000000, articles: result[n] };
                  Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/articles', { params: tokenDetails }, rootState.headerDetails)
                    .then(response => {
                      return response.json();
                    }, error => {
                      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                      commit('setSnack', snackDetails);
                      console.log(error);
                    }).then(sdt => {

                    if( sdt.length > 0 ) {
                      for( var s in sdt ) {
                        totalSdt.push( sdt[s] );
                      }
                    }

                  });
                }

                var timer = 250 * pages;

                setTimeout(function(){
                  commit('fncSetEditLoading', false);
                  var modalDetails = { title: 'Update Details - ' + payload.quote_no, component: 'modal-edit-quote-details', mstate: true, params: { details: data, objRanges: [], id: payload.id, vendorId: payload.vendorId, plistItems: totalSdt, vendorCodes: codes, storeName: payload.store_name, status: payload.status, departmentId: payload.departmentId, customer: payload.customer_email } };
                  commit({
                    type: 'setModal',
                    details: modalDetails
                  });
                }, timer);

              } else {

                var tokenDetails = { token: sdata.token, retailer_id: '1', limit: 1000000, articles: articles };
                Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/articles', { params: tokenDetails }, rootState.headerDetails)
                  .then(response => {
                    return response.json();
                  }, error => {
                    var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                    commit('setSnack', snackDetails);
                    console.log(error);
                  }).then(sdt => {

                  commit('fncSetEditLoading', false);
                  var modalDetails = { title: 'Update Details - ' + payload.quote_no, component: 'modal-edit-quote-details', mstate: true, params: { details: data, objRanges: [], id: payload.id, vendorId: payload.vendorId, plistItems: sdt, vendorCodes: codes, storeName: payload.store_name, status: payload.status, departmentId: payload.departmentId, customer: payload.customer_email } };
                  commit({
                    type: 'setModal',
                    details: modalDetails
                  });

                });
              }


            } else {

              commit('fncSetEditLoading', false);
              var modalDetails = { title: 'Update Details - ' + payload.quote_no, component: 'modal-edit-quote-details', mstate: true, params: { details: data, objRanges: [], id: payload.id, vendorId: payload.vendorId, plistItems: [], vendorCodes: codes, storeName: payload.store_name, status: payload.status, departmentId: payload.departmentId, customer: payload.customer_email } };
              commit({
                type: 'setModal',
                details: modalDetails
              });

            }

          });

        });

      });

    });

  }

}

export const fncSaveQuoteItems = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);

  if( payload.tallisman == true ) {
    var quoteDetails = { id: payload.id, data: payload.data, manufacturer: objAuth.manufacturer, vendorId: payload.vendorId, tallisman: payload.tallisman, addressOne: payload.address['addressOne'],addressTwo: payload.address['addressTwo'],town: payload.address['town'], province: payload.address['province'], postalCode: payload.address['postalCode'], notes: payload.notes };
  } else {
    var quoteDetails = { id: payload.id, data: payload.data, manufacturer: objAuth.manufacturer, vendorId: payload.vendorId, tallisman: payload.tallisman, address: payload.address };
  }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=editItems', quoteDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    if( data == true ) {

      if( payload.doPdf != undefined && payload.doPdf == true ) {

        dispatch('fncGeneratePdf', payload.id );

      } else if( payload.sendHybris != undefined && payload.sendHybris == true ) {

        dispatch({
          type: 'fncSendToHybrisShoppingList',
          data: payload.hybrisData,
          statusName: payload.hybrisStatusName
        })

      } else {
        var snackDetails = { color: 'success', message: 'The quote items have successfully been updated', display: true };
        commit('setSnack', snackDetails);
        setTimeout(function() {
          location.reload();
        },500)
        //console.log('Reload');
      }

    } else {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncPopulateSettings = ({ commit, dispatch, state, rootState }, payload) => {
  var manuId = '';
  if( payload != '' ) {
    manuId = payload;
  } else {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var manuId = objAuth.manufacturer;
  }
  var settingsDetails = {
    manufacturer: manuId
  };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=retrieve_system_settings', { params: settingsDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the RFC list', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    commit( 'fncSetSystemSettings', data );
  });
}

export const fncArchiveQuote = ({ commit, dispatch, state, rootState }, payload) => {
  var quoteDetails = {
    quoteId: payload
  };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=archive_quote', { params: quoteDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'The quote could not be archived', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
      var snackDetails = { color: 'success', message: 'The quote has been archived', display: true };
      commit('setSnack', snackDetails);
      setTimeout(function(){
        if( window.location.hash.indexOf('quote-single-content?quote=') != -1 ) {
          router.push({path: '/reports/quote-reports-lite', query: {p: 1}});
          router.go();
        } else {
          location.reload();
        }
      }, 500)
  });
}

export const fncUpdateStatusReason = ({ commit, dispatch, state, rootState }, payload) => {
  var quoteDetails = {
    details: payload
  };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=update_status_reason', { params: quoteDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'The status data could not be edited', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
      var snackDetails = { color: 'success', message: 'The status data has successfully been updated', display: true };
      commit('setSnack', snackDetails);
  });
}

export const fncUpdateQuoteOriginator = ({ commit, dispatch, state, rootState }, payload) => {
  var quoteDetails = {
    details: payload
  };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=update_originator', { params: quoteDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'The originator could not be edited', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    var snackDetails = { color: 'success', message: 'The originator has successfully been updated', display: true };
    commit('setSnack', snackDetails);
  });
}

export const fncGetQuoteCodes = ({ commit, dispatch, state, rootState }, payload) => {
  var quoteDetails = { id: payload };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Process.php?a=getQuoteCodes', quoteDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit( 'setSurveyProductCodes', data );
  });
};

export const fncNotificationHistory = ({ commit, dispatch, state, rootState }, payload) => {
  var quoteDetails = { id: payload.quoteId };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'InternalNotifications.php?a=getHistory', quoteDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit('setNotificationHistoryLoaded', true);
      commit('setNotificationHistory', data);
    /*var modalDetails = { title: 'Notification History', component: 'modal-notification-history', mstate: true, params: { details: data } };
    commit({
      type: 'setModal',
      details: modalDetails
    });*/

    //commit( 'setSurveyProductCodes', data );
  });
};

export const fncDoSoExcel = ({ commit, dispatch, state, rootState }, payload) => {

  var page = 0;
  var objAuth = JSON.parse(rootState.objAuthorize);
  var userDetails = { a: 'userVendor', id: objAuth.id };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: userDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(d => {

    if( objAuth.type == '6' && d[0].vendor != undefined ){
      var salesDetails = { manufacturer: objAuth.manufacturer, vendor: d[0].vendor, page: page, vendors: payload.vendors, status: payload.status, stores: payload.stores, soDates: payload.soDates, columns: payload.columns, search: payload.search };
    } else {
      var salesDetails = { manufacturer: objAuth.manufacturer, page: page, vendors: payload.objVendor, status: payload.objStatus, stores: payload.objStore, soDates: payload.reportDate, columns: payload.columns, search: payload.search };
    }

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=salesOrder', salesDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {

      // console.log( data );
      dispatch('fncReturnExcel', data);
      commit('setSoExcelLoading', false);
    });
  });

};

export const fncCheckTokenAuth = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=checkTokenAuth', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      commit( 'setFormValid', data );
  });

};

export const fncProcessOrder = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  payload.userChanging = objAuth.id;
  payload.manufacturer = objAuth.manufacturer;
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=processOrder', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data == true ) {
        var snackDetails = { color: 'success', message: 'The order has been placed successfully', display: true };
        commit('setSnack', snackDetails);
        setTimeout(function(){
          location.reload();
        }, 500)
      } else {
        var snackDetails = { color: 'error', message: 'The order could not be processed', display: true };
        commit('setSnack', snackDetails);
      }
  });

};

export const fncGenerateSummaryReport = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  payload.manufacturer = objAuth.manufacturer;
  let start = payload.hasOwnProperty("startDate") ? payload.startDate : payload.start_date
  let end  = payload.hasOwnProperty("endDate") ? payload.endDate : payload.end_date
  if( start != '' ) {
    var sDate = new Date(start);
    sDate.setDate(sDate.getDate() + 1);
    payload.start_date = sDate.toISOString().split('T')[0];
  } else {
    payload.start_date = '';
  }

  if( end != '' ) {
    var eDate = new Date(end);
    eDate.setDate(eDate.getDate() + 1);
    payload.end_date = eDate.toISOString().split('T')[0];
  } else {
    payload.end_date = '';
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=generateSummaryReportOriginal', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit('fncSummaryFilterLoad', false);
    if( data.success == true ) {
      var reportDownload = document.createElement('a');
      reportDownload.setAttribute('href', data.file);
      reportDownload.setAttribute('download', 'summary-report.xlsx');
      reportDownload.click();
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to create the excel file', display: true };
      commit('setSnack', snackDetails);
    }

  });

};


export const fncUpdateCommercialKam = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateQuoteKam', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The kam has been updated', display: true };
      commit('setSnack', snackDetails);
      setTimeout(function(){
        location.reload();
      }, 500)
    } else {
      var snackDetails = { color: 'error', message: 'The kam could not be updated', display: true };
      commit('setSnack', snackDetails);
    };

  });

};

export const fncUpdateCommercialOriginator = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateQuoteOriginator', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The originator has been updated', display: true };
      commit('setSnack', snackDetails);
      setTimeout(function(){
        location.reload();
      }, 500)
    } else {
      var snackDetails = { color: 'error', message: 'The originator could not be updated', display: true };
      commit('setSnack', snackDetails);
    };

  });

};

export const fncGetCalculators = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getCalculatorLinks', { quote: payload.id }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    var modalDetails = { title: 'Select Calculator', component: 'modal-quote-calculator', mstate: true, params: { links: data, quote: payload } };
    commit({
      type: 'setModal',
      details: modalDetails
    });

  });

};

export const fncSetCustomerRecipient = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=setCustomerRecipient', { id: payload.quote, customer_recipient: payload.emails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data == true ) {
        var snackDetails = { color: 'success', message: 'The customer recipient has been updated', display: true };
      } else {
        var snackDetails = { color: 'error', message: 'The customer recipient could not be updated', display: true };
      }
      commit('setSnack', snackDetails);
      setTimeout(function() {
        location.reload();
      },250)
  });

};

export const fncSetVendorRecipient = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=setVendorRecipient', { id: payload.quote, vendor_recipient: payload.emails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The vendor recipient has been updated', display: true };
    } else {
      var snackDetails = { color: 'error', message: 'The vendor recipient could not be updated', display: true };
    }
    commit('setSnack', snackDetails);
    setTimeout(function() {
      location.reload();
    },250)
  });

};

export const fncSendToHybrisShoppingList = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);

  var statusDetails = { type: 'quote_status_change', prev_value: payload.data.status, new_value: payload.statusName, user: objAuth.id, target: payload.data.id, data: 'Updated from Quote Edit screen', manufacturer: objAuth.manufacturer, save: 'true' };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add', statusDetails, rootState.headerDetails)
    .then(response => {
      /*if( response.body.indexOf('file_get_contents') != '' ) {
        var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
        commit('setSnack', snackDetails);
      }*/
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data.error != null ) {
      var snackDetails = {color: 'error', message: data.error, display: true};
    } else {
      var snackDetails = {color: 'success', message: 'The quote status was updated successfully', display: true};
    }

    if( window.location.hash.indexOf('quote-single-content?quote=') != -1 ) {
      window.location.reload();
    } else {
      commit('setSnack', snackDetails);
    }

    commit('hideModal');

  });
}

export const fncUpdatePodCategory = ({commit, dispatch, state, rootState}, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  var podDetails = { manufacturer: objAuth.manufacturer, category: payload };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=updatePodCategory', podDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {

      if( data == true ) {
        var snackDetails = {color: 'success', message: 'The POD category was updated successfully', display: true};
        var uniObjAuthorize = JSON.parse(rootState.objAuthorize);
            uniObjAuthorize['pod_category'] = payload;

            commit('setObjAuthorize', uniObjAuthorize);

            console.log('Auth');
            console.log( uniObjAuthorize );
      } else {
        var snackDetails = {color: 'error', message: 'The POD category was not updated', display: true};
      }

      commit('setSnack', snackDetails);

  });
}

export const fncUpdatePodStatus = ({commit, dispatch, state, rootState}, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {

      if( data.error != null ) {
        var snackDetails = {color: 'error', message: data.error, display: true};
        commit('setSnack', snackDetails);
      } else {
        var snackDetails = {color: 'success', message: 'The quote status was updated successfully', display: true};

        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateSoItemStatus', { 'id': payload.itemId }, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
            commit('setSnack', snackDetails);
          }).then(data => {
            commit('setSnack', snackDetails);
        });

      }



  });
}

export const fncUpdateSoMeta = ({commit, dispatch, state, rootState}, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateSoMeta', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data.error != null ) {
      var snackDetails = {color: 'error', message: 'The meta data could not be saved', display: true};
    } else {
      var snackDetails = {color: 'success', message: 'The meta data was saved successfully', display: true};
    }
    commit('setSnack', snackDetails);
  });
}

export const fncGetResponsibleReps = ({commit, dispatch, state, rootState}, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getResponsibleReps', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {
      commit('setSoReps', data);
  });
}

export const fncUpdateQuoteRepsSwitchSo = ({commit, dispatch, state, rootState}, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateSoReps', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to update the quote status', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data == true ) {
      var snackDetails = {color: 'success', message: 'The users have been updated successfully', display: true};
    } else {
      var snackDetails = {color: 'error', message: 'There was an error updating the users', display: true};
    }
    commit('setSnack', snackDetails);

  });
}

export const fncDeleteAllAttachments = ({commit, dispatch, state, rootState}, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=deleteAllAttachments', { quote: payload }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error occured while trying to delete the quote attachments', display: true};
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data == true ) {
      var snackDetails = {color: 'success', message: 'The attachments have been deleted successfully', display: true};

    } else {
      var snackDetails = {color: 'error', message: 'There was an error deleting the attachments', display: true};
    }
    commit('setSnack', snackDetails);

  });
}

export const fncPopulateFiltersList = ({commit, dispatch, state, rootState}, payload)  => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var details = {manufacturer: objAuth.manufacturer};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=get_filters_data', {params: details}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit({
      type: 'setAllFilters',
       filters: data
    });
  });
};

export const fncFilterLineItems = ({commit, dispatch, state, rootState}, payload)  => {

  var objAuthorize = JSON.parse(rootState.objAuthorize);

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {

    var pricelistDetails = {token: data.token, id32: payload};
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/line_items', {params: pricelistDetails}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = {
          color: 'error',
          message: 'An error has occured retrieving the user pricelists',
          display: true
        };
        commit('setSnack', snackDetails);
      }).then(data => {

      commit({
        type: 'fncSetCalculatorFilterItems',
        rangeId: payload,
        data: data
      });

    });

  });

}

export const fncUpdateQuoteNumber = ({commit, dispatch, state, rootState}, payload)  => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var details = {quote: payload, manufacturer: objAuth.manufacturer};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=update_quote_number', {params: details}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data == true ) {
        var snackDetails = {color: 'success', message: 'The Quote Number has been updated', display: true};
      } else {
        var snackDetails = {color: 'error', message: 'The Quote Number could not be updated', display: true};
      }
      commit('setSnack', snackDetails);
      setTimeout(function(){
        window.location.reload();
      }, 1000);

    });
};

export const fncGenerateStatusSummaryReport = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=generateSummaryStatusReport', {quote: payload}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    if (data.success == true) {
      var reportDownload = document.createElement('a');
      reportDownload.setAttribute('href', data.file);
      reportDownload.setAttribute('download', 'status-summary-report.xlsx');
      reportDownload.click();
      //commit('setSummaryLoading', false);
    } else {
      var snackDetails = {
        color: 'error',
        message: 'An error occured while trying to create the excel file',
        display: true
      };
      commit('setSnack', snackDetails);
      //commit('setSummaryLoading', false);
    }
  })
}

export const getStoreItems = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuthorize = JSON.parse(rootState.objAuthorize);

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(dd => {

    var pricelistDetails = {token: dd.token, id32: payload.range};
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/line_items', {params: pricelistDetails}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = {
          color: 'error',
          message: 'An error has occured retrieving the user pricelists',
          display: true
        };
        commit('setSnack', snackDetails);
      }).then(data => {

        var allItems = data;

        var arrData = Object.values(data);

        var zeroPad = (num, places) => String(num).padStart(places, '0');
        var chunks = [];
        var chunkSize = 10000;

        for (var i = 0; i < arrData.length; i += chunkSize) {
          //var chunk = data.slice(i, i + chunkSize);
          var chunk = arrData.slice(i, i + chunkSize);
          chunks.push(chunk);
        }

        var allChunks = [];
        var finalChunks = [];

        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);

        var jobId = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');

        //for( var n in chunks ) {
        for (var n = 0; n <= chunks.length; n++) { 

          var x = 0;
          var count = 0;
          var timeout = 500 * ( x + 1 );

          setTimeout(function(){

            var strCodes = [];
            for( var p in chunks[x] ) {            
              strCodes.push(zeroPad(chunks[x][p].article_number, 18));
            }

            strCodes = strCodes.join(',');

            x++;
            timeout = 500 * ( x + 1 );

            Vue.http.post(process.env.MIDDLEWARE_FILE, {action: 'auth'}, rootState.headerDetails)
              .then(response => {
                return response.json();
              }, error => {
                console.log(error);
              }).then(dd => {

                var feed = {
                  action: 'feed',
                  access_token: dd.access_token,
                  store: payload.store,
                  customer: payload.customer,
                  products: strCodes,
                  job_id: jobId
                };

                Vue.http.post(process.env.MIDDLEWARE_FILE, feed, rootState.headerDetails)
                  .then(response => {
                    return response.json();
                  }, error => {
                    console.log(error);
                  }).then(d => {

                    count++;

                  for( var s in d ) {
                    for( var p in d[s] ) {
                      if( finalChunks[d[s][p]['product']] == undefined ) {
                        finalChunks[d[s][p]['product']] = [];
                        finalChunks[d[s][p]['product']]['price'] = '';
                        finalChunks[d[s][p]['product']]['listed'] = '';
                      }
                      finalChunks[d[s][p]['product']]['price'] = d[s][p]['price'];
                      finalChunks[d[s][p]['product']]['listed'] = d[s][p]['listed'];
                    }
                  }

                  if( count == ( chunks.length + 1 ) ) {

                    commit({
                      type: 'setStoreItems',
                      rangeId: payload.range,
                      allItems: allItems,
                      chunks: finalChunks,
                      addedItems: payload.addedItems
                    })

                  }

                })
            });

          }, timeout)
        }

    });
  });

}

export const fncGeneratePdf = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=generateQuotePdf', {quote: payload}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    if (data.result != false) {
      var reportDownload = document.createElement('a');
      reportDownload.setAttribute('href', data.result);
      reportDownload.setAttribute('download', 'preview_quote.pdf');
      reportDownload.click();

    } else {
      var snackDetails = {
        color: 'error',
        message: 'An error occured while trying to create the Quote PDF',
        display: true
      };
      commit('setSnack', snackDetails);
    }
  })
}

export const fncGetStatusOrder = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getStatusOrder', {quotes: payload.quotes}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    const quotes = store.getters.quoteSearchList
    let ascending = null
    let descending = null
    if (payload.order == -1) {
      // sort in descending order based on date
      descending = data.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
    } else {
      ascending = data.slice().sort((a, b) => new Date(a.date) - new Date(b.date));

    }
    let tmp = (descending != null) ? descending : ascending
    const targetPositions = {};

    tmp.forEach((item, index) => {
      targetPositions[item.target] = index;
    });

    quotes.sort((a, b) => {
      const posA = targetPositions[a.id];
      const posB = targetPositions[b.id];
      return posA - posB;
    });

    //this.$store.commit('fncSortedQuotes', quotes);
    commit('fncSortedQuotes', quotes);


  });
}

export const fncGetStoreAudits = ({commit, dispatch, state, rootState}, payload)  => {
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=get_store_audits', {quote: payload}, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    commit( 'setStoreAudits', data );

  });
};

export const fncGetVendor = ({commit, dispatch, state, rootState}, payload)  => {

  var zeroPad = (num, places) => String(num).padStart(places, '0');

  var articles = []
  articles.push(zeroPad( payload, 18 ));

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(sdata => {

    var tokenDetails = { token: sdata.token, retailer_id: '1', limit: 1, articles: articles };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/articles', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(sdt => {

      if( sdt.length != 0 ) {
        commit({
          type: 'fncSetVendorCodes',
          code: payload,
          vendor: sdt[0].vendor
        });
      }



    });

  });

};

export const fncGetVendorAll = ({commit, dispatch, state, rootState}, payload)  => {

  var zeroPad = (num, places) => String(num).padStart(places, '0');

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(sdata => {

    var tokenDetails = { token: sdata.token, retailer_id: '1', articles: payload };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/articles', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(sdt => {

      if( sdt.length != 0 ) {
        commit('fncSetVendorCodesAll',sdt);
      }

    });

  });

};

export const getArchivedQuotes = ({commit, dispatch, state, rootState}, payload)  => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  var details = { manufacturer: objAuth.manufacturer, quote_no: payload }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getArchivedQuotes', details, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit('fncSetArchivedQuotes', data);

  });
};

export const fncUnarchiveQuote = ({commit, dispatch, state, rootState}, payload)  => {

  var details = { id: payload }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=unarchiveQuote', details, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    if( data == true ) {
      var snackDetails = { color: 'success', message: 'Quote has successfully been unarchived', display: true };
      commit('setSnack', snackDetails);

      setTimeout(function(){
        location.reload();
      }, 500)
    } else {
      var snackDetails = { color: 'error', message: 'An error has occured while trying to unarchive quote', display: true };
      commit('setSnack', snackDetails);
    }

  });
};

export const fncUpdateStore = ({commit, dispatch, state, rootState}, payload)  => {

  var details = { quote: payload.id, store: payload.store_name  }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateStore', details, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    if( data == true ) {
      var snackDetails = { color: 'success', message: 'Store has successfully been update', display: true };
      commit('setSnack', snackDetails);

      setTimeout(function(){
        location.reload();
      }, 1500)
    } else {
      var snackDetails = { color: 'error', message: 'An error has occured while trying to update the store', display: true };
      commit('setSnack', snackDetails);
    }

  });
};

export const fncGetSurveyCalculators = ({commit, dispatch, state, rootState}, payload)  => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getSurveyCalculators', '', rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit('fncSetSurveyCalculators', data);

  });
};


export const fncGenerateDeliveryNote = ({ commit, dispatch, state, rootState }, payload) => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=generateDeliveryNotePdf', {quote: payload.id}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    if( data.result == 'notchecked' ) {
      var snackDetails = {
        color: 'error',
        message: 'The quote has not been checked out',
        display: true
      };
      commit('setSnack', snackDetails);
    } else if (data.result != false) {
      var reportDownload = document.createElement('a');
      reportDownload.setAttribute('href', data.result);
      reportDownload.setAttribute('download', 'delivery_note_'+payload.quote_no+'.pdf');
      reportDownload.click();

    } else {
      var snackDetails = {
        color: 'error',
        message: 'An error occured while trying to create the Quote PDF',
        display: true
      };
      commit('setSnack', snackDetails);
    }

  });
};


export const fncGetQuoteApi = ({commit, dispatch, state, rootState}, payload)  => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuoteApi', { quote: payload }, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    commit('fncSetQuoteApis', data);

  });
};

export const fncQuoteReportLite = ({commit, dispatch, state, rootState}, payload)  => {

  if( !payload ) {
    payload = [];
  }

  var objAuth = JSON.parse(rootState.objAuthorize);

  var details = {manufacturer: objAuth.manufacturer, user: objAuth.id}

  // && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' )

  if( payload.status && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.status.indexOf('all');
    if (index !== -1) {
      payload.status.splice(index, 1);
    }

    if( payload.status.length != 0 ) {
      details['status'] = payload.status;
    }

  }

  if( payload.department && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.department.indexOf('all');
    if (index !== -1) {
      payload.department.splice(index, 1);
    }

    if( payload.department.length != 0 ) {
      details['department'] = payload.department;
    }

  }

  if( payload.store && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.store.indexOf('all');
    if (index !== -1) {
      payload.store.splice(index, 1);
    }

    if( payload.store.length != 0 ) {
      details['store'] = payload.store;
    }

  }

  if( payload.customer && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.customer.indexOf('all');
    if (index !== -1) {
      payload.customer.splice(index, 1);
    }

    if( payload.customer.length != 0 ) {
      details['customer'] = payload.customer;
    }

  }

  if( payload.vendor && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.vendor.indexOf('all');
    if (index !== -1) {
      payload.vendor.splice(index, 1);
    }

    if( payload.vendor.length != 0 ) {
      details['vendor'] = payload.vendor;
    }

  }

  if( payload.company && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.company.indexOf('all');
    if (index !== -1) {
      payload.company.splice(index, 1);
    }

    if( payload.company.length != 0 ) {
      details['company'] = payload.company;
    }

  }

  if( payload.originator && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.originator.indexOf('all');
    if (index !== -1) {
      payload.originator.splice(index, 1);
    }

    if( payload.originator.length != 0 ) {
      details['originator'] = payload.originator;
    }

  }

  if( payload.project && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.project.indexOf('all');
    if (index !== -1) {
      payload.project.splice(index, 1);
    }

    if( payload.project.length != 0 ) {
      details['project'] = payload.store;
    }

  }

  if( payload.service_type && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.service_type.indexOf('all');
    if (index !== -1) {
      payload.service_type.splice(index, 1);
    }

    if( payload.service_type.length != 0 ) {
      details['service_type'] = payload.service_type;
    }

  }

  if( payload.linked_user && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.linked_user.indexOf('all');
    if (index !== -1) {
      payload.linked_user.splice(index, 1);
    }

    if( payload.linked_user.length != 0 ) {
      details['linked_user'] = payload.linked_user;
    }

  }

  if( payload.location && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.location.indexOf('all');
    if (index !== -1) {
      payload.location.splice(index, 1);
    }

    if( payload.location.length != 0 ) {
      details['location'] = payload.location;
    }

  }

  if( payload.customer_telephone && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    if( payload.customer_telephone != '' ) {
      details['customer_telephone'] = payload.customer_telephone;
    }

  }

  if( payload.startDate && payload.startDate != undefined && payload.startDate != 'undefined ' && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {
    details['startDate'] = payload.startDate;
  }

  if( payload.endDate && payload.endDate != 'undefined' && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {
    details['endDate'] = payload.endDate;
  }

  if (window.localStorage.reportSearch != null && window.localStorage.reportSearch != 'undefined' && window.localStorage.reportSearch != '') {
    details['search'] = window.localStorage.reportSearch;
  }

  if( details['startDate'] == 'undefined' ) {
    delete details['startDate'];
  }

  if( payload.tab ){
    details['tab'] = payload.tab;
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuotesLite', details, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    commit('fncSetQuotesLite', data);
    commit('fncSetQuoteLiteLoaded', true);

  });
}

export const getQuotesLiteFilters = ({commit, dispatch, state, rootState}, payload)  => {

  if( !payload ) {
    payload = [];
  }

  var objAuth = JSON.parse(rootState.objAuthorize);

  var details = {manufacturer: objAuth.manufacturer, user: objAuth.id}

  if( payload.status ) {

    var index = payload.status.indexOf('all');
    if (index !== -1) {
      payload.status.splice(index, 1);
    }

    if( payload.status.length != 0 ) {
      details['status'] = payload.status;
    }

  }

  if( payload.department ) {

    var index = payload.department.indexOf('all');
    if (index !== -1) {
      payload.department.splice(index, 1);
    }

    if( payload.department.length != 0 ) {
      details['department'] = payload.department;
    }

  }

  if( payload.store ) {

    var index = payload.store.indexOf('all');
    if (index !== -1) {
      payload.store.splice(index, 1);
    }

    if( payload.store.length != 0 ) {
      details['store'] = payload.store;
    }

  }

  if( payload.customer ) {

    var index = payload.customer.indexOf('all');
    if (index !== -1) {
      payload.customer.splice(index, 1);
    }

    if( payload.customer.length != 0 ) {
      details['customer'] = payload.customer;
    }

  }

  if( payload.vendor ) {

    var index = payload.vendor.indexOf('all');
    if (index !== -1) {
      payload.vendor.splice(index, 1);
    }

    if( payload.vendor.length != 0 ) {
      details['vendor'] = payload.vendor;
    }

  }

  if( payload.company ) {

    var index = payload.company.indexOf('all');
    if (index !== -1) {
      payload.company.splice(index, 1);
    }

    if( payload.company.length != 0 ) {
      details['company'] = payload.company;
    }

  }

  if( payload.originator ) {

    var index = payload.originator.indexOf('all');
    if (index !== -1) {
      payload.originator.splice(index, 1);
    }

    if( payload.originator.length != 0 ) {
      details['originator'] = payload.originator;
    }

  }

  if( payload.project ) {

    var index = payload.project.indexOf('all');
    if (index !== -1) {
      payload.project.splice(index, 1);
    }

    if( payload.project.length != 0 ) {
      details['project'] = payload.store;
    }

  }

  if( payload.service_type ) {

    var index = payload.service_type.indexOf('all');
    if (index !== -1) {
      payload.service_type.splice(index, 1);
    }

    if( payload.service_type.length != 0 ) {
      details['service_type'] = payload.service_type;
    }

  }

  if( payload.customer_telephone && payload.customer_telephone != '' ) {

    details['customer_telephone'] = payload.customer_telephone;

  }

  if( payload.linked_user ) {

    var index = payload.linked_user.indexOf('all');
    if (index !== -1) {
      payload.linked_user.splice(index, 1);
    }

    if( payload.linked_user.length != 0 ) {
      details['linked_user'] = payload.linked_user;
    }

  }

  if( payload.location ) {

    var index = payload.location.indexOf('all');
    if (index !== -1) {
      payload.location.splice(index, 1);
    }

    if( payload.location.length != 0 ) {
      details['location'] = payload.location;
    }

  }

  if( payload.startDate && payload.startDate != 'undefined' ) {
    details['startDate'] = payload.startDate;
  }

  if( payload.endDate ) {
    details['endDate'] = payload.endDate;
  }

  if (window.localStorage.reportSearch != null && window.localStorage.reportSearch != 'undefined') {
    details['search'] = window.localStorage.reportSearch;
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuotesLiteFilters', details, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit('fncSetQuotesLiteFilters', data);
      commit('fncSetFiltersLoading', false);
      commit('fncSetLiteFilterLoaded', true);

  });
}

export const fncUpdateDate = ({commit, dispatch, state, rootState}, payload) => {
  if (rootState && rootState.hasOwnProperty('objAuthorize') && rootState.objAuthorize ) {

    if (typeof rootState.objAuthorize === 'string') {
      var objAuthorize = JSON.parse(rootState.objAuthorize);
      if (typeof objAuthorize === 'object' && objAuthorize !== null) {
        payload.user = objAuthorize.id
      }
    }

  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateDate', {params: payload}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {

    }).then(data => {
    if (!payload.hasOwnProperty('is_date_picker_response')) {
      if (data == true) {
        var snackDetails = {color: 'success', message: 'The date has been updated successfully', display: true};

      } else {
        var snackDetails = {color: 'error', message: 'There was an error updating the date', display: true};
      }
      commit('setSnack', snackDetails);
    } else {
      let newMessage = false
      if (data == true) {
        newMessage = true
      } else {
        newMessage = false
      }

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('fncSaveInstallationDAte', newMessage);
          resolve(); // Resolve the Promise to indicate successful action
        }, 1000); // Delay for demonstration purposes (1 second)
      });


    }

  });
}

export const fncFullContent = ({commit, dispatch, state, rootState}, payload)  => {

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuoteContentLite', { params: payload }, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    commit('fncSetQuoteSingle', data);
    commit('fncSetQuoteLiteContentLoaded', true);

  });
};

export const fncGetLiteStatus = ({commit, dispatch, state, rootState}, payload)  => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  payload.data.auth = objAuth;

  if( payload.list != undefined ) {

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuoteContentLite', { params: payload }, rootState.headerDetails)

      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {

        data.auth = objAuth;

        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuoteLiteStatuses', { data: data }, rootState.headerDetails)

          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(d => {

          var newPayload = data;

          var modalDetails = { title: 'Quote Status Update (' + newPayload.quote.quote_no + ')', component: 'modal-quote-status-update-lite', mstate: true, params: {currentStatus: newPayload.quote.quoteStatus, quoteId: newPayload.quote.id, currentStatusStatic: newPayload.quote.quoteStatus, object: newPayload.quote, statusList: d, quoteTotal: newPayload.quote.totalFullPrice } };
          commit({
            type: 'setModal',
            details: modalDetails
          });

        });

    });

  } else {

    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuoteLiteStatuses', payload, rootState.headerDetails)

      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {

      var modalDetails = { title: 'Quote Status Update (' + payload.data.quote.quote_no + ')', component: 'modal-quote-status-update-lite', mstate: true, params: {currentStatus: payload.data.quote.quoteStatus, quoteId: payload.data.quote.id, currentStatusStatic: payload.data.quote.quoteStatus, object: payload.data.quote, statusList: data, quoteTotal: payload.data.quote.totalFullPrice } };
      commit({
        type: 'setModal',
        details: modalDetails
      });

    });
  }

};

export const fncPopulateLinkedUsersLite = ({commit, dispatch, state, rootState}, payload)  => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuoteLinkedUser', { quote: payload.quote, manufacturer: objAuth.manufacturer }, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit('fncSetQuoteRepsLite', data);

  });
};

export const fncUpdateLead = ({commit, dispatch, state, rootState}, payload)  => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateLead', { quote: payload.id, manufacturer: objAuth.manufacturer, lead: payload.lead }, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      console.log('Data');
      console.log( data );

    //commit('fncSetQuoteRepsLite', data);

  });
};

export const fncLiteColumns = ({commit, dispatch, state, rootState}, payload)  => {

  commit('fncEmptyLiteColumns', []);

  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getLiteColumns', { user: objAuth.id }, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit({
        type: 'fncSetLiteColumns',
        data: data,
        manufacturer: objAuth.manufacturer
      });

      //commit('fncSetLiteColumns', { data: data, manufacturer: objAuth.manufacturer );

  });
};

export const fncResetColumnsLite = ({ commit, dispatch, state, rootState }, payload) => {

  if( payload.noSort != null ) {

    var quoteSettings = state.liteColumns;
    if( payload.newSettings.length > 0 ) {
      quoteSettings = payload.newSettings;
    }

    commit('fncSetColumnsSorted', true);

    var objAuth = JSON.parse(rootState.objAuthorize);
    var newSettings = [];
    var newOrder = 1;
    for( var s in quoteSettings ) {
      var p = quoteSettings[s];
      p.order = newOrder;
      newSettings.push(p);
      newOrder++;
    }

    var checkedColumns = [];
    var uncheckedColumns = [];

    for( var n in newSettings ) {
      if( newSettings[n].checked == 'false' || newSettings[n].checked == false ) {
        uncheckedColumns.push( newSettings[n] );
      } else {
        checkedColumns.push( newSettings[n] );
      }
    }

    var finalSettings = [];
    var newOrder = 1;
    for( var c in checkedColumns ) {
      checkedColumns[c].order = newOrder;
      finalSettings.push(checkedColumns[c]);
      newOrder++;
    }
    for( var c in uncheckedColumns ) {
      uncheckedColumns[c].order = newOrder;
      finalSettings.push(uncheckedColumns[c]);
      newOrder++;
    }

    commit('setQuoteSettingsLite', finalSettings);

    // Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', quote_details, rootState.headerDetails)

    var columnsDetails = { a: 'save_report_settings_lite', id: objAuth.id, settings: JSON.stringify(newSettings) };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', columnsDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote columns', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      commit('fncSetColumns', finalSettings);
    });
  } else if( payload.splice == null ) {
    var objAuth = JSON.parse(rootState.objAuthorize);

    state.liteColumns.splice(payload.end, 0, state.objQuoteSettings.splice(payload.start, 1)[0]);

    var newSettings = [];
    var newOrder = 1;
    for( var s in state.liteColumns ) {
      var p = state.liteColumns[s];
      p.order = newOrder;
      newSettings.push(p);
      newOrder++;
    }

    var checkedColumns = [];
    var uncheckedColumns = [];

    for( var n in newSettings ) {
      if( newSettings[n].checked == 'false' || newSettings[n].checked == false ) {
        uncheckedColumns.push( newSettings[n] );
      } else {
        checkedColumns.push( newSettings[n] );
      }
    }

    var finalSettings = [];
    var newOrder = 1;
    for( var c in checkedColumns ) {
      checkedColumns[c].order = newOrder;
      finalSettings.push(checkedColumns[c]);
      newOrder++;
    }
    for( var c in uncheckedColumns ) {
      uncheckedColumns[c].order = newOrder;
      finalSettings.push(uncheckedColumns[c]);
      newOrder++;
    }

    commit('setQuoteSettingsLite', finalSettings);
    var columnsDetails = { a: 'save_report_settings_lite', id: objAuth.id, settings: JSON.stringify(newSettings) };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', columnsDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error occured while trying to update the quote columns', display: true };
        commit('setSnack', snackDetails);
      }).then(data => {
      commit('fncSetColumns', finalSettings);
    });
  } else {
    /*dispatch({
      type: 'fncPopulateQuoteList',
      refresh: true
    });*/
    var snackDetails = { color: 'success', message: 'The report columns have been updated successfully', display: true };
    commit('setSnack', snackDetails);
    commit('hideModal');
    setTimeout(function(){
      location.reload();
    }, 1000)
  }

}

export const fncGetRoleData = ({commit, dispatch, state, rootState}, payload)  => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getRoleData', { manufacturer: objAuth.manufacturer }, rootState.headerDetails)

    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

     //commit('fncSetLiteColumns', data);

  });
};

export const fncPopulateStatusListEdit = ({ commit, dispatch, state, rootState }, payload) => {
  // if (state.statusList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true ))) {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var statusDetails = {
    a: 'get_quote_status',
    manufacturer: objAuth.manufacturer,
    user: objAuth.id
  };
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', { params: statusDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured retrieving the Status list', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
    for (var n = 0; n < data.length; n++) {
      data[n].text = data.description;
      data[n].order = parseInt(n) + 1;
    }
    commit({
      type: 'setObjStatusEdit',
      id: payload.id,
      data: data
    });
    var modalDetails = { title: 'Edit Status - ' + payload.name, component: 'modal-status-edit', mstate: true, params: {statusId: payload.id, statusName: payload.name, hasCheckedOut: payload.hasCheckedOut, hasCheckedOutText: payload.hasCheckedOutText} };
    commit({
      type: 'setModal',
      details: modalDetails
    });
    // data
  });
  // }
};

export const fncQuoteReportLiteExcel = ({commit, dispatch, state, rootState}, payload)  => {

  if( !payload ) {
    payload = [];
  }

  var objAuth = JSON.parse(rootState.objAuthorize);

  var details = {manufacturer: objAuth.manufacturer, user: objAuth.id}

  // && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' )

  if( payload.status && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.status.indexOf('all');
    if (index !== -1) {
      payload.status.splice(index, 1);
    }

    if( payload.status.length != 0 ) {
      details['status'] = payload.status;
    }

  }

  if( payload.department && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.department.indexOf('all');
    if (index !== -1) {
      payload.department.splice(index, 1);
    }

    if( payload.department.length != 0 ) {
      details['department'] = payload.department;
    }

  }

  if( payload.store && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.store.indexOf('all');
    if (index !== -1) {
      payload.store.splice(index, 1);
    }

    if( payload.store.length != 0 ) {
      details['store'] = payload.store;
    }

  }

  if( payload.customer && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.customer.indexOf('all');
    if (index !== -1) {
      payload.customer.splice(index, 1);
    }

    if( payload.customer.length != 0 ) {
      details['customer'] = payload.customer;
    }

  }

  if( payload.vendor && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.vendor.indexOf('all');
    if (index !== -1) {
      payload.vendor.splice(index, 1);
    }

    if( payload.vendor.length != 0 ) {
      details['vendor'] = payload.vendor;
    }

  }

  if( payload.company && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.company.indexOf('all');
    if (index !== -1) {
      payload.company.splice(index, 1);
    }

    if( payload.company.length != 0 ) {
      details['company'] = payload.company;
    }

  }

  if( payload.originator && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.originator.indexOf('all');
    if (index !== -1) {
      payload.originator.splice(index, 1);
    }

    if( payload.originator.length != 0 ) {
      details['originator'] = payload.originator;
    }

  }

  if( payload.project && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.project.indexOf('all');
    if (index !== -1) {
      payload.project.splice(index, 1);
    }

    if( payload.project.length != 0 ) {
      details['project'] = payload.store;
    }

  }

  if( payload.service_type && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.service_type.indexOf('all');
    if (index !== -1) {
      payload.service_type.splice(index, 1);
    }

    if( payload.service_type.length != 0 ) {
      details['service_type'] = payload.service_type;
    }

  }

  if( payload.linked_user && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.linked_user.indexOf('all');
    if (index !== -1) {
      payload.linked_user.splice(index, 1);
    }

    if( payload.linked_user.length != 0 ) {
      details['linked_user'] = payload.linked_user;
    }

  }

  if( payload.location && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    var index = payload.location.indexOf('all');
    if (index !== -1) {
      payload.location.splice(index, 1);
    }

    if( payload.location.length != 0 ) {
      details['location'] = payload.location;
    }

  }

  if( payload.customer_telephone && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {

    if( payload.customer_telephone != '' ) {
      details['customer_telephone'] = payload.customer_telephone;
    }

  }

  if( payload.startDate && payload.startDate != undefined && payload.startDate != 'undefined ' && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {
    details['startDate'] = payload.startDate;
  }

  if( payload.endDate && payload.endDate != 'undefined' && ( window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' || window.localStorage.reportSearch == '' ) ) {
    details['endDate'] = payload.endDate;
  }

  if (window.localStorage.reportSearch != null && window.localStorage.reportSearch != 'undefined' && window.localStorage.reportSearch != '') {
    details['search'] = window.localStorage.reportSearch;
  }

  if( details['startDate'] == 'undefined' ) {
    delete details['startDate'];
  }

  details['excel'] = true;

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuotesLite', details, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      if (data.success && data.file) {
        const link = document.createElement('a');
        link.href = data.file;
        link.download = 'export.csv'; // You can customize the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        commit('fncExcelLoading', false);

      } else {
        alert('Failed to generate file');
      }

    /*commit('fncSetQuotesLite', data);
    commit('fncSetQuoteLiteLoaded', true);*/

  });
}
